/*! For license information please see activitypub-visualization.js.LICENSE.txt */
!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t(require("react")) : "function" == typeof define && define.amd ? define(["react"], t) : "object" == typeof exports ? exports.activity_pub_visualization = t(require("react")) : e.activity_pub_visualization = t(e.react);
}(self, e => (() => {
  var t = {
      386: (e, t, r) => {
        !function (e) {
          function t(e) {
            e.state.placeholder && (e.state.placeholder.parentNode.removeChild(e.state.placeholder), e.state.placeholder = null);
          }
          function r(e) {
            t(e);
            var r = e.state.placeholder = document.createElement("pre");
            r.style.cssText = "height: 0; overflow: visible", r.style.direction = e.getOption("direction"), r.className = "CodeMirror-placeholder CodeMirror-line-like";
            var n = e.getOption("placeholder");
            "string" == typeof n && (n = document.createTextNode(n)), r.appendChild(n), e.display.lineSpace.insertBefore(r, e.display.lineSpace.firstChild);
          }
          function n(e) {
            o(e) && r(e);
          }
          function i(e) {
            var n = e.getWrapperElement(),
              i = o(e);
            n.className = n.className.replace(" CodeMirror-empty", "") + (i ? " CodeMirror-empty" : ""), i ? r(e) : t(e);
          }
          function o(e) {
            return 1 === e.lineCount() && "" === e.getLine(0);
          }
          e.defineOption("placeholder", "", function (o, a, l) {
            var s = l && l != e.Init;
            if (a && !s) o.on("blur", n), o.on("change", i), o.on("swapDoc", i), e.on(o.getInputField(), "compositionupdate", o.state.placeholderCompose = function () {
              !function (e) {
                setTimeout(function () {
                  var n = !1;
                  if (1 == e.lineCount()) {
                    var i = e.getInputField();
                    n = "TEXTAREA" == i.nodeName ? !e.getLine(0).length : !/[^\u200b]/.test(i.querySelector(".CodeMirror-line").textContent);
                  }
                  n ? r(e) : t(e);
                }, 20);
              }(o);
            }), i(o);else if (!a && s) {
              o.off("blur", n), o.off("change", i), o.off("swapDoc", i), e.off(o.getInputField(), "compositionupdate", o.state.placeholderCompose), t(o);
              var c = o.getWrapperElement();
              c.className = c.className.replace(" CodeMirror-empty", "");
            }
            a && !o.hasFocus() && n(o);
          });
        }(r(631));
      },
      631: function (e) {
        e.exports = function () {
          "use strict";

          var e = navigator.userAgent,
            t = navigator.platform,
            r = /gecko\/\d/i.test(e),
            n = /MSIE \d/.test(e),
            i = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(e),
            o = /Edge\/(\d+)/.exec(e),
            a = n || i || o,
            l = a && (n ? document.documentMode || 6 : +(o || i)[1]),
            s = !o && /WebKit\//.test(e),
            c = s && /Qt\/\d+\.\d+/.test(e),
            u = !o && /Chrome\//.test(e),
            d = /Opera\//.test(e),
            f = /Apple Computer/.test(navigator.vendor),
            h = /Mac OS X 1\d\D([8-9]|\d\d)\D/.test(e),
            p = /PhantomJS/.test(e),
            m = f && (/Mobile\/\w+/.test(e) || navigator.maxTouchPoints > 2),
            g = /Android/.test(e),
            v = m || g || /webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(e),
            y = m || /Mac/.test(t),
            b = /\bCrOS\b/.test(e),
            x = /win/i.test(t),
            w = d && e.match(/Version\/(\d*\.\d*)/);
          w && (w = Number(w[1])), w && w >= 15 && (d = !1, s = !0);
          var k = y && (c || d && (null == w || w < 12.11)),
            C = r || a && l >= 9;
          function S(e) {
            return new RegExp("(^|\\s)" + e + "(?:$|\\s)\\s*");
          }
          var T,
            L = function (e, t) {
              var r = e.className,
                n = S(t).exec(r);
              if (n) {
                var i = r.slice(n.index + n[0].length);
                e.className = r.slice(0, n.index) + (i ? n[1] + i : "");
              }
            };
          function N(e) {
            for (var t = e.childNodes.length; t > 0; --t) e.removeChild(e.firstChild);
            return e;
          }
          function E(e, t) {
            return N(e).appendChild(t);
          }
          function M(e, t, r, n) {
            var i = document.createElement(e);
            if (r && (i.className = r), n && (i.style.cssText = n), "string" == typeof t) i.appendChild(document.createTextNode(t));else if (t) for (var o = 0; o < t.length; ++o) i.appendChild(t[o]);
            return i;
          }
          function A(e, t, r, n) {
            var i = M(e, t, r, n);
            return i.setAttribute("role", "presentation"), i;
          }
          function O(e, t) {
            if (3 == t.nodeType && (t = t.parentNode), e.contains) return e.contains(t);
            do {
              if (11 == t.nodeType && (t = t.host), t == e) return !0;
            } while (t = t.parentNode);
          }
          function D() {
            var e;
            try {
              e = document.activeElement;
            } catch (t) {
              e = document.body || null;
            }
            for (; e && e.shadowRoot && e.shadowRoot.activeElement;) e = e.shadowRoot.activeElement;
            return e;
          }
          function R(e, t) {
            var r = e.className;
            S(t).test(r) || (e.className += (r ? " " : "") + t);
          }
          function W(e, t) {
            for (var r = e.split(" "), n = 0; n < r.length; n++) r[n] && !S(r[n]).test(t) && (t += " " + r[n]);
            return t;
          }
          T = document.createRange ? function (e, t, r, n) {
            var i = document.createRange();
            return i.setEnd(n || e, r), i.setStart(e, t), i;
          } : function (e, t, r) {
            var n = document.body.createTextRange();
            try {
              n.moveToElementText(e.parentNode);
            } catch (e) {
              return n;
            }
            return n.collapse(!0), n.moveEnd("character", r), n.moveStart("character", t), n;
          };
          var I = function (e) {
            e.select();
          };
          function P(e) {
            var t = Array.prototype.slice.call(arguments, 1);
            return function () {
              return e.apply(null, t);
            };
          }
          function H(e, t, r) {
            for (var n in t || (t = {}), e) !e.hasOwnProperty(n) || !1 === r && t.hasOwnProperty(n) || (t[n] = e[n]);
            return t;
          }
          function F(e, t, r, n, i) {
            null == t && -1 == (t = e.search(/[^\s\u00a0]/)) && (t = e.length);
            for (var o = n || 0, a = i || 0;;) {
              var l = e.indexOf("\t", o);
              if (l < 0 || l >= t) return a + (t - o);
              a += l - o, a += r - a % r, o = l + 1;
            }
          }
          m ? I = function (e) {
            e.selectionStart = 0, e.selectionEnd = e.value.length;
          } : a && (I = function (e) {
            try {
              e.select();
            } catch (e) {}
          });
          var z = function () {
            this.id = null, this.f = null, this.time = 0, this.handler = P(this.onTimeout, this);
          };
          function _(e, t) {
            for (var r = 0; r < e.length; ++r) if (e[r] == t) return r;
            return -1;
          }
          z.prototype.onTimeout = function (e) {
            e.id = 0, e.time <= +new Date() ? e.f() : setTimeout(e.handler, e.time - +new Date());
          }, z.prototype.set = function (e, t) {
            this.f = t;
            var r = +new Date() + e;
            (!this.id || r < this.time) && (clearTimeout(this.id), this.id = setTimeout(this.handler, e), this.time = r);
          };
          var B = {
              toString: function () {
                return "CodeMirror.Pass";
              }
            },
            j = {
              scroll: !1
            },
            U = {
              origin: "*mouse"
            },
            G = {
              origin: "+move"
            };
          function V(e, t, r) {
            for (var n = 0, i = 0;;) {
              var o = e.indexOf("\t", n);
              -1 == o && (o = e.length);
              var a = o - n;
              if (o == e.length || i + a >= t) return n + Math.min(a, t - i);
              if (i += o - n, n = o + 1, (i += r - i % r) >= t) return n;
            }
          }
          var K = [""];
          function Y(e) {
            for (; K.length <= e;) K.push(X(K) + " ");
            return K[e];
          }
          function X(e) {
            return e[e.length - 1];
          }
          function q(e, t) {
            for (var r = [], n = 0; n < e.length; n++) r[n] = t(e[n], n);
            return r;
          }
          function $() {}
          function J(e, t) {
            var r;
            return Object.create ? r = Object.create(e) : ($.prototype = e, r = new $()), t && H(t, r), r;
          }
          var Z = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
          function Q(e) {
            return /\w/.test(e) || e > "" && (e.toUpperCase() != e.toLowerCase() || Z.test(e));
          }
          function ee(e, t) {
            return t ? !!(t.source.indexOf("\\w") > -1 && Q(e)) || t.test(e) : Q(e);
          }
          function te(e) {
            for (var t in e) if (e.hasOwnProperty(t) && e[t]) return !1;
            return !0;
          }
          var re = /[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065e\u0670\u06d6-\u06dc\u06de-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0900-\u0902\u093c\u0941-\u0948\u094d\u0951-\u0955\u0962\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2\u09e3\u0a01\u0a02\u0a3c\u0a41\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81\u0a82\u0abc\u0ac1-\u0ac5\u0ac7\u0ac8\u0acd\u0ae2\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86\u0f87\u0f90-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039\u103a\u103d\u103e\u1058\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085\u1086\u108d\u109d\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193b\u1a17\u1a18\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80\u1b81\u1ba2-\u1ba5\u1ba8\u1ba9\u1c2c-\u1c33\u1c36\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1dc0-\u1de6\u1dfd-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\ua672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua825\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\uaa29-\uaa2e\uaa31\uaa32\uaa35\uaa36\uaa43\uaa4c\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe5\uabe8\uabed\udc00-\udfff\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]/;
          function ne(e) {
            return e.charCodeAt(0) >= 768 && re.test(e);
          }
          function ie(e, t, r) {
            for (; (r < 0 ? t > 0 : t < e.length) && ne(e.charAt(t));) t += r;
            return t;
          }
          function oe(e, t, r) {
            for (var n = t > r ? -1 : 1;;) {
              if (t == r) return t;
              var i = (t + r) / 2,
                o = n < 0 ? Math.ceil(i) : Math.floor(i);
              if (o == t) return e(o) ? t : r;
              e(o) ? r = o : t = o + n;
            }
          }
          var ae = null;
          function le(e, t, r) {
            var n;
            ae = null;
            for (var i = 0; i < e.length; ++i) {
              var o = e[i];
              if (o.from < t && o.to > t) return i;
              o.to == t && (o.from != o.to && "before" == r ? n = i : ae = i), o.from == t && (o.from != o.to && "before" != r ? n = i : ae = i);
            }
            return null != n ? n : ae;
          }
          var se = function () {
            var e = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/,
              t = /[stwN]/,
              r = /[LRr]/,
              n = /[Lb1n]/,
              i = /[1n]/;
            function o(e, t, r) {
              this.level = e, this.from = t, this.to = r;
            }
            return function (a, l) {
              var s,
                c = "ltr" == l ? "L" : "R";
              if (0 == a.length || "ltr" == l && !e.test(a)) return !1;
              for (var u = a.length, d = [], f = 0; f < u; ++f) d.push((s = a.charCodeAt(f)) <= 247 ? "bbbbbbbbbtstwsbbbbbbbbbbbbbbssstwNN%%%NNNNNN,N,N1111111111NNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNbbbbbbsbbbbbbbbbbbbbbbbbbbbbbbbbb,N%%%%NNNNLNNNNN%%11NLNNN1LNNNNNLLLLLLLLLLLLLLLLLLLLLLLNLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLN".charAt(s) : 1424 <= s && s <= 1524 ? "R" : 1536 <= s && s <= 1785 ? "nnnnnnNNr%%r,rNNmmmmmmmmmmmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmmmmmmmmnnnnnnnnnn%nnrrrmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmnNmmmmmmrrmmNmmmmrr1111111111".charAt(s - 1536) : 1774 <= s && s <= 2220 ? "r" : 8192 <= s && s <= 8203 ? "w" : 8204 == s ? "b" : "L");
              for (var h = 0, p = c; h < u; ++h) {
                var m = d[h];
                "m" == m ? d[h] = p : p = m;
              }
              for (var g = 0, v = c; g < u; ++g) {
                var y = d[g];
                "1" == y && "r" == v ? d[g] = "n" : r.test(y) && (v = y, "r" == y && (d[g] = "R"));
              }
              for (var b = 1, x = d[0]; b < u - 1; ++b) {
                var w = d[b];
                "+" == w && "1" == x && "1" == d[b + 1] ? d[b] = "1" : "," != w || x != d[b + 1] || "1" != x && "n" != x || (d[b] = x), x = w;
              }
              for (var k = 0; k < u; ++k) {
                var C = d[k];
                if ("," == C) d[k] = "N";else if ("%" == C) {
                  var S = void 0;
                  for (S = k + 1; S < u && "%" == d[S]; ++S);
                  for (var T = k && "!" == d[k - 1] || S < u && "1" == d[S] ? "1" : "N", L = k; L < S; ++L) d[L] = T;
                  k = S - 1;
                }
              }
              for (var N = 0, E = c; N < u; ++N) {
                var M = d[N];
                "L" == E && "1" == M ? d[N] = "L" : r.test(M) && (E = M);
              }
              for (var A = 0; A < u; ++A) if (t.test(d[A])) {
                var O = void 0;
                for (O = A + 1; O < u && t.test(d[O]); ++O);
                for (var D = "L" == (A ? d[A - 1] : c), R = D == ("L" == (O < u ? d[O] : c)) ? D ? "L" : "R" : c, W = A; W < O; ++W) d[W] = R;
                A = O - 1;
              }
              for (var I, P = [], H = 0; H < u;) if (n.test(d[H])) {
                var F = H;
                for (++H; H < u && n.test(d[H]); ++H);
                P.push(new o(0, F, H));
              } else {
                var z = H,
                  _ = P.length,
                  B = "rtl" == l ? 1 : 0;
                for (++H; H < u && "L" != d[H]; ++H);
                for (var j = z; j < H;) if (i.test(d[j])) {
                  z < j && (P.splice(_, 0, new o(1, z, j)), _ += B);
                  var U = j;
                  for (++j; j < H && i.test(d[j]); ++j);
                  P.splice(_, 0, new o(2, U, j)), _ += B, z = j;
                } else ++j;
                z < H && P.splice(_, 0, new o(1, z, H));
              }
              return "ltr" == l && (1 == P[0].level && (I = a.match(/^\s+/)) && (P[0].from = I[0].length, P.unshift(new o(0, 0, I[0].length))), 1 == X(P).level && (I = a.match(/\s+$/)) && (X(P).to -= I[0].length, P.push(new o(0, u - I[0].length, u)))), "rtl" == l ? P.reverse() : P;
            };
          }();
          function ce(e, t) {
            var r = e.order;
            return null == r && (r = e.order = se(e.text, t)), r;
          }
          var ue = [],
            de = function (e, t, r) {
              if (e.addEventListener) e.addEventListener(t, r, !1);else if (e.attachEvent) e.attachEvent("on" + t, r);else {
                var n = e._handlers || (e._handlers = {});
                n[t] = (n[t] || ue).concat(r);
              }
            };
          function fe(e, t) {
            return e._handlers && e._handlers[t] || ue;
          }
          function he(e, t, r) {
            if (e.removeEventListener) e.removeEventListener(t, r, !1);else if (e.detachEvent) e.detachEvent("on" + t, r);else {
              var n = e._handlers,
                i = n && n[t];
              if (i) {
                var o = _(i, r);
                o > -1 && (n[t] = i.slice(0, o).concat(i.slice(o + 1)));
              }
            }
          }
          function pe(e, t) {
            var r = fe(e, t);
            if (r.length) for (var n = Array.prototype.slice.call(arguments, 2), i = 0; i < r.length; ++i) r[i].apply(null, n);
          }
          function me(e, t, r) {
            return "string" == typeof t && (t = {
              type: t,
              preventDefault: function () {
                this.defaultPrevented = !0;
              }
            }), pe(e, r || t.type, e, t), we(t) || t.codemirrorIgnore;
          }
          function ge(e) {
            var t = e._handlers && e._handlers.cursorActivity;
            if (t) for (var r = e.curOp.cursorActivityHandlers || (e.curOp.cursorActivityHandlers = []), n = 0; n < t.length; ++n) -1 == _(r, t[n]) && r.push(t[n]);
          }
          function ve(e, t) {
            return fe(e, t).length > 0;
          }
          function ye(e) {
            e.prototype.on = function (e, t) {
              de(this, e, t);
            }, e.prototype.off = function (e, t) {
              he(this, e, t);
            };
          }
          function be(e) {
            e.preventDefault ? e.preventDefault() : e.returnValue = !1;
          }
          function xe(e) {
            e.stopPropagation ? e.stopPropagation() : e.cancelBubble = !0;
          }
          function we(e) {
            return null != e.defaultPrevented ? e.defaultPrevented : 0 == e.returnValue;
          }
          function ke(e) {
            be(e), xe(e);
          }
          function Ce(e) {
            return e.target || e.srcElement;
          }
          function Se(e) {
            var t = e.which;
            return null == t && (1 & e.button ? t = 1 : 2 & e.button ? t = 3 : 4 & e.button && (t = 2)), y && e.ctrlKey && 1 == t && (t = 3), t;
          }
          var Te,
            Le,
            Ne = function () {
              if (a && l < 9) return !1;
              var e = M("div");
              return "draggable" in e || "dragDrop" in e;
            }();
          function Ee(e) {
            if (null == Te) {
              var t = M("span", "​");
              E(e, M("span", [t, document.createTextNode("x")])), 0 != e.firstChild.offsetHeight && (Te = t.offsetWidth <= 1 && t.offsetHeight > 2 && !(a && l < 8));
            }
            var r = Te ? M("span", "​") : M("span", " ", null, "display: inline-block; width: 1px; margin-right: -1px");
            return r.setAttribute("cm-text", ""), r;
          }
          function Me(e) {
            if (null != Le) return Le;
            var t = E(e, document.createTextNode("AخA")),
              r = T(t, 0, 1).getBoundingClientRect(),
              n = T(t, 1, 2).getBoundingClientRect();
            return N(e), !(!r || r.left == r.right) && (Le = n.right - r.right < 3);
          }
          var Ae,
            Oe = 3 != "\n\nb".split(/\n/).length ? function (e) {
              for (var t = 0, r = [], n = e.length; t <= n;) {
                var i = e.indexOf("\n", t);
                -1 == i && (i = e.length);
                var o = e.slice(t, "\r" == e.charAt(i - 1) ? i - 1 : i),
                  a = o.indexOf("\r");
                -1 != a ? (r.push(o.slice(0, a)), t += a + 1) : (r.push(o), t = i + 1);
              }
              return r;
            } : function (e) {
              return e.split(/\r\n?|\n/);
            },
            De = window.getSelection ? function (e) {
              try {
                return e.selectionStart != e.selectionEnd;
              } catch (e) {
                return !1;
              }
            } : function (e) {
              var t;
              try {
                t = e.ownerDocument.selection.createRange();
              } catch (e) {}
              return !(!t || t.parentElement() != e) && 0 != t.compareEndPoints("StartToEnd", t);
            },
            Re = "oncopy" in (Ae = M("div")) || (Ae.setAttribute("oncopy", "return;"), "function" == typeof Ae.oncopy),
            We = null;
          var Ie = {},
            Pe = {};
          function He(e, t) {
            arguments.length > 2 && (t.dependencies = Array.prototype.slice.call(arguments, 2)), Ie[e] = t;
          }
          function Fe(e) {
            if ("string" == typeof e && Pe.hasOwnProperty(e)) e = Pe[e];else if (e && "string" == typeof e.name && Pe.hasOwnProperty(e.name)) {
              var t = Pe[e.name];
              "string" == typeof t && (t = {
                name: t
              }), (e = J(t, e)).name = t.name;
            } else {
              if ("string" == typeof e && /^[\w\-]+\/[\w\-]+\+xml$/.test(e)) return Fe("application/xml");
              if ("string" == typeof e && /^[\w\-]+\/[\w\-]+\+json$/.test(e)) return Fe("application/json");
            }
            return "string" == typeof e ? {
              name: e
            } : e || {
              name: "null"
            };
          }
          function ze(e, t) {
            t = Fe(t);
            var r = Ie[t.name];
            if (!r) return ze(e, "text/plain");
            var n = r(e, t);
            if (_e.hasOwnProperty(t.name)) {
              var i = _e[t.name];
              for (var o in i) i.hasOwnProperty(o) && (n.hasOwnProperty(o) && (n["_" + o] = n[o]), n[o] = i[o]);
            }
            if (n.name = t.name, t.helperType && (n.helperType = t.helperType), t.modeProps) for (var a in t.modeProps) n[a] = t.modeProps[a];
            return n;
          }
          var _e = {};
          function Be(e, t) {
            H(t, _e.hasOwnProperty(e) ? _e[e] : _e[e] = {});
          }
          function je(e, t) {
            if (!0 === t) return t;
            if (e.copyState) return e.copyState(t);
            var r = {};
            for (var n in t) {
              var i = t[n];
              i instanceof Array && (i = i.concat([])), r[n] = i;
            }
            return r;
          }
          function Ue(e, t) {
            for (var r; e.innerMode && (r = e.innerMode(t)) && r.mode != e;) t = r.state, e = r.mode;
            return r || {
              mode: e,
              state: t
            };
          }
          function Ge(e, t, r) {
            return !e.startState || e.startState(t, r);
          }
          var Ve = function (e, t, r) {
            this.pos = this.start = 0, this.string = e, this.tabSize = t || 8, this.lastColumnPos = this.lastColumnValue = 0, this.lineStart = 0, this.lineOracle = r;
          };
          function Ke(e, t) {
            if ((t -= e.first) < 0 || t >= e.size) throw new Error("There is no line " + (t + e.first) + " in the document.");
            for (var r = e; !r.lines;) for (var n = 0;; ++n) {
              var i = r.children[n],
                o = i.chunkSize();
              if (t < o) {
                r = i;
                break;
              }
              t -= o;
            }
            return r.lines[t];
          }
          function Ye(e, t, r) {
            var n = [],
              i = t.line;
            return e.iter(t.line, r.line + 1, function (e) {
              var o = e.text;
              i == r.line && (o = o.slice(0, r.ch)), i == t.line && (o = o.slice(t.ch)), n.push(o), ++i;
            }), n;
          }
          function Xe(e, t, r) {
            var n = [];
            return e.iter(t, r, function (e) {
              n.push(e.text);
            }), n;
          }
          function qe(e, t) {
            var r = t - e.height;
            if (r) for (var n = e; n; n = n.parent) n.height += r;
          }
          function $e(e) {
            if (null == e.parent) return null;
            for (var t = e.parent, r = _(t.lines, e), n = t.parent; n; t = n, n = n.parent) for (var i = 0; n.children[i] != t; ++i) r += n.children[i].chunkSize();
            return r + t.first;
          }
          function Je(e, t) {
            var r = e.first;
            e: do {
              for (var n = 0; n < e.children.length; ++n) {
                var i = e.children[n],
                  o = i.height;
                if (t < o) {
                  e = i;
                  continue e;
                }
                t -= o, r += i.chunkSize();
              }
              return r;
            } while (!e.lines);
            for (var a = 0; a < e.lines.length; ++a) {
              var l = e.lines[a].height;
              if (t < l) break;
              t -= l;
            }
            return r + a;
          }
          function Ze(e, t) {
            return t >= e.first && t < e.first + e.size;
          }
          function Qe(e, t) {
            return String(e.lineNumberFormatter(t + e.firstLineNumber));
          }
          function et(e, t, r) {
            if (void 0 === r && (r = null), !(this instanceof et)) return new et(e, t, r);
            this.line = e, this.ch = t, this.sticky = r;
          }
          function tt(e, t) {
            return e.line - t.line || e.ch - t.ch;
          }
          function rt(e, t) {
            return e.sticky == t.sticky && 0 == tt(e, t);
          }
          function nt(e) {
            return et(e.line, e.ch);
          }
          function it(e, t) {
            return tt(e, t) < 0 ? t : e;
          }
          function ot(e, t) {
            return tt(e, t) < 0 ? e : t;
          }
          function at(e, t) {
            return Math.max(e.first, Math.min(t, e.first + e.size - 1));
          }
          function lt(e, t) {
            if (t.line < e.first) return et(e.first, 0);
            var r = e.first + e.size - 1;
            return t.line > r ? et(r, Ke(e, r).text.length) : function (e, t) {
              var r = e.ch;
              return null == r || r > t ? et(e.line, t) : r < 0 ? et(e.line, 0) : e;
            }(t, Ke(e, t.line).text.length);
          }
          function st(e, t) {
            for (var r = [], n = 0; n < t.length; n++) r[n] = lt(e, t[n]);
            return r;
          }
          Ve.prototype.eol = function () {
            return this.pos >= this.string.length;
          }, Ve.prototype.sol = function () {
            return this.pos == this.lineStart;
          }, Ve.prototype.peek = function () {
            return this.string.charAt(this.pos) || void 0;
          }, Ve.prototype.next = function () {
            if (this.pos < this.string.length) return this.string.charAt(this.pos++);
          }, Ve.prototype.eat = function (e) {
            var t = this.string.charAt(this.pos);
            if ("string" == typeof e ? t == e : t && (e.test ? e.test(t) : e(t))) return ++this.pos, t;
          }, Ve.prototype.eatWhile = function (e) {
            for (var t = this.pos; this.eat(e););
            return this.pos > t;
          }, Ve.prototype.eatSpace = function () {
            for (var e = this.pos; /[\s\u00a0]/.test(this.string.charAt(this.pos));) ++this.pos;
            return this.pos > e;
          }, Ve.prototype.skipToEnd = function () {
            this.pos = this.string.length;
          }, Ve.prototype.skipTo = function (e) {
            var t = this.string.indexOf(e, this.pos);
            if (t > -1) return this.pos = t, !0;
          }, Ve.prototype.backUp = function (e) {
            this.pos -= e;
          }, Ve.prototype.column = function () {
            return this.lastColumnPos < this.start && (this.lastColumnValue = F(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue), this.lastColumnPos = this.start), this.lastColumnValue - (this.lineStart ? F(this.string, this.lineStart, this.tabSize) : 0);
          }, Ve.prototype.indentation = function () {
            return F(this.string, null, this.tabSize) - (this.lineStart ? F(this.string, this.lineStart, this.tabSize) : 0);
          }, Ve.prototype.match = function (e, t, r) {
            if ("string" != typeof e) {
              var n = this.string.slice(this.pos).match(e);
              return n && n.index > 0 ? null : (n && !1 !== t && (this.pos += n[0].length), n);
            }
            var i = function (e) {
              return r ? e.toLowerCase() : e;
            };
            if (i(this.string.substr(this.pos, e.length)) == i(e)) return !1 !== t && (this.pos += e.length), !0;
          }, Ve.prototype.current = function () {
            return this.string.slice(this.start, this.pos);
          }, Ve.prototype.hideFirstChars = function (e, t) {
            this.lineStart += e;
            try {
              return t();
            } finally {
              this.lineStart -= e;
            }
          }, Ve.prototype.lookAhead = function (e) {
            var t = this.lineOracle;
            return t && t.lookAhead(e);
          }, Ve.prototype.baseToken = function () {
            var e = this.lineOracle;
            return e && e.baseToken(this.pos);
          };
          var ct = function (e, t) {
              this.state = e, this.lookAhead = t;
            },
            ut = function (e, t, r, n) {
              this.state = t, this.doc = e, this.line = r, this.maxLookAhead = n || 0, this.baseTokens = null, this.baseTokenPos = 1;
            };
          function dt(e, t, r, n) {
            var i = [e.state.modeGen],
              o = {};
            xt(e, t.text, e.doc.mode, r, function (e, t) {
              return i.push(e, t);
            }, o, n);
            for (var a = r.state, l = function (n) {
                r.baseTokens = i;
                var l = e.state.overlays[n],
                  s = 1,
                  c = 0;
                r.state = !0, xt(e, t.text, l.mode, r, function (e, t) {
                  for (var r = s; c < e;) {
                    var n = i[s];
                    n > e && i.splice(s, 1, e, i[s + 1], n), s += 2, c = Math.min(e, n);
                  }
                  if (t) if (l.opaque) i.splice(r, s - r, e, "overlay " + t), s = r + 2;else for (; r < s; r += 2) {
                    var o = i[r + 1];
                    i[r + 1] = (o ? o + " " : "") + "overlay " + t;
                  }
                }, o), r.state = a, r.baseTokens = null, r.baseTokenPos = 1;
              }, s = 0; s < e.state.overlays.length; ++s) l(s);
            return {
              styles: i,
              classes: o.bgClass || o.textClass ? o : null
            };
          }
          function ft(e, t, r) {
            if (!t.styles || t.styles[0] != e.state.modeGen) {
              var n = ht(e, $e(t)),
                i = t.text.length > e.options.maxHighlightLength && je(e.doc.mode, n.state),
                o = dt(e, t, n);
              i && (n.state = i), t.stateAfter = n.save(!i), t.styles = o.styles, o.classes ? t.styleClasses = o.classes : t.styleClasses && (t.styleClasses = null), r === e.doc.highlightFrontier && (e.doc.modeFrontier = Math.max(e.doc.modeFrontier, ++e.doc.highlightFrontier));
            }
            return t.styles;
          }
          function ht(e, t, r) {
            var n = e.doc,
              i = e.display;
            if (!n.mode.startState) return new ut(n, !0, t);
            var o = function (e, t, r) {
                for (var n, i, o = e.doc, a = r ? -1 : t - (e.doc.mode.innerMode ? 1e3 : 100), l = t; l > a; --l) {
                  if (l <= o.first) return o.first;
                  var s = Ke(o, l - 1),
                    c = s.stateAfter;
                  if (c && (!r || l + (c instanceof ct ? c.lookAhead : 0) <= o.modeFrontier)) return l;
                  var u = F(s.text, null, e.options.tabSize);
                  (null == i || n > u) && (i = l - 1, n = u);
                }
                return i;
              }(e, t, r),
              a = o > n.first && Ke(n, o - 1).stateAfter,
              l = a ? ut.fromSaved(n, a, o) : new ut(n, Ge(n.mode), o);
            return n.iter(o, t, function (r) {
              pt(e, r.text, l);
              var n = l.line;
              r.stateAfter = n == t - 1 || n % 5 == 0 || n >= i.viewFrom && n < i.viewTo ? l.save() : null, l.nextLine();
            }), r && (n.modeFrontier = l.line), l;
          }
          function pt(e, t, r, n) {
            var i = e.doc.mode,
              o = new Ve(t, e.options.tabSize, r);
            for (o.start = o.pos = n || 0, "" == t && mt(i, r.state); !o.eol();) gt(i, o, r.state), o.start = o.pos;
          }
          function mt(e, t) {
            if (e.blankLine) return e.blankLine(t);
            if (e.innerMode) {
              var r = Ue(e, t);
              return r.mode.blankLine ? r.mode.blankLine(r.state) : void 0;
            }
          }
          function gt(e, t, r, n) {
            for (var i = 0; i < 10; i++) {
              n && (n[0] = Ue(e, r).mode);
              var o = e.token(t, r);
              if (t.pos > t.start) return o;
            }
            throw new Error("Mode " + e.name + " failed to advance stream.");
          }
          ut.prototype.lookAhead = function (e) {
            var t = this.doc.getLine(this.line + e);
            return null != t && e > this.maxLookAhead && (this.maxLookAhead = e), t;
          }, ut.prototype.baseToken = function (e) {
            if (!this.baseTokens) return null;
            for (; this.baseTokens[this.baseTokenPos] <= e;) this.baseTokenPos += 2;
            var t = this.baseTokens[this.baseTokenPos + 1];
            return {
              type: t && t.replace(/( |^)overlay .*/, ""),
              size: this.baseTokens[this.baseTokenPos] - e
            };
          }, ut.prototype.nextLine = function () {
            this.line++, this.maxLookAhead > 0 && this.maxLookAhead--;
          }, ut.fromSaved = function (e, t, r) {
            return t instanceof ct ? new ut(e, je(e.mode, t.state), r, t.lookAhead) : new ut(e, je(e.mode, t), r);
          }, ut.prototype.save = function (e) {
            var t = !1 !== e ? je(this.doc.mode, this.state) : this.state;
            return this.maxLookAhead > 0 ? new ct(t, this.maxLookAhead) : t;
          };
          var vt = function (e, t, r) {
            this.start = e.start, this.end = e.pos, this.string = e.current(), this.type = t || null, this.state = r;
          };
          function yt(e, t, r, n) {
            var i,
              o,
              a = e.doc,
              l = a.mode,
              s = Ke(a, (t = lt(a, t)).line),
              c = ht(e, t.line, r),
              u = new Ve(s.text, e.options.tabSize, c);
            for (n && (o = []); (n || u.pos < t.ch) && !u.eol();) u.start = u.pos, i = gt(l, u, c.state), n && o.push(new vt(u, i, je(a.mode, c.state)));
            return n ? o : new vt(u, i, c.state);
          }
          function bt(e, t) {
            if (e) for (;;) {
              var r = e.match(/(?:^|\s+)line-(background-)?(\S+)/);
              if (!r) break;
              e = e.slice(0, r.index) + e.slice(r.index + r[0].length);
              var n = r[1] ? "bgClass" : "textClass";
              null == t[n] ? t[n] = r[2] : new RegExp("(?:^|\\s)" + r[2] + "(?:$|\\s)").test(t[n]) || (t[n] += " " + r[2]);
            }
            return e;
          }
          function xt(e, t, r, n, i, o, a) {
            var l = r.flattenSpans;
            null == l && (l = e.options.flattenSpans);
            var s,
              c = 0,
              u = null,
              d = new Ve(t, e.options.tabSize, n),
              f = e.options.addModeClass && [null];
            for ("" == t && bt(mt(r, n.state), o); !d.eol();) {
              if (d.pos > e.options.maxHighlightLength ? (l = !1, a && pt(e, t, n, d.pos), d.pos = t.length, s = null) : s = bt(gt(r, d, n.state, f), o), f) {
                var h = f[0].name;
                h && (s = "m-" + (s ? h + " " + s : h));
              }
              if (!l || u != s) {
                for (; c < d.start;) i(c = Math.min(d.start, c + 5e3), u);
                u = s;
              }
              d.start = d.pos;
            }
            for (; c < d.pos;) {
              var p = Math.min(d.pos, c + 5e3);
              i(p, u), c = p;
            }
          }
          var wt = !1,
            kt = !1;
          function Ct(e, t, r) {
            this.marker = e, this.from = t, this.to = r;
          }
          function St(e, t) {
            if (e) for (var r = 0; r < e.length; ++r) {
              var n = e[r];
              if (n.marker == t) return n;
            }
          }
          function Tt(e, t) {
            for (var r, n = 0; n < e.length; ++n) e[n] != t && (r || (r = [])).push(e[n]);
            return r;
          }
          function Lt(e, t) {
            if (t.full) return null;
            var r = Ze(e, t.from.line) && Ke(e, t.from.line).markedSpans,
              n = Ze(e, t.to.line) && Ke(e, t.to.line).markedSpans;
            if (!r && !n) return null;
            var i = t.from.ch,
              o = t.to.ch,
              a = 0 == tt(t.from, t.to),
              l = function (e, t, r) {
                var n;
                if (e) for (var i = 0; i < e.length; ++i) {
                  var o = e[i],
                    a = o.marker;
                  if (null == o.from || (a.inclusiveLeft ? o.from <= t : o.from < t) || o.from == t && "bookmark" == a.type && (!r || !o.marker.insertLeft)) {
                    var l = null == o.to || (a.inclusiveRight ? o.to >= t : o.to > t);
                    (n || (n = [])).push(new Ct(a, o.from, l ? null : o.to));
                  }
                }
                return n;
              }(r, i, a),
              s = function (e, t, r) {
                var n;
                if (e) for (var i = 0; i < e.length; ++i) {
                  var o = e[i],
                    a = o.marker;
                  if (null == o.to || (a.inclusiveRight ? o.to >= t : o.to > t) || o.from == t && "bookmark" == a.type && (!r || o.marker.insertLeft)) {
                    var l = null == o.from || (a.inclusiveLeft ? o.from <= t : o.from < t);
                    (n || (n = [])).push(new Ct(a, l ? null : o.from - t, null == o.to ? null : o.to - t));
                  }
                }
                return n;
              }(n, o, a),
              c = 1 == t.text.length,
              u = X(t.text).length + (c ? i : 0);
            if (l) for (var d = 0; d < l.length; ++d) {
              var f = l[d];
              if (null == f.to) {
                var h = St(s, f.marker);
                h ? c && (f.to = null == h.to ? null : h.to + u) : f.to = i;
              }
            }
            if (s) for (var p = 0; p < s.length; ++p) {
              var m = s[p];
              null != m.to && (m.to += u), null == m.from ? St(l, m.marker) || (m.from = u, c && (l || (l = [])).push(m)) : (m.from += u, c && (l || (l = [])).push(m));
            }
            l && (l = Nt(l)), s && s != l && (s = Nt(s));
            var g = [l];
            if (!c) {
              var v,
                y = t.text.length - 2;
              if (y > 0 && l) for (var b = 0; b < l.length; ++b) null == l[b].to && (v || (v = [])).push(new Ct(l[b].marker, null, null));
              for (var x = 0; x < y; ++x) g.push(v);
              g.push(s);
            }
            return g;
          }
          function Nt(e) {
            for (var t = 0; t < e.length; ++t) {
              var r = e[t];
              null != r.from && r.from == r.to && !1 !== r.marker.clearWhenEmpty && e.splice(t--, 1);
            }
            return e.length ? e : null;
          }
          function Et(e) {
            var t = e.markedSpans;
            if (t) {
              for (var r = 0; r < t.length; ++r) t[r].marker.detachLine(e);
              e.markedSpans = null;
            }
          }
          function Mt(e, t) {
            if (t) {
              for (var r = 0; r < t.length; ++r) t[r].marker.attachLine(e);
              e.markedSpans = t;
            }
          }
          function At(e) {
            return e.inclusiveLeft ? -1 : 0;
          }
          function Ot(e) {
            return e.inclusiveRight ? 1 : 0;
          }
          function Dt(e, t) {
            var r = e.lines.length - t.lines.length;
            if (0 != r) return r;
            var n = e.find(),
              i = t.find(),
              o = tt(n.from, i.from) || At(e) - At(t);
            return o ? -o : tt(n.to, i.to) || Ot(e) - Ot(t) || t.id - e.id;
          }
          function Rt(e, t) {
            var r,
              n = kt && e.markedSpans;
            if (n) for (var i = void 0, o = 0; o < n.length; ++o) (i = n[o]).marker.collapsed && null == (t ? i.from : i.to) && (!r || Dt(r, i.marker) < 0) && (r = i.marker);
            return r;
          }
          function Wt(e) {
            return Rt(e, !0);
          }
          function It(e) {
            return Rt(e, !1);
          }
          function Pt(e, t) {
            var r,
              n = kt && e.markedSpans;
            if (n) for (var i = 0; i < n.length; ++i) {
              var o = n[i];
              o.marker.collapsed && (null == o.from || o.from < t) && (null == o.to || o.to > t) && (!r || Dt(r, o.marker) < 0) && (r = o.marker);
            }
            return r;
          }
          function Ht(e, t, r, n, i) {
            var o = Ke(e, t),
              a = kt && o.markedSpans;
            if (a) for (var l = 0; l < a.length; ++l) {
              var s = a[l];
              if (s.marker.collapsed) {
                var c = s.marker.find(0),
                  u = tt(c.from, r) || At(s.marker) - At(i),
                  d = tt(c.to, n) || Ot(s.marker) - Ot(i);
                if (!(u >= 0 && d <= 0 || u <= 0 && d >= 0) && (u <= 0 && (s.marker.inclusiveRight && i.inclusiveLeft ? tt(c.to, r) >= 0 : tt(c.to, r) > 0) || u >= 0 && (s.marker.inclusiveRight && i.inclusiveLeft ? tt(c.from, n) <= 0 : tt(c.from, n) < 0))) return !0;
              }
            }
          }
          function Ft(e) {
            for (var t; t = Wt(e);) e = t.find(-1, !0).line;
            return e;
          }
          function zt(e, t) {
            var r = Ke(e, t),
              n = Ft(r);
            return r == n ? t : $e(n);
          }
          function _t(e, t) {
            if (t > e.lastLine()) return t;
            var r,
              n = Ke(e, t);
            if (!Bt(e, n)) return t;
            for (; r = It(n);) n = r.find(1, !0).line;
            return $e(n) + 1;
          }
          function Bt(e, t) {
            var r = kt && t.markedSpans;
            if (r) for (var n = void 0, i = 0; i < r.length; ++i) if ((n = r[i]).marker.collapsed) {
              if (null == n.from) return !0;
              if (!n.marker.widgetNode && 0 == n.from && n.marker.inclusiveLeft && jt(e, t, n)) return !0;
            }
          }
          function jt(e, t, r) {
            if (null == r.to) {
              var n = r.marker.find(1, !0);
              return jt(e, n.line, St(n.line.markedSpans, r.marker));
            }
            if (r.marker.inclusiveRight && r.to == t.text.length) return !0;
            for (var i = void 0, o = 0; o < t.markedSpans.length; ++o) if ((i = t.markedSpans[o]).marker.collapsed && !i.marker.widgetNode && i.from == r.to && (null == i.to || i.to != r.from) && (i.marker.inclusiveLeft || r.marker.inclusiveRight) && jt(e, t, i)) return !0;
          }
          function Ut(e) {
            for (var t = 0, r = (e = Ft(e)).parent, n = 0; n < r.lines.length; ++n) {
              var i = r.lines[n];
              if (i == e) break;
              t += i.height;
            }
            for (var o = r.parent; o; o = (r = o).parent) for (var a = 0; a < o.children.length; ++a) {
              var l = o.children[a];
              if (l == r) break;
              t += l.height;
            }
            return t;
          }
          function Gt(e) {
            if (0 == e.height) return 0;
            for (var t, r = e.text.length, n = e; t = Wt(n);) {
              var i = t.find(0, !0);
              n = i.from.line, r += i.from.ch - i.to.ch;
            }
            for (n = e; t = It(n);) {
              var o = t.find(0, !0);
              r -= n.text.length - o.from.ch, r += (n = o.to.line).text.length - o.to.ch;
            }
            return r;
          }
          function Vt(e) {
            var t = e.display,
              r = e.doc;
            t.maxLine = Ke(r, r.first), t.maxLineLength = Gt(t.maxLine), t.maxLineChanged = !0, r.iter(function (e) {
              var r = Gt(e);
              r > t.maxLineLength && (t.maxLineLength = r, t.maxLine = e);
            });
          }
          var Kt = function (e, t, r) {
            this.text = e, Mt(this, t), this.height = r ? r(this) : 1;
          };
          function Yt(e) {
            e.parent = null, Et(e);
          }
          Kt.prototype.lineNo = function () {
            return $e(this);
          }, ye(Kt);
          var Xt = {},
            qt = {};
          function $t(e, t) {
            if (!e || /^\s*$/.test(e)) return null;
            var r = t.addModeClass ? qt : Xt;
            return r[e] || (r[e] = e.replace(/\S+/g, "cm-$&"));
          }
          function Jt(e, t) {
            var r = A("span", null, null, s ? "padding-right: .1px" : null),
              n = {
                pre: A("pre", [r], "CodeMirror-line"),
                content: r,
                col: 0,
                pos: 0,
                cm: e,
                trailingSpace: !1,
                splitSpaces: e.getOption("lineWrapping")
              };
            t.measure = {};
            for (var i = 0; i <= (t.rest ? t.rest.length : 0); i++) {
              var o = i ? t.rest[i - 1] : t.line,
                a = void 0;
              n.pos = 0, n.addToken = Qt, Me(e.display.measure) && (a = ce(o, e.doc.direction)) && (n.addToken = er(n.addToken, a)), n.map = [], rr(o, n, ft(e, o, t != e.display.externalMeasured && $e(o))), o.styleClasses && (o.styleClasses.bgClass && (n.bgClass = W(o.styleClasses.bgClass, n.bgClass || "")), o.styleClasses.textClass && (n.textClass = W(o.styleClasses.textClass, n.textClass || ""))), 0 == n.map.length && n.map.push(0, 0, n.content.appendChild(Ee(e.display.measure))), 0 == i ? (t.measure.map = n.map, t.measure.cache = {}) : ((t.measure.maps || (t.measure.maps = [])).push(n.map), (t.measure.caches || (t.measure.caches = [])).push({}));
            }
            if (s) {
              var l = n.content.lastChild;
              (/\bcm-tab\b/.test(l.className) || l.querySelector && l.querySelector(".cm-tab")) && (n.content.className = "cm-tab-wrap-hack");
            }
            return pe(e, "renderLine", e, t.line, n.pre), n.pre.className && (n.textClass = W(n.pre.className, n.textClass || "")), n;
          }
          function Zt(e) {
            var t = M("span", "•", "cm-invalidchar");
            return t.title = "\\u" + e.charCodeAt(0).toString(16), t.setAttribute("aria-label", t.title), t;
          }
          function Qt(e, t, r, n, i, o, s) {
            if (t) {
              var c,
                u = e.splitSpaces ? function (e, t) {
                  if (e.length > 1 && !/  /.test(e)) return e;
                  for (var r = t, n = "", i = 0; i < e.length; i++) {
                    var o = e.charAt(i);
                    " " != o || !r || i != e.length - 1 && 32 != e.charCodeAt(i + 1) || (o = " "), n += o, r = " " == o;
                  }
                  return n;
                }(t, e.trailingSpace) : t,
                d = e.cm.state.specialChars,
                f = !1;
              if (d.test(t)) {
                c = document.createDocumentFragment();
                for (var h = 0;;) {
                  d.lastIndex = h;
                  var p = d.exec(t),
                    m = p ? p.index - h : t.length - h;
                  if (m) {
                    var g = document.createTextNode(u.slice(h, h + m));
                    a && l < 9 ? c.appendChild(M("span", [g])) : c.appendChild(g), e.map.push(e.pos, e.pos + m, g), e.col += m, e.pos += m;
                  }
                  if (!p) break;
                  h += m + 1;
                  var v = void 0;
                  if ("\t" == p[0]) {
                    var y = e.cm.options.tabSize,
                      b = y - e.col % y;
                    (v = c.appendChild(M("span", Y(b), "cm-tab"))).setAttribute("role", "presentation"), v.setAttribute("cm-text", "\t"), e.col += b;
                  } else "\r" == p[0] || "\n" == p[0] ? ((v = c.appendChild(M("span", "\r" == p[0] ? "␍" : "␤", "cm-invalidchar"))).setAttribute("cm-text", p[0]), e.col += 1) : ((v = e.cm.options.specialCharPlaceholder(p[0])).setAttribute("cm-text", p[0]), a && l < 9 ? c.appendChild(M("span", [v])) : c.appendChild(v), e.col += 1);
                  e.map.push(e.pos, e.pos + 1, v), e.pos++;
                }
              } else e.col += t.length, c = document.createTextNode(u), e.map.push(e.pos, e.pos + t.length, c), a && l < 9 && (f = !0), e.pos += t.length;
              if (e.trailingSpace = 32 == u.charCodeAt(t.length - 1), r || n || i || f || o || s) {
                var x = r || "";
                n && (x += n), i && (x += i);
                var w = M("span", [c], x, o);
                if (s) for (var k in s) s.hasOwnProperty(k) && "style" != k && "class" != k && w.setAttribute(k, s[k]);
                return e.content.appendChild(w);
              }
              e.content.appendChild(c);
            }
          }
          function er(e, t) {
            return function (r, n, i, o, a, l, s) {
              i = i ? i + " cm-force-border" : "cm-force-border";
              for (var c = r.pos, u = c + n.length;;) {
                for (var d = void 0, f = 0; f < t.length && !((d = t[f]).to > c && d.from <= c); f++);
                if (d.to >= u) return e(r, n, i, o, a, l, s);
                e(r, n.slice(0, d.to - c), i, o, null, l, s), o = null, n = n.slice(d.to - c), c = d.to;
              }
            };
          }
          function tr(e, t, r, n) {
            var i = !n && r.widgetNode;
            i && e.map.push(e.pos, e.pos + t, i), !n && e.cm.display.input.needsContentAttribute && (i || (i = e.content.appendChild(document.createElement("span"))), i.setAttribute("cm-marker", r.id)), i && (e.cm.display.input.setUneditable(i), e.content.appendChild(i)), e.pos += t, e.trailingSpace = !1;
          }
          function rr(e, t, r) {
            var n = e.markedSpans,
              i = e.text,
              o = 0;
            if (n) for (var a, l, s, c, u, d, f, h = i.length, p = 0, m = 1, g = "", v = 0;;) {
              if (v == p) {
                s = c = u = l = "", f = null, d = null, v = 1 / 0;
                for (var y = [], b = void 0, x = 0; x < n.length; ++x) {
                  var w = n[x],
                    k = w.marker;
                  if ("bookmark" == k.type && w.from == p && k.widgetNode) y.push(k);else if (w.from <= p && (null == w.to || w.to > p || k.collapsed && w.to == p && w.from == p)) {
                    if (null != w.to && w.to != p && v > w.to && (v = w.to, c = ""), k.className && (s += " " + k.className), k.css && (l = (l ? l + ";" : "") + k.css), k.startStyle && w.from == p && (u += " " + k.startStyle), k.endStyle && w.to == v && (b || (b = [])).push(k.endStyle, w.to), k.title && ((f || (f = {})).title = k.title), k.attributes) for (var C in k.attributes) (f || (f = {}))[C] = k.attributes[C];
                    k.collapsed && (!d || Dt(d.marker, k) < 0) && (d = w);
                  } else w.from > p && v > w.from && (v = w.from);
                }
                if (b) for (var S = 0; S < b.length; S += 2) b[S + 1] == v && (c += " " + b[S]);
                if (!d || d.from == p) for (var T = 0; T < y.length; ++T) tr(t, 0, y[T]);
                if (d && (d.from || 0) == p) {
                  if (tr(t, (null == d.to ? h + 1 : d.to) - p, d.marker, null == d.from), null == d.to) return;
                  d.to == p && (d = !1);
                }
              }
              if (p >= h) break;
              for (var L = Math.min(h, v);;) {
                if (g) {
                  var N = p + g.length;
                  if (!d) {
                    var E = N > L ? g.slice(0, L - p) : g;
                    t.addToken(t, E, a ? a + s : s, u, p + E.length == v ? c : "", l, f);
                  }
                  if (N >= L) {
                    g = g.slice(L - p), p = L;
                    break;
                  }
                  p = N, u = "";
                }
                g = i.slice(o, o = r[m++]), a = $t(r[m++], t.cm.options);
              }
            } else for (var M = 1; M < r.length; M += 2) t.addToken(t, i.slice(o, o = r[M]), $t(r[M + 1], t.cm.options));
          }
          function nr(e, t, r) {
            this.line = t, this.rest = function (e) {
              for (var t, r; t = It(e);) e = t.find(1, !0).line, (r || (r = [])).push(e);
              return r;
            }(t), this.size = this.rest ? $e(X(this.rest)) - r + 1 : 1, this.node = this.text = null, this.hidden = Bt(e, t);
          }
          function ir(e, t, r) {
            for (var n, i = [], o = t; o < r; o = n) {
              var a = new nr(e.doc, Ke(e.doc, o), o);
              n = o + a.size, i.push(a);
            }
            return i;
          }
          var or = null;
          var ar = null;
          function lr(e, t) {
            var r = fe(e, t);
            if (r.length) {
              var n,
                i = Array.prototype.slice.call(arguments, 2);
              or ? n = or.delayedCallbacks : ar ? n = ar : (n = ar = [], setTimeout(sr, 0));
              for (var o = function (e) {
                  n.push(function () {
                    return r[e].apply(null, i);
                  });
                }, a = 0; a < r.length; ++a) o(a);
            }
          }
          function sr() {
            var e = ar;
            ar = null;
            for (var t = 0; t < e.length; ++t) e[t]();
          }
          function cr(e, t, r, n) {
            for (var i = 0; i < t.changes.length; i++) {
              var o = t.changes[i];
              "text" == o ? fr(e, t) : "gutter" == o ? pr(e, t, r, n) : "class" == o ? hr(e, t) : "widget" == o && mr(e, t, n);
            }
            t.changes = null;
          }
          function ur(e) {
            return e.node == e.text && (e.node = M("div", null, null, "position: relative"), e.text.parentNode && e.text.parentNode.replaceChild(e.node, e.text), e.node.appendChild(e.text), a && l < 8 && (e.node.style.zIndex = 2)), e.node;
          }
          function dr(e, t) {
            var r = e.display.externalMeasured;
            return r && r.line == t.line ? (e.display.externalMeasured = null, t.measure = r.measure, r.built) : Jt(e, t);
          }
          function fr(e, t) {
            var r = t.text.className,
              n = dr(e, t);
            t.text == t.node && (t.node = n.pre), t.text.parentNode.replaceChild(n.pre, t.text), t.text = n.pre, n.bgClass != t.bgClass || n.textClass != t.textClass ? (t.bgClass = n.bgClass, t.textClass = n.textClass, hr(e, t)) : r && (t.text.className = r);
          }
          function hr(e, t) {
            (function (e, t) {
              var r = t.bgClass ? t.bgClass + " " + (t.line.bgClass || "") : t.line.bgClass;
              if (r && (r += " CodeMirror-linebackground"), t.background) r ? t.background.className = r : (t.background.parentNode.removeChild(t.background), t.background = null);else if (r) {
                var n = ur(t);
                t.background = n.insertBefore(M("div", null, r), n.firstChild), e.display.input.setUneditable(t.background);
              }
            })(e, t), t.line.wrapClass ? ur(t).className = t.line.wrapClass : t.node != t.text && (t.node.className = "");
            var r = t.textClass ? t.textClass + " " + (t.line.textClass || "") : t.line.textClass;
            t.text.className = r || "";
          }
          function pr(e, t, r, n) {
            if (t.gutter && (t.node.removeChild(t.gutter), t.gutter = null), t.gutterBackground && (t.node.removeChild(t.gutterBackground), t.gutterBackground = null), t.line.gutterClass) {
              var i = ur(t);
              t.gutterBackground = M("div", null, "CodeMirror-gutter-background " + t.line.gutterClass, "left: " + (e.options.fixedGutter ? n.fixedPos : -n.gutterTotalWidth) + "px; width: " + n.gutterTotalWidth + "px"), e.display.input.setUneditable(t.gutterBackground), i.insertBefore(t.gutterBackground, t.text);
            }
            var o = t.line.gutterMarkers;
            if (e.options.lineNumbers || o) {
              var a = ur(t),
                l = t.gutter = M("div", null, "CodeMirror-gutter-wrapper", "left: " + (e.options.fixedGutter ? n.fixedPos : -n.gutterTotalWidth) + "px");
              if (l.setAttribute("aria-hidden", "true"), e.display.input.setUneditable(l), a.insertBefore(l, t.text), t.line.gutterClass && (l.className += " " + t.line.gutterClass), !e.options.lineNumbers || o && o["CodeMirror-linenumbers"] || (t.lineNumber = l.appendChild(M("div", Qe(e.options, r), "CodeMirror-linenumber CodeMirror-gutter-elt", "left: " + n.gutterLeft["CodeMirror-linenumbers"] + "px; width: " + e.display.lineNumInnerWidth + "px"))), o) for (var s = 0; s < e.display.gutterSpecs.length; ++s) {
                var c = e.display.gutterSpecs[s].className,
                  u = o.hasOwnProperty(c) && o[c];
                u && l.appendChild(M("div", [u], "CodeMirror-gutter-elt", "left: " + n.gutterLeft[c] + "px; width: " + n.gutterWidth[c] + "px"));
              }
            }
          }
          function mr(e, t, r) {
            t.alignable && (t.alignable = null);
            for (var n = S("CodeMirror-linewidget"), i = t.node.firstChild, o = void 0; i; i = o) o = i.nextSibling, n.test(i.className) && t.node.removeChild(i);
            vr(e, t, r);
          }
          function gr(e, t, r, n) {
            var i = dr(e, t);
            return t.text = t.node = i.pre, i.bgClass && (t.bgClass = i.bgClass), i.textClass && (t.textClass = i.textClass), hr(e, t), pr(e, t, r, n), vr(e, t, n), t.node;
          }
          function vr(e, t, r) {
            if (yr(e, t.line, t, r, !0), t.rest) for (var n = 0; n < t.rest.length; n++) yr(e, t.rest[n], t, r, !1);
          }
          function yr(e, t, r, n, i) {
            if (t.widgets) for (var o = ur(r), a = 0, l = t.widgets; a < l.length; ++a) {
              var s = l[a],
                c = M("div", [s.node], "CodeMirror-linewidget" + (s.className ? " " + s.className : ""));
              s.handleMouseEvents || c.setAttribute("cm-ignore-events", "true"), br(s, c, r, n), e.display.input.setUneditable(c), i && s.above ? o.insertBefore(c, r.gutter || r.text) : o.appendChild(c), lr(s, "redraw");
            }
          }
          function br(e, t, r, n) {
            if (e.noHScroll) {
              (r.alignable || (r.alignable = [])).push(t);
              var i = n.wrapperWidth;
              t.style.left = n.fixedPos + "px", e.coverGutter || (i -= n.gutterTotalWidth, t.style.paddingLeft = n.gutterTotalWidth + "px"), t.style.width = i + "px";
            }
            e.coverGutter && (t.style.zIndex = 5, t.style.position = "relative", e.noHScroll || (t.style.marginLeft = -n.gutterTotalWidth + "px"));
          }
          function xr(e) {
            if (null != e.height) return e.height;
            var t = e.doc.cm;
            if (!t) return 0;
            if (!O(document.body, e.node)) {
              var r = "position: relative;";
              e.coverGutter && (r += "margin-left: -" + t.display.gutters.offsetWidth + "px;"), e.noHScroll && (r += "width: " + t.display.wrapper.clientWidth + "px;"), E(t.display.measure, M("div", [e.node], null, r));
            }
            return e.height = e.node.parentNode.offsetHeight;
          }
          function wr(e, t) {
            for (var r = Ce(t); r != e.wrapper; r = r.parentNode) if (!r || 1 == r.nodeType && "true" == r.getAttribute("cm-ignore-events") || r.parentNode == e.sizer && r != e.mover) return !0;
          }
          function kr(e) {
            return e.lineSpace.offsetTop;
          }
          function Cr(e) {
            return e.mover.offsetHeight - e.lineSpace.offsetHeight;
          }
          function Sr(e) {
            if (e.cachedPaddingH) return e.cachedPaddingH;
            var t = E(e.measure, M("pre", "x", "CodeMirror-line-like")),
              r = window.getComputedStyle ? window.getComputedStyle(t) : t.currentStyle,
              n = {
                left: parseInt(r.paddingLeft),
                right: parseInt(r.paddingRight)
              };
            return isNaN(n.left) || isNaN(n.right) || (e.cachedPaddingH = n), n;
          }
          function Tr(e) {
            return 50 - e.display.nativeBarWidth;
          }
          function Lr(e) {
            return e.display.scroller.clientWidth - Tr(e) - e.display.barWidth;
          }
          function Nr(e) {
            return e.display.scroller.clientHeight - Tr(e) - e.display.barHeight;
          }
          function Er(e, t, r) {
            if (e.line == t) return {
              map: e.measure.map,
              cache: e.measure.cache
            };
            if (e.rest) {
              for (var n = 0; n < e.rest.length; n++) if (e.rest[n] == t) return {
                map: e.measure.maps[n],
                cache: e.measure.caches[n]
              };
              for (var i = 0; i < e.rest.length; i++) if ($e(e.rest[i]) > r) return {
                map: e.measure.maps[i],
                cache: e.measure.caches[i],
                before: !0
              };
            }
          }
          function Mr(e, t, r, n) {
            return Dr(e, Or(e, t), r, n);
          }
          function Ar(e, t) {
            if (t >= e.display.viewFrom && t < e.display.viewTo) return e.display.view[un(e, t)];
            var r = e.display.externalMeasured;
            return r && t >= r.lineN && t < r.lineN + r.size ? r : void 0;
          }
          function Or(e, t) {
            var r = $e(t),
              n = Ar(e, r);
            n && !n.text ? n = null : n && n.changes && (cr(e, n, r, on(e)), e.curOp.forceUpdate = !0), n || (n = function (e, t) {
              var r = $e(t = Ft(t)),
                n = e.display.externalMeasured = new nr(e.doc, t, r);
              n.lineN = r;
              var i = n.built = Jt(e, n);
              return n.text = i.pre, E(e.display.lineMeasure, i.pre), n;
            }(e, t));
            var i = Er(n, t, r);
            return {
              line: t,
              view: n,
              rect: null,
              map: i.map,
              cache: i.cache,
              before: i.before,
              hasHeights: !1
            };
          }
          function Dr(e, t, r, n, i) {
            t.before && (r = -1);
            var o,
              s = r + (n || "");
            return t.cache.hasOwnProperty(s) ? o = t.cache[s] : (t.rect || (t.rect = t.view.text.getBoundingClientRect()), t.hasHeights || (function (e, t, r) {
              var n = e.options.lineWrapping,
                i = n && Lr(e);
              if (!t.measure.heights || n && t.measure.width != i) {
                var o = t.measure.heights = [];
                if (n) {
                  t.measure.width = i;
                  for (var a = t.text.firstChild.getClientRects(), l = 0; l < a.length - 1; l++) {
                    var s = a[l],
                      c = a[l + 1];
                    Math.abs(s.bottom - c.bottom) > 2 && o.push((s.bottom + c.top) / 2 - r.top);
                  }
                }
                o.push(r.bottom - r.top);
              }
            }(e, t.view, t.rect), t.hasHeights = !0), (o = function (e, t, r, n) {
              var i,
                o = Ir(t.map, r, n),
                s = o.node,
                c = o.start,
                u = o.end,
                d = o.collapse;
              if (3 == s.nodeType) {
                for (var f = 0; f < 4; f++) {
                  for (; c && ne(t.line.text.charAt(o.coverStart + c));) --c;
                  for (; o.coverStart + u < o.coverEnd && ne(t.line.text.charAt(o.coverStart + u));) ++u;
                  if ((i = a && l < 9 && 0 == c && u == o.coverEnd - o.coverStart ? s.parentNode.getBoundingClientRect() : Pr(T(s, c, u).getClientRects(), n)).left || i.right || 0 == c) break;
                  u = c, c -= 1, d = "right";
                }
                a && l < 11 && (i = function (e, t) {
                  if (!window.screen || null == screen.logicalXDPI || screen.logicalXDPI == screen.deviceXDPI || !function (e) {
                    if (null != We) return We;
                    var t = E(e, M("span", "x")),
                      r = t.getBoundingClientRect(),
                      n = T(t, 0, 1).getBoundingClientRect();
                    return We = Math.abs(r.left - n.left) > 1;
                  }(e)) return t;
                  var r = screen.logicalXDPI / screen.deviceXDPI,
                    n = screen.logicalYDPI / screen.deviceYDPI;
                  return {
                    left: t.left * r,
                    right: t.right * r,
                    top: t.top * n,
                    bottom: t.bottom * n
                  };
                }(e.display.measure, i));
              } else {
                var h;
                c > 0 && (d = n = "right"), i = e.options.lineWrapping && (h = s.getClientRects()).length > 1 ? h["right" == n ? h.length - 1 : 0] : s.getBoundingClientRect();
              }
              if (a && l < 9 && !c && (!i || !i.left && !i.right)) {
                var p = s.parentNode.getClientRects()[0];
                i = p ? {
                  left: p.left,
                  right: p.left + nn(e.display),
                  top: p.top,
                  bottom: p.bottom
                } : Wr;
              }
              for (var m = i.top - t.rect.top, g = i.bottom - t.rect.top, v = (m + g) / 2, y = t.view.measure.heights, b = 0; b < y.length - 1 && !(v < y[b]); b++);
              var x = b ? y[b - 1] : 0,
                w = y[b],
                k = {
                  left: ("right" == d ? i.right : i.left) - t.rect.left,
                  right: ("left" == d ? i.left : i.right) - t.rect.left,
                  top: x,
                  bottom: w
                };
              return i.left || i.right || (k.bogus = !0), e.options.singleCursorHeightPerLine || (k.rtop = m, k.rbottom = g), k;
            }(e, t, r, n)).bogus || (t.cache[s] = o)), {
              left: o.left,
              right: o.right,
              top: i ? o.rtop : o.top,
              bottom: i ? o.rbottom : o.bottom
            };
          }
          var Rr,
            Wr = {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0
            };
          function Ir(e, t, r) {
            for (var n, i, o, a, l, s, c = 0; c < e.length; c += 3) if (l = e[c], s = e[c + 1], t < l ? (i = 0, o = 1, a = "left") : t < s ? o = 1 + (i = t - l) : (c == e.length - 3 || t == s && e[c + 3] > t) && (i = (o = s - l) - 1, t >= s && (a = "right")), null != i) {
              if (n = e[c + 2], l == s && r == (n.insertLeft ? "left" : "right") && (a = r), "left" == r && 0 == i) for (; c && e[c - 2] == e[c - 3] && e[c - 1].insertLeft;) n = e[2 + (c -= 3)], a = "left";
              if ("right" == r && i == s - l) for (; c < e.length - 3 && e[c + 3] == e[c + 4] && !e[c + 5].insertLeft;) n = e[(c += 3) + 2], a = "right";
              break;
            }
            return {
              node: n,
              start: i,
              end: o,
              collapse: a,
              coverStart: l,
              coverEnd: s
            };
          }
          function Pr(e, t) {
            var r = Wr;
            if ("left" == t) for (var n = 0; n < e.length && (r = e[n]).left == r.right; n++);else for (var i = e.length - 1; i >= 0 && (r = e[i]).left == r.right; i--);
            return r;
          }
          function Hr(e) {
            if (e.measure && (e.measure.cache = {}, e.measure.heights = null, e.rest)) for (var t = 0; t < e.rest.length; t++) e.measure.caches[t] = {};
          }
          function Fr(e) {
            e.display.externalMeasure = null, N(e.display.lineMeasure);
            for (var t = 0; t < e.display.view.length; t++) Hr(e.display.view[t]);
          }
          function zr(e) {
            Fr(e), e.display.cachedCharWidth = e.display.cachedTextHeight = e.display.cachedPaddingH = null, e.options.lineWrapping || (e.display.maxLineChanged = !0), e.display.lineNumChars = null;
          }
          function _r() {
            return u && g ? -(document.body.getBoundingClientRect().left - parseInt(getComputedStyle(document.body).marginLeft)) : window.pageXOffset || (document.documentElement || document.body).scrollLeft;
          }
          function Br() {
            return u && g ? -(document.body.getBoundingClientRect().top - parseInt(getComputedStyle(document.body).marginTop)) : window.pageYOffset || (document.documentElement || document.body).scrollTop;
          }
          function jr(e) {
            var t = 0;
            if (e.widgets) for (var r = 0; r < e.widgets.length; ++r) e.widgets[r].above && (t += xr(e.widgets[r]));
            return t;
          }
          function Ur(e, t, r, n, i) {
            if (!i) {
              var o = jr(t);
              r.top += o, r.bottom += o;
            }
            if ("line" == n) return r;
            n || (n = "local");
            var a = Ut(t);
            if ("local" == n ? a += kr(e.display) : a -= e.display.viewOffset, "page" == n || "window" == n) {
              var l = e.display.lineSpace.getBoundingClientRect();
              a += l.top + ("window" == n ? 0 : Br());
              var s = l.left + ("window" == n ? 0 : _r());
              r.left += s, r.right += s;
            }
            return r.top += a, r.bottom += a, r;
          }
          function Gr(e, t, r) {
            if ("div" == r) return t;
            var n = t.left,
              i = t.top;
            if ("page" == r) n -= _r(), i -= Br();else if ("local" == r || !r) {
              var o = e.display.sizer.getBoundingClientRect();
              n += o.left, i += o.top;
            }
            var a = e.display.lineSpace.getBoundingClientRect();
            return {
              left: n - a.left,
              top: i - a.top
            };
          }
          function Vr(e, t, r, n, i) {
            return n || (n = Ke(e.doc, t.line)), Ur(e, n, Mr(e, n, t.ch, i), r);
          }
          function Kr(e, t, r, n, i, o) {
            function a(t, a) {
              var l = Dr(e, i, t, a ? "right" : "left", o);
              return a ? l.left = l.right : l.right = l.left, Ur(e, n, l, r);
            }
            n = n || Ke(e.doc, t.line), i || (i = Or(e, n));
            var l = ce(n, e.doc.direction),
              s = t.ch,
              c = t.sticky;
            if (s >= n.text.length ? (s = n.text.length, c = "before") : s <= 0 && (s = 0, c = "after"), !l) return a("before" == c ? s - 1 : s, "before" == c);
            function u(e, t, r) {
              return a(r ? e - 1 : e, 1 == l[t].level != r);
            }
            var d = le(l, s, c),
              f = ae,
              h = u(s, d, "before" == c);
            return null != f && (h.other = u(s, f, "before" != c)), h;
          }
          function Yr(e, t) {
            var r = 0;
            t = lt(e.doc, t), e.options.lineWrapping || (r = nn(e.display) * t.ch);
            var n = Ke(e.doc, t.line),
              i = Ut(n) + kr(e.display);
            return {
              left: r,
              right: r,
              top: i,
              bottom: i + n.height
            };
          }
          function Xr(e, t, r, n, i) {
            var o = et(e, t, r);
            return o.xRel = i, n && (o.outside = n), o;
          }
          function qr(e, t, r) {
            var n = e.doc;
            if ((r += e.display.viewOffset) < 0) return Xr(n.first, 0, null, -1, -1);
            var i = Je(n, r),
              o = n.first + n.size - 1;
            if (i > o) return Xr(n.first + n.size - 1, Ke(n, o).text.length, null, 1, 1);
            t < 0 && (t = 0);
            for (var a = Ke(n, i);;) {
              var l = Qr(e, a, i, t, r),
                s = Pt(a, l.ch + (l.xRel > 0 || l.outside > 0 ? 1 : 0));
              if (!s) return l;
              var c = s.find(1);
              if (c.line == i) return c;
              a = Ke(n, i = c.line);
            }
          }
          function $r(e, t, r, n) {
            n -= jr(t);
            var i = t.text.length,
              o = oe(function (t) {
                return Dr(e, r, t - 1).bottom <= n;
              }, i, 0);
            return {
              begin: o,
              end: i = oe(function (t) {
                return Dr(e, r, t).top > n;
              }, o, i)
            };
          }
          function Jr(e, t, r, n) {
            return r || (r = Or(e, t)), $r(e, t, r, Ur(e, t, Dr(e, r, n), "line").top);
          }
          function Zr(e, t, r, n) {
            return !(e.bottom <= r) && (e.top > r || (n ? e.left : e.right) > t);
          }
          function Qr(e, t, r, n, i) {
            i -= Ut(t);
            var o = Or(e, t),
              a = jr(t),
              l = 0,
              s = t.text.length,
              c = !0,
              u = ce(t, e.doc.direction);
            if (u) {
              var d = (e.options.lineWrapping ? tn : en)(e, t, r, o, u, n, i);
              l = (c = 1 != d.level) ? d.from : d.to - 1, s = c ? d.to : d.from - 1;
            }
            var f,
              h,
              p = null,
              m = null,
              g = oe(function (t) {
                var r = Dr(e, o, t);
                return r.top += a, r.bottom += a, !!Zr(r, n, i, !1) && (r.top <= i && r.left <= n && (p = t, m = r), !0);
              }, l, s),
              v = !1;
            if (m) {
              var y = n - m.left < m.right - n,
                b = y == c;
              g = p + (b ? 0 : 1), h = b ? "after" : "before", f = y ? m.left : m.right;
            } else {
              c || g != s && g != l || g++, h = 0 == g ? "after" : g == t.text.length ? "before" : Dr(e, o, g - (c ? 1 : 0)).bottom + a <= i == c ? "after" : "before";
              var x = Kr(e, et(r, g, h), "line", t, o);
              f = x.left, v = i < x.top ? -1 : i >= x.bottom ? 1 : 0;
            }
            return Xr(r, g = ie(t.text, g, 1), h, v, n - f);
          }
          function en(e, t, r, n, i, o, a) {
            var l = oe(function (l) {
                var s = i[l],
                  c = 1 != s.level;
                return Zr(Kr(e, et(r, c ? s.to : s.from, c ? "before" : "after"), "line", t, n), o, a, !0);
              }, 0, i.length - 1),
              s = i[l];
            if (l > 0) {
              var c = 1 != s.level,
                u = Kr(e, et(r, c ? s.from : s.to, c ? "after" : "before"), "line", t, n);
              Zr(u, o, a, !0) && u.top > a && (s = i[l - 1]);
            }
            return s;
          }
          function tn(e, t, r, n, i, o, a) {
            var l = $r(e, t, n, a),
              s = l.begin,
              c = l.end;
            /\s/.test(t.text.charAt(c - 1)) && c--;
            for (var u = null, d = null, f = 0; f < i.length; f++) {
              var h = i[f];
              if (!(h.from >= c || h.to <= s)) {
                var p = Dr(e, n, 1 != h.level ? Math.min(c, h.to) - 1 : Math.max(s, h.from)).right,
                  m = p < o ? o - p + 1e9 : p - o;
                (!u || d > m) && (u = h, d = m);
              }
            }
            return u || (u = i[i.length - 1]), u.from < s && (u = {
              from: s,
              to: u.to,
              level: u.level
            }), u.to > c && (u = {
              from: u.from,
              to: c,
              level: u.level
            }), u;
          }
          function rn(e) {
            if (null != e.cachedTextHeight) return e.cachedTextHeight;
            if (null == Rr) {
              Rr = M("pre", null, "CodeMirror-line-like");
              for (var t = 0; t < 49; ++t) Rr.appendChild(document.createTextNode("x")), Rr.appendChild(M("br"));
              Rr.appendChild(document.createTextNode("x"));
            }
            E(e.measure, Rr);
            var r = Rr.offsetHeight / 50;
            return r > 3 && (e.cachedTextHeight = r), N(e.measure), r || 1;
          }
          function nn(e) {
            if (null != e.cachedCharWidth) return e.cachedCharWidth;
            var t = M("span", "xxxxxxxxxx"),
              r = M("pre", [t], "CodeMirror-line-like");
            E(e.measure, r);
            var n = t.getBoundingClientRect(),
              i = (n.right - n.left) / 10;
            return i > 2 && (e.cachedCharWidth = i), i || 10;
          }
          function on(e) {
            for (var t = e.display, r = {}, n = {}, i = t.gutters.clientLeft, o = t.gutters.firstChild, a = 0; o; o = o.nextSibling, ++a) {
              var l = e.display.gutterSpecs[a].className;
              r[l] = o.offsetLeft + o.clientLeft + i, n[l] = o.clientWidth;
            }
            return {
              fixedPos: an(t),
              gutterTotalWidth: t.gutters.offsetWidth,
              gutterLeft: r,
              gutterWidth: n,
              wrapperWidth: t.wrapper.clientWidth
            };
          }
          function an(e) {
            return e.scroller.getBoundingClientRect().left - e.sizer.getBoundingClientRect().left;
          }
          function ln(e) {
            var t = rn(e.display),
              r = e.options.lineWrapping,
              n = r && Math.max(5, e.display.scroller.clientWidth / nn(e.display) - 3);
            return function (i) {
              if (Bt(e.doc, i)) return 0;
              var o = 0;
              if (i.widgets) for (var a = 0; a < i.widgets.length; a++) i.widgets[a].height && (o += i.widgets[a].height);
              return r ? o + (Math.ceil(i.text.length / n) || 1) * t : o + t;
            };
          }
          function sn(e) {
            var t = e.doc,
              r = ln(e);
            t.iter(function (e) {
              var t = r(e);
              t != e.height && qe(e, t);
            });
          }
          function cn(e, t, r, n) {
            var i = e.display;
            if (!r && "true" == Ce(t).getAttribute("cm-not-content")) return null;
            var o,
              a,
              l = i.lineSpace.getBoundingClientRect();
            try {
              o = t.clientX - l.left, a = t.clientY - l.top;
            } catch (e) {
              return null;
            }
            var s,
              c = qr(e, o, a);
            if (n && c.xRel > 0 && (s = Ke(e.doc, c.line).text).length == c.ch) {
              var u = F(s, s.length, e.options.tabSize) - s.length;
              c = et(c.line, Math.max(0, Math.round((o - Sr(e.display).left) / nn(e.display)) - u));
            }
            return c;
          }
          function un(e, t) {
            if (t >= e.display.viewTo) return null;
            if ((t -= e.display.viewFrom) < 0) return null;
            for (var r = e.display.view, n = 0; n < r.length; n++) if ((t -= r[n].size) < 0) return n;
          }
          function dn(e, t, r, n) {
            null == t && (t = e.doc.first), null == r && (r = e.doc.first + e.doc.size), n || (n = 0);
            var i = e.display;
            if (n && r < i.viewTo && (null == i.updateLineNumbers || i.updateLineNumbers > t) && (i.updateLineNumbers = t), e.curOp.viewChanged = !0, t >= i.viewTo) kt && zt(e.doc, t) < i.viewTo && hn(e);else if (r <= i.viewFrom) kt && _t(e.doc, r + n) > i.viewFrom ? hn(e) : (i.viewFrom += n, i.viewTo += n);else if (t <= i.viewFrom && r >= i.viewTo) hn(e);else if (t <= i.viewFrom) {
              var o = pn(e, r, r + n, 1);
              o ? (i.view = i.view.slice(o.index), i.viewFrom = o.lineN, i.viewTo += n) : hn(e);
            } else if (r >= i.viewTo) {
              var a = pn(e, t, t, -1);
              a ? (i.view = i.view.slice(0, a.index), i.viewTo = a.lineN) : hn(e);
            } else {
              var l = pn(e, t, t, -1),
                s = pn(e, r, r + n, 1);
              l && s ? (i.view = i.view.slice(0, l.index).concat(ir(e, l.lineN, s.lineN)).concat(i.view.slice(s.index)), i.viewTo += n) : hn(e);
            }
            var c = i.externalMeasured;
            c && (r < c.lineN ? c.lineN += n : t < c.lineN + c.size && (i.externalMeasured = null));
          }
          function fn(e, t, r) {
            e.curOp.viewChanged = !0;
            var n = e.display,
              i = e.display.externalMeasured;
            if (i && t >= i.lineN && t < i.lineN + i.size && (n.externalMeasured = null), !(t < n.viewFrom || t >= n.viewTo)) {
              var o = n.view[un(e, t)];
              if (null != o.node) {
                var a = o.changes || (o.changes = []);
                -1 == _(a, r) && a.push(r);
              }
            }
          }
          function hn(e) {
            e.display.viewFrom = e.display.viewTo = e.doc.first, e.display.view = [], e.display.viewOffset = 0;
          }
          function pn(e, t, r, n) {
            var i,
              o = un(e, t),
              a = e.display.view;
            if (!kt || r == e.doc.first + e.doc.size) return {
              index: o,
              lineN: r
            };
            for (var l = e.display.viewFrom, s = 0; s < o; s++) l += a[s].size;
            if (l != t) {
              if (n > 0) {
                if (o == a.length - 1) return null;
                i = l + a[o].size - t, o++;
              } else i = l - t;
              t += i, r += i;
            }
            for (; zt(e.doc, r) != r;) {
              if (o == (n < 0 ? 0 : a.length - 1)) return null;
              r += n * a[o - (n < 0 ? 1 : 0)].size, o += n;
            }
            return {
              index: o,
              lineN: r
            };
          }
          function mn(e) {
            for (var t = e.display.view, r = 0, n = 0; n < t.length; n++) {
              var i = t[n];
              i.hidden || i.node && !i.changes || ++r;
            }
            return r;
          }
          function gn(e) {
            e.display.input.showSelection(e.display.input.prepareSelection());
          }
          function vn(e, t) {
            void 0 === t && (t = !0);
            var r = e.doc,
              n = {},
              i = n.cursors = document.createDocumentFragment(),
              o = n.selection = document.createDocumentFragment(),
              a = e.options.$customCursor;
            a && (t = !0);
            for (var l = 0; l < r.sel.ranges.length; l++) if (t || l != r.sel.primIndex) {
              var s = r.sel.ranges[l];
              if (!(s.from().line >= e.display.viewTo || s.to().line < e.display.viewFrom)) {
                var c = s.empty();
                if (a) {
                  var u = a(e, s);
                  u && yn(e, u, i);
                } else (c || e.options.showCursorWhenSelecting) && yn(e, s.head, i);
                c || xn(e, s, o);
              }
            }
            return n;
          }
          function yn(e, t, r) {
            var n = Kr(e, t, "div", null, null, !e.options.singleCursorHeightPerLine),
              i = r.appendChild(M("div", " ", "CodeMirror-cursor"));
            if (i.style.left = n.left + "px", i.style.top = n.top + "px", i.style.height = Math.max(0, n.bottom - n.top) * e.options.cursorHeight + "px", /\bcm-fat-cursor\b/.test(e.getWrapperElement().className)) {
              var o = Vr(e, t, "div", null, null),
                a = o.right - o.left;
              i.style.width = (a > 0 ? a : e.defaultCharWidth()) + "px";
            }
            if (n.other) {
              var l = r.appendChild(M("div", " ", "CodeMirror-cursor CodeMirror-secondarycursor"));
              l.style.display = "", l.style.left = n.other.left + "px", l.style.top = n.other.top + "px", l.style.height = .85 * (n.other.bottom - n.other.top) + "px";
            }
          }
          function bn(e, t) {
            return e.top - t.top || e.left - t.left;
          }
          function xn(e, t, r) {
            var n = e.display,
              i = e.doc,
              o = document.createDocumentFragment(),
              a = Sr(e.display),
              l = a.left,
              s = Math.max(n.sizerWidth, Lr(e) - n.sizer.offsetLeft) - a.right,
              c = "ltr" == i.direction;
            function u(e, t, r, n) {
              t < 0 && (t = 0), t = Math.round(t), n = Math.round(n), o.appendChild(M("div", null, "CodeMirror-selected", "position: absolute; left: " + e + "px;\n                             top: " + t + "px; width: " + (null == r ? s - e : r) + "px;\n                             height: " + (n - t) + "px"));
            }
            function d(t, r, n) {
              var o,
                a,
                d = Ke(i, t),
                f = d.text.length;
              function h(r, n) {
                return Vr(e, et(t, r), "div", d, n);
              }
              function p(t, r, n) {
                var i = Jr(e, d, null, t),
                  o = "ltr" == r == ("after" == n) ? "left" : "right";
                return h("after" == n ? i.begin : i.end - (/\s/.test(d.text.charAt(i.end - 1)) ? 2 : 1), o)[o];
              }
              var m = ce(d, i.direction);
              return function (e, t, r, n) {
                if (!e) return n(t, r, "ltr", 0);
                for (var i = !1, o = 0; o < e.length; ++o) {
                  var a = e[o];
                  (a.from < r && a.to > t || t == r && a.to == t) && (n(Math.max(a.from, t), Math.min(a.to, r), 1 == a.level ? "rtl" : "ltr", o), i = !0);
                }
                i || n(t, r, "ltr");
              }(m, r || 0, null == n ? f : n, function (e, t, i, d) {
                var g = "ltr" == i,
                  v = h(e, g ? "left" : "right"),
                  y = h(t - 1, g ? "right" : "left"),
                  b = null == r && 0 == e,
                  x = null == n && t == f,
                  w = 0 == d,
                  k = !m || d == m.length - 1;
                if (y.top - v.top <= 3) {
                  var C = (c ? x : b) && k,
                    S = (c ? b : x) && w ? l : (g ? v : y).left,
                    T = C ? s : (g ? y : v).right;
                  u(S, v.top, T - S, v.bottom);
                } else {
                  var L, N, E, M;
                  g ? (L = c && b && w ? l : v.left, N = c ? s : p(e, i, "before"), E = c ? l : p(t, i, "after"), M = c && x && k ? s : y.right) : (L = c ? p(e, i, "before") : l, N = !c && b && w ? s : v.right, E = !c && x && k ? l : y.left, M = c ? p(t, i, "after") : s), u(L, v.top, N - L, v.bottom), v.bottom < y.top && u(l, v.bottom, null, y.top), u(E, y.top, M - E, y.bottom);
                }
                (!o || bn(v, o) < 0) && (o = v), bn(y, o) < 0 && (o = y), (!a || bn(v, a) < 0) && (a = v), bn(y, a) < 0 && (a = y);
              }), {
                start: o,
                end: a
              };
            }
            var f = t.from(),
              h = t.to();
            if (f.line == h.line) d(f.line, f.ch, h.ch);else {
              var p = Ke(i, f.line),
                m = Ke(i, h.line),
                g = Ft(p) == Ft(m),
                v = d(f.line, f.ch, g ? p.text.length + 1 : null).end,
                y = d(h.line, g ? 0 : null, h.ch).start;
              g && (v.top < y.top - 2 ? (u(v.right, v.top, null, v.bottom), u(l, y.top, y.left, y.bottom)) : u(v.right, v.top, y.left - v.right, v.bottom)), v.bottom < y.top && u(l, v.bottom, null, y.top);
            }
            r.appendChild(o);
          }
          function wn(e) {
            if (e.state.focused) {
              var t = e.display;
              clearInterval(t.blinker);
              var r = !0;
              t.cursorDiv.style.visibility = "", e.options.cursorBlinkRate > 0 ? t.blinker = setInterval(function () {
                e.hasFocus() || Tn(e), t.cursorDiv.style.visibility = (r = !r) ? "" : "hidden";
              }, e.options.cursorBlinkRate) : e.options.cursorBlinkRate < 0 && (t.cursorDiv.style.visibility = "hidden");
            }
          }
          function kn(e) {
            e.hasFocus() || (e.display.input.focus(), e.state.focused || Sn(e));
          }
          function Cn(e) {
            e.state.delayingBlurEvent = !0, setTimeout(function () {
              e.state.delayingBlurEvent && (e.state.delayingBlurEvent = !1, e.state.focused && Tn(e));
            }, 100);
          }
          function Sn(e, t) {
            e.state.delayingBlurEvent && !e.state.draggingText && (e.state.delayingBlurEvent = !1), "nocursor" != e.options.readOnly && (e.state.focused || (pe(e, "focus", e, t), e.state.focused = !0, R(e.display.wrapper, "CodeMirror-focused"), e.curOp || e.display.selForContextMenu == e.doc.sel || (e.display.input.reset(), s && setTimeout(function () {
              return e.display.input.reset(!0);
            }, 20)), e.display.input.receivedFocus()), wn(e));
          }
          function Tn(e, t) {
            e.state.delayingBlurEvent || (e.state.focused && (pe(e, "blur", e, t), e.state.focused = !1, L(e.display.wrapper, "CodeMirror-focused")), clearInterval(e.display.blinker), setTimeout(function () {
              e.state.focused || (e.display.shift = !1);
            }, 150));
          }
          function Ln(e) {
            for (var t = e.display, r = t.lineDiv.offsetTop, n = Math.max(0, t.scroller.getBoundingClientRect().top), i = t.lineDiv.getBoundingClientRect().top, o = 0, s = 0; s < t.view.length; s++) {
              var c = t.view[s],
                u = e.options.lineWrapping,
                d = void 0,
                f = 0;
              if (!c.hidden) {
                if (i += c.line.height, a && l < 8) {
                  var h = c.node.offsetTop + c.node.offsetHeight;
                  d = h - r, r = h;
                } else {
                  var p = c.node.getBoundingClientRect();
                  d = p.bottom - p.top, !u && c.text.firstChild && (f = c.text.firstChild.getBoundingClientRect().right - p.left - 1);
                }
                var m = c.line.height - d;
                if ((m > .005 || m < -.005) && (i < n && (o -= m), qe(c.line, d), Nn(c.line), c.rest)) for (var g = 0; g < c.rest.length; g++) Nn(c.rest[g]);
                if (f > e.display.sizerWidth) {
                  var v = Math.ceil(f / nn(e.display));
                  v > e.display.maxLineLength && (e.display.maxLineLength = v, e.display.maxLine = c.line, e.display.maxLineChanged = !0);
                }
              }
            }
            Math.abs(o) > 2 && (t.scroller.scrollTop += o);
          }
          function Nn(e) {
            if (e.widgets) for (var t = 0; t < e.widgets.length; ++t) {
              var r = e.widgets[t],
                n = r.node.parentNode;
              n && (r.height = n.offsetHeight);
            }
          }
          function En(e, t, r) {
            var n = r && null != r.top ? Math.max(0, r.top) : e.scroller.scrollTop;
            n = Math.floor(n - kr(e));
            var i = r && null != r.bottom ? r.bottom : n + e.wrapper.clientHeight,
              o = Je(t, n),
              a = Je(t, i);
            if (r && r.ensure) {
              var l = r.ensure.from.line,
                s = r.ensure.to.line;
              l < o ? (o = l, a = Je(t, Ut(Ke(t, l)) + e.wrapper.clientHeight)) : Math.min(s, t.lastLine()) >= a && (o = Je(t, Ut(Ke(t, s)) - e.wrapper.clientHeight), a = s);
            }
            return {
              from: o,
              to: Math.max(a, o + 1)
            };
          }
          function Mn(e, t) {
            var r = e.display,
              n = rn(e.display);
            t.top < 0 && (t.top = 0);
            var i = e.curOp && null != e.curOp.scrollTop ? e.curOp.scrollTop : r.scroller.scrollTop,
              o = Nr(e),
              a = {};
            t.bottom - t.top > o && (t.bottom = t.top + o);
            var l = e.doc.height + Cr(r),
              s = t.top < n,
              c = t.bottom > l - n;
            if (t.top < i) a.scrollTop = s ? 0 : t.top;else if (t.bottom > i + o) {
              var u = Math.min(t.top, (c ? l : t.bottom) - o);
              u != i && (a.scrollTop = u);
            }
            var d = e.options.fixedGutter ? 0 : r.gutters.offsetWidth,
              f = e.curOp && null != e.curOp.scrollLeft ? e.curOp.scrollLeft : r.scroller.scrollLeft - d,
              h = Lr(e) - r.gutters.offsetWidth,
              p = t.right - t.left > h;
            return p && (t.right = t.left + h), t.left < 10 ? a.scrollLeft = 0 : t.left < f ? a.scrollLeft = Math.max(0, t.left + d - (p ? 0 : 10)) : t.right > h + f - 3 && (a.scrollLeft = t.right + (p ? 0 : 10) - h), a;
          }
          function An(e, t) {
            null != t && (Rn(e), e.curOp.scrollTop = (null == e.curOp.scrollTop ? e.doc.scrollTop : e.curOp.scrollTop) + t);
          }
          function On(e) {
            Rn(e);
            var t = e.getCursor();
            e.curOp.scrollToPos = {
              from: t,
              to: t,
              margin: e.options.cursorScrollMargin
            };
          }
          function Dn(e, t, r) {
            null == t && null == r || Rn(e), null != t && (e.curOp.scrollLeft = t), null != r && (e.curOp.scrollTop = r);
          }
          function Rn(e) {
            var t = e.curOp.scrollToPos;
            t && (e.curOp.scrollToPos = null, Wn(e, Yr(e, t.from), Yr(e, t.to), t.margin));
          }
          function Wn(e, t, r, n) {
            var i = Mn(e, {
              left: Math.min(t.left, r.left),
              top: Math.min(t.top, r.top) - n,
              right: Math.max(t.right, r.right),
              bottom: Math.max(t.bottom, r.bottom) + n
            });
            Dn(e, i.scrollLeft, i.scrollTop);
          }
          function In(e, t) {
            Math.abs(e.doc.scrollTop - t) < 2 || (r || si(e, {
              top: t
            }), Pn(e, t, !0), r && si(e), ni(e, 100));
          }
          function Pn(e, t, r) {
            t = Math.max(0, Math.min(e.display.scroller.scrollHeight - e.display.scroller.clientHeight, t)), (e.display.scroller.scrollTop != t || r) && (e.doc.scrollTop = t, e.display.scrollbars.setScrollTop(t), e.display.scroller.scrollTop != t && (e.display.scroller.scrollTop = t));
          }
          function Hn(e, t, r, n) {
            t = Math.max(0, Math.min(t, e.display.scroller.scrollWidth - e.display.scroller.clientWidth)), (r ? t == e.doc.scrollLeft : Math.abs(e.doc.scrollLeft - t) < 2) && !n || (e.doc.scrollLeft = t, di(e), e.display.scroller.scrollLeft != t && (e.display.scroller.scrollLeft = t), e.display.scrollbars.setScrollLeft(t));
          }
          function Fn(e) {
            var t = e.display,
              r = t.gutters.offsetWidth,
              n = Math.round(e.doc.height + Cr(e.display));
            return {
              clientHeight: t.scroller.clientHeight,
              viewHeight: t.wrapper.clientHeight,
              scrollWidth: t.scroller.scrollWidth,
              clientWidth: t.scroller.clientWidth,
              viewWidth: t.wrapper.clientWidth,
              barLeft: e.options.fixedGutter ? r : 0,
              docHeight: n,
              scrollHeight: n + Tr(e) + t.barHeight,
              nativeBarWidth: t.nativeBarWidth,
              gutterWidth: r
            };
          }
          var zn = function (e, t, r) {
            this.cm = r;
            var n = this.vert = M("div", [M("div", null, null, "min-width: 1px")], "CodeMirror-vscrollbar"),
              i = this.horiz = M("div", [M("div", null, null, "height: 100%; min-height: 1px")], "CodeMirror-hscrollbar");
            n.tabIndex = i.tabIndex = -1, e(n), e(i), de(n, "scroll", function () {
              n.clientHeight && t(n.scrollTop, "vertical");
            }), de(i, "scroll", function () {
              i.clientWidth && t(i.scrollLeft, "horizontal");
            }), this.checkedZeroWidth = !1, a && l < 8 && (this.horiz.style.minHeight = this.vert.style.minWidth = "18px");
          };
          zn.prototype.update = function (e) {
            var t = e.scrollWidth > e.clientWidth + 1,
              r = e.scrollHeight > e.clientHeight + 1,
              n = e.nativeBarWidth;
            if (r) {
              this.vert.style.display = "block", this.vert.style.bottom = t ? n + "px" : "0";
              var i = e.viewHeight - (t ? n : 0);
              this.vert.firstChild.style.height = Math.max(0, e.scrollHeight - e.clientHeight + i) + "px";
            } else this.vert.scrollTop = 0, this.vert.style.display = "", this.vert.firstChild.style.height = "0";
            if (t) {
              this.horiz.style.display = "block", this.horiz.style.right = r ? n + "px" : "0", this.horiz.style.left = e.barLeft + "px";
              var o = e.viewWidth - e.barLeft - (r ? n : 0);
              this.horiz.firstChild.style.width = Math.max(0, e.scrollWidth - e.clientWidth + o) + "px";
            } else this.horiz.style.display = "", this.horiz.firstChild.style.width = "0";
            return !this.checkedZeroWidth && e.clientHeight > 0 && (0 == n && this.zeroWidthHack(), this.checkedZeroWidth = !0), {
              right: r ? n : 0,
              bottom: t ? n : 0
            };
          }, zn.prototype.setScrollLeft = function (e) {
            this.horiz.scrollLeft != e && (this.horiz.scrollLeft = e), this.disableHoriz && this.enableZeroWidthBar(this.horiz, this.disableHoriz, "horiz");
          }, zn.prototype.setScrollTop = function (e) {
            this.vert.scrollTop != e && (this.vert.scrollTop = e), this.disableVert && this.enableZeroWidthBar(this.vert, this.disableVert, "vert");
          }, zn.prototype.zeroWidthHack = function () {
            var e = y && !h ? "12px" : "18px";
            this.horiz.style.height = this.vert.style.width = e, this.horiz.style.pointerEvents = this.vert.style.pointerEvents = "none", this.disableHoriz = new z(), this.disableVert = new z();
          }, zn.prototype.enableZeroWidthBar = function (e, t, r) {
            e.style.pointerEvents = "auto", t.set(1e3, function n() {
              var i = e.getBoundingClientRect();
              ("vert" == r ? document.elementFromPoint(i.right - 1, (i.top + i.bottom) / 2) : document.elementFromPoint((i.right + i.left) / 2, i.bottom - 1)) != e ? e.style.pointerEvents = "none" : t.set(1e3, n);
            });
          }, zn.prototype.clear = function () {
            var e = this.horiz.parentNode;
            e.removeChild(this.horiz), e.removeChild(this.vert);
          };
          var _n = function () {};
          function Bn(e, t) {
            t || (t = Fn(e));
            var r = e.display.barWidth,
              n = e.display.barHeight;
            jn(e, t);
            for (var i = 0; i < 4 && r != e.display.barWidth || n != e.display.barHeight; i++) r != e.display.barWidth && e.options.lineWrapping && Ln(e), jn(e, Fn(e)), r = e.display.barWidth, n = e.display.barHeight;
          }
          function jn(e, t) {
            var r = e.display,
              n = r.scrollbars.update(t);
            r.sizer.style.paddingRight = (r.barWidth = n.right) + "px", r.sizer.style.paddingBottom = (r.barHeight = n.bottom) + "px", r.heightForcer.style.borderBottom = n.bottom + "px solid transparent", n.right && n.bottom ? (r.scrollbarFiller.style.display = "block", r.scrollbarFiller.style.height = n.bottom + "px", r.scrollbarFiller.style.width = n.right + "px") : r.scrollbarFiller.style.display = "", n.bottom && e.options.coverGutterNextToScrollbar && e.options.fixedGutter ? (r.gutterFiller.style.display = "block", r.gutterFiller.style.height = n.bottom + "px", r.gutterFiller.style.width = t.gutterWidth + "px") : r.gutterFiller.style.display = "";
          }
          _n.prototype.update = function () {
            return {
              bottom: 0,
              right: 0
            };
          }, _n.prototype.setScrollLeft = function () {}, _n.prototype.setScrollTop = function () {}, _n.prototype.clear = function () {};
          var Un = {
            native: zn,
            null: _n
          };
          function Gn(e) {
            e.display.scrollbars && (e.display.scrollbars.clear(), e.display.scrollbars.addClass && L(e.display.wrapper, e.display.scrollbars.addClass)), e.display.scrollbars = new Un[e.options.scrollbarStyle](function (t) {
              e.display.wrapper.insertBefore(t, e.display.scrollbarFiller), de(t, "mousedown", function () {
                e.state.focused && setTimeout(function () {
                  return e.display.input.focus();
                }, 0);
              }), t.setAttribute("cm-not-content", "true");
            }, function (t, r) {
              "horizontal" == r ? Hn(e, t) : In(e, t);
            }, e), e.display.scrollbars.addClass && R(e.display.wrapper, e.display.scrollbars.addClass);
          }
          var Vn = 0;
          function Kn(e) {
            var t;
            e.curOp = {
              cm: e,
              viewChanged: !1,
              startHeight: e.doc.height,
              forceUpdate: !1,
              updateInput: 0,
              typing: !1,
              changeObjs: null,
              cursorActivityHandlers: null,
              cursorActivityCalled: 0,
              selectionChanged: !1,
              updateMaxLine: !1,
              scrollLeft: null,
              scrollTop: null,
              scrollToPos: null,
              focus: !1,
              id: ++Vn,
              markArrays: null
            }, t = e.curOp, or ? or.ops.push(t) : t.ownsGroup = or = {
              ops: [t],
              delayedCallbacks: []
            };
          }
          function Yn(e) {
            var t = e.curOp;
            t && function (e, t) {
              var r = e.ownsGroup;
              if (r) try {
                !function (e) {
                  var t = e.delayedCallbacks,
                    r = 0;
                  do {
                    for (; r < t.length; r++) t[r].call(null);
                    for (var n = 0; n < e.ops.length; n++) {
                      var i = e.ops[n];
                      if (i.cursorActivityHandlers) for (; i.cursorActivityCalled < i.cursorActivityHandlers.length;) i.cursorActivityHandlers[i.cursorActivityCalled++].call(null, i.cm);
                    }
                  } while (r < t.length);
                }(r);
              } finally {
                or = null, t(r);
              }
            }(t, function (e) {
              for (var t = 0; t < e.ops.length; t++) e.ops[t].cm.curOp = null;
              !function (e) {
                for (var t = e.ops, r = 0; r < t.length; r++) Xn(t[r]);
                for (var n = 0; n < t.length; n++) qn(t[n]);
                for (var i = 0; i < t.length; i++) $n(t[i]);
                for (var o = 0; o < t.length; o++) Jn(t[o]);
                for (var a = 0; a < t.length; a++) Zn(t[a]);
              }(e);
            });
          }
          function Xn(e) {
            var t = e.cm,
              r = t.display;
            (function (e) {
              var t = e.display;
              !t.scrollbarsClipped && t.scroller.offsetWidth && (t.nativeBarWidth = t.scroller.offsetWidth - t.scroller.clientWidth, t.heightForcer.style.height = Tr(e) + "px", t.sizer.style.marginBottom = -t.nativeBarWidth + "px", t.sizer.style.borderRightWidth = Tr(e) + "px", t.scrollbarsClipped = !0);
            })(t), e.updateMaxLine && Vt(t), e.mustUpdate = e.viewChanged || e.forceUpdate || null != e.scrollTop || e.scrollToPos && (e.scrollToPos.from.line < r.viewFrom || e.scrollToPos.to.line >= r.viewTo) || r.maxLineChanged && t.options.lineWrapping, e.update = e.mustUpdate && new oi(t, e.mustUpdate && {
              top: e.scrollTop,
              ensure: e.scrollToPos
            }, e.forceUpdate);
          }
          function qn(e) {
            e.updatedDisplay = e.mustUpdate && ai(e.cm, e.update);
          }
          function $n(e) {
            var t = e.cm,
              r = t.display;
            e.updatedDisplay && Ln(t), e.barMeasure = Fn(t), r.maxLineChanged && !t.options.lineWrapping && (e.adjustWidthTo = Mr(t, r.maxLine, r.maxLine.text.length).left + 3, t.display.sizerWidth = e.adjustWidthTo, e.barMeasure.scrollWidth = Math.max(r.scroller.clientWidth, r.sizer.offsetLeft + e.adjustWidthTo + Tr(t) + t.display.barWidth), e.maxScrollLeft = Math.max(0, r.sizer.offsetLeft + e.adjustWidthTo - Lr(t))), (e.updatedDisplay || e.selectionChanged) && (e.preparedSelection = r.input.prepareSelection());
          }
          function Jn(e) {
            var t = e.cm;
            null != e.adjustWidthTo && (t.display.sizer.style.minWidth = e.adjustWidthTo + "px", e.maxScrollLeft < t.doc.scrollLeft && Hn(t, Math.min(t.display.scroller.scrollLeft, e.maxScrollLeft), !0), t.display.maxLineChanged = !1);
            var r = e.focus && e.focus == D();
            e.preparedSelection && t.display.input.showSelection(e.preparedSelection, r), (e.updatedDisplay || e.startHeight != t.doc.height) && Bn(t, e.barMeasure), e.updatedDisplay && ui(t, e.barMeasure), e.selectionChanged && wn(t), t.state.focused && e.updateInput && t.display.input.reset(e.typing), r && kn(e.cm);
          }
          function Zn(e) {
            var t = e.cm,
              r = t.display,
              n = t.doc;
            e.updatedDisplay && li(t, e.update), null == r.wheelStartX || null == e.scrollTop && null == e.scrollLeft && !e.scrollToPos || (r.wheelStartX = r.wheelStartY = null), null != e.scrollTop && Pn(t, e.scrollTop, e.forceScroll), null != e.scrollLeft && Hn(t, e.scrollLeft, !0, !0), e.scrollToPos && function (e, t) {
              if (!me(e, "scrollCursorIntoView")) {
                var r = e.display,
                  n = r.sizer.getBoundingClientRect(),
                  i = null;
                if (t.top + n.top < 0 ? i = !0 : t.bottom + n.top > (window.innerHeight || document.documentElement.clientHeight) && (i = !1), null != i && !p) {
                  var o = M("div", "​", null, "position: absolute;\n                         top: " + (t.top - r.viewOffset - kr(e.display)) + "px;\n                         height: " + (t.bottom - t.top + Tr(e) + r.barHeight) + "px;\n                         left: " + t.left + "px; width: " + Math.max(2, t.right - t.left) + "px;");
                  e.display.lineSpace.appendChild(o), o.scrollIntoView(i), e.display.lineSpace.removeChild(o);
                }
              }
            }(t, function (e, t, r, n) {
              var i;
              null == n && (n = 0), e.options.lineWrapping || t != r || (r = "before" == t.sticky ? et(t.line, t.ch + 1, "before") : t, t = t.ch ? et(t.line, "before" == t.sticky ? t.ch - 1 : t.ch, "after") : t);
              for (var o = 0; o < 5; o++) {
                var a = !1,
                  l = Kr(e, t),
                  s = r && r != t ? Kr(e, r) : l,
                  c = Mn(e, i = {
                    left: Math.min(l.left, s.left),
                    top: Math.min(l.top, s.top) - n,
                    right: Math.max(l.left, s.left),
                    bottom: Math.max(l.bottom, s.bottom) + n
                  }),
                  u = e.doc.scrollTop,
                  d = e.doc.scrollLeft;
                if (null != c.scrollTop && (In(e, c.scrollTop), Math.abs(e.doc.scrollTop - u) > 1 && (a = !0)), null != c.scrollLeft && (Hn(e, c.scrollLeft), Math.abs(e.doc.scrollLeft - d) > 1 && (a = !0)), !a) break;
              }
              return i;
            }(t, lt(n, e.scrollToPos.from), lt(n, e.scrollToPos.to), e.scrollToPos.margin));
            var i = e.maybeHiddenMarkers,
              o = e.maybeUnhiddenMarkers;
            if (i) for (var a = 0; a < i.length; ++a) i[a].lines.length || pe(i[a], "hide");
            if (o) for (var l = 0; l < o.length; ++l) o[l].lines.length && pe(o[l], "unhide");
            r.wrapper.offsetHeight && (n.scrollTop = t.display.scroller.scrollTop), e.changeObjs && pe(t, "changes", t, e.changeObjs), e.update && e.update.finish();
          }
          function Qn(e, t) {
            if (e.curOp) return t();
            Kn(e);
            try {
              return t();
            } finally {
              Yn(e);
            }
          }
          function ei(e, t) {
            return function () {
              if (e.curOp) return t.apply(e, arguments);
              Kn(e);
              try {
                return t.apply(e, arguments);
              } finally {
                Yn(e);
              }
            };
          }
          function ti(e) {
            return function () {
              if (this.curOp) return e.apply(this, arguments);
              Kn(this);
              try {
                return e.apply(this, arguments);
              } finally {
                Yn(this);
              }
            };
          }
          function ri(e) {
            return function () {
              var t = this.cm;
              if (!t || t.curOp) return e.apply(this, arguments);
              Kn(t);
              try {
                return e.apply(this, arguments);
              } finally {
                Yn(t);
              }
            };
          }
          function ni(e, t) {
            e.doc.highlightFrontier < e.display.viewTo && e.state.highlight.set(t, P(ii, e));
          }
          function ii(e) {
            var t = e.doc;
            if (!(t.highlightFrontier >= e.display.viewTo)) {
              var r = +new Date() + e.options.workTime,
                n = ht(e, t.highlightFrontier),
                i = [];
              t.iter(n.line, Math.min(t.first + t.size, e.display.viewTo + 500), function (o) {
                if (n.line >= e.display.viewFrom) {
                  var a = o.styles,
                    l = o.text.length > e.options.maxHighlightLength ? je(t.mode, n.state) : null,
                    s = dt(e, o, n, !0);
                  l && (n.state = l), o.styles = s.styles;
                  var c = o.styleClasses,
                    u = s.classes;
                  u ? o.styleClasses = u : c && (o.styleClasses = null);
                  for (var d = !a || a.length != o.styles.length || c != u && (!c || !u || c.bgClass != u.bgClass || c.textClass != u.textClass), f = 0; !d && f < a.length; ++f) d = a[f] != o.styles[f];
                  d && i.push(n.line), o.stateAfter = n.save(), n.nextLine();
                } else o.text.length <= e.options.maxHighlightLength && pt(e, o.text, n), o.stateAfter = n.line % 5 == 0 ? n.save() : null, n.nextLine();
                if (+new Date() > r) return ni(e, e.options.workDelay), !0;
              }), t.highlightFrontier = n.line, t.modeFrontier = Math.max(t.modeFrontier, n.line), i.length && Qn(e, function () {
                for (var t = 0; t < i.length; t++) fn(e, i[t], "text");
              });
            }
          }
          var oi = function (e, t, r) {
            var n = e.display;
            this.viewport = t, this.visible = En(n, e.doc, t), this.editorIsHidden = !n.wrapper.offsetWidth, this.wrapperHeight = n.wrapper.clientHeight, this.wrapperWidth = n.wrapper.clientWidth, this.oldDisplayWidth = Lr(e), this.force = r, this.dims = on(e), this.events = [];
          };
          function ai(e, t) {
            var r = e.display,
              n = e.doc;
            if (t.editorIsHidden) return hn(e), !1;
            if (!t.force && t.visible.from >= r.viewFrom && t.visible.to <= r.viewTo && (null == r.updateLineNumbers || r.updateLineNumbers >= r.viewTo) && r.renderedView == r.view && 0 == mn(e)) return !1;
            fi(e) && (hn(e), t.dims = on(e));
            var i = n.first + n.size,
              o = Math.max(t.visible.from - e.options.viewportMargin, n.first),
              a = Math.min(i, t.visible.to + e.options.viewportMargin);
            r.viewFrom < o && o - r.viewFrom < 20 && (o = Math.max(n.first, r.viewFrom)), r.viewTo > a && r.viewTo - a < 20 && (a = Math.min(i, r.viewTo)), kt && (o = zt(e.doc, o), a = _t(e.doc, a));
            var l = o != r.viewFrom || a != r.viewTo || r.lastWrapHeight != t.wrapperHeight || r.lastWrapWidth != t.wrapperWidth;
            (function (e, t, r) {
              var n = e.display;
              0 == n.view.length || t >= n.viewTo || r <= n.viewFrom ? (n.view = ir(e, t, r), n.viewFrom = t) : (n.viewFrom > t ? n.view = ir(e, t, n.viewFrom).concat(n.view) : n.viewFrom < t && (n.view = n.view.slice(un(e, t))), n.viewFrom = t, n.viewTo < r ? n.view = n.view.concat(ir(e, n.viewTo, r)) : n.viewTo > r && (n.view = n.view.slice(0, un(e, r)))), n.viewTo = r;
            })(e, o, a), r.viewOffset = Ut(Ke(e.doc, r.viewFrom)), e.display.mover.style.top = r.viewOffset + "px";
            var c = mn(e);
            if (!l && 0 == c && !t.force && r.renderedView == r.view && (null == r.updateLineNumbers || r.updateLineNumbers >= r.viewTo)) return !1;
            var u = function (e) {
              if (e.hasFocus()) return null;
              var t = D();
              if (!t || !O(e.display.lineDiv, t)) return null;
              var r = {
                activeElt: t
              };
              if (window.getSelection) {
                var n = window.getSelection();
                n.anchorNode && n.extend && O(e.display.lineDiv, n.anchorNode) && (r.anchorNode = n.anchorNode, r.anchorOffset = n.anchorOffset, r.focusNode = n.focusNode, r.focusOffset = n.focusOffset);
              }
              return r;
            }(e);
            return c > 4 && (r.lineDiv.style.display = "none"), function (e, t, r) {
              var n = e.display,
                i = e.options.lineNumbers,
                o = n.lineDiv,
                a = o.firstChild;
              function l(t) {
                var r = t.nextSibling;
                return s && y && e.display.currentWheelTarget == t ? t.style.display = "none" : t.parentNode.removeChild(t), r;
              }
              for (var c = n.view, u = n.viewFrom, d = 0; d < c.length; d++) {
                var f = c[d];
                if (f.hidden) ;else if (f.node && f.node.parentNode == o) {
                  for (; a != f.node;) a = l(a);
                  var h = i && null != t && t <= u && f.lineNumber;
                  f.changes && (_(f.changes, "gutter") > -1 && (h = !1), cr(e, f, u, r)), h && (N(f.lineNumber), f.lineNumber.appendChild(document.createTextNode(Qe(e.options, u)))), a = f.node.nextSibling;
                } else {
                  var p = gr(e, f, u, r);
                  o.insertBefore(p, a);
                }
                u += f.size;
              }
              for (; a;) a = l(a);
            }(e, r.updateLineNumbers, t.dims), c > 4 && (r.lineDiv.style.display = ""), r.renderedView = r.view, function (e) {
              if (e && e.activeElt && e.activeElt != D() && (e.activeElt.focus(), !/^(INPUT|TEXTAREA)$/.test(e.activeElt.nodeName) && e.anchorNode && O(document.body, e.anchorNode) && O(document.body, e.focusNode))) {
                var t = window.getSelection(),
                  r = document.createRange();
                r.setEnd(e.anchorNode, e.anchorOffset), r.collapse(!1), t.removeAllRanges(), t.addRange(r), t.extend(e.focusNode, e.focusOffset);
              }
            }(u), N(r.cursorDiv), N(r.selectionDiv), r.gutters.style.height = r.sizer.style.minHeight = 0, l && (r.lastWrapHeight = t.wrapperHeight, r.lastWrapWidth = t.wrapperWidth, ni(e, 400)), r.updateLineNumbers = null, !0;
          }
          function li(e, t) {
            for (var r = t.viewport, n = !0;; n = !1) {
              if (n && e.options.lineWrapping && t.oldDisplayWidth != Lr(e)) n && (t.visible = En(e.display, e.doc, r));else if (r && null != r.top && (r = {
                top: Math.min(e.doc.height + Cr(e.display) - Nr(e), r.top)
              }), t.visible = En(e.display, e.doc, r), t.visible.from >= e.display.viewFrom && t.visible.to <= e.display.viewTo) break;
              if (!ai(e, t)) break;
              Ln(e);
              var i = Fn(e);
              gn(e), Bn(e, i), ui(e, i), t.force = !1;
            }
            t.signal(e, "update", e), e.display.viewFrom == e.display.reportedViewFrom && e.display.viewTo == e.display.reportedViewTo || (t.signal(e, "viewportChange", e, e.display.viewFrom, e.display.viewTo), e.display.reportedViewFrom = e.display.viewFrom, e.display.reportedViewTo = e.display.viewTo);
          }
          function si(e, t) {
            var r = new oi(e, t);
            if (ai(e, r)) {
              Ln(e), li(e, r);
              var n = Fn(e);
              gn(e), Bn(e, n), ui(e, n), r.finish();
            }
          }
          function ci(e) {
            var t = e.gutters.offsetWidth;
            e.sizer.style.marginLeft = t + "px", lr(e, "gutterChanged", e);
          }
          function ui(e, t) {
            e.display.sizer.style.minHeight = t.docHeight + "px", e.display.heightForcer.style.top = t.docHeight + "px", e.display.gutters.style.height = t.docHeight + e.display.barHeight + Tr(e) + "px";
          }
          function di(e) {
            var t = e.display,
              r = t.view;
            if (t.alignWidgets || t.gutters.firstChild && e.options.fixedGutter) {
              for (var n = an(t) - t.scroller.scrollLeft + e.doc.scrollLeft, i = t.gutters.offsetWidth, o = n + "px", a = 0; a < r.length; a++) if (!r[a].hidden) {
                e.options.fixedGutter && (r[a].gutter && (r[a].gutter.style.left = o), r[a].gutterBackground && (r[a].gutterBackground.style.left = o));
                var l = r[a].alignable;
                if (l) for (var s = 0; s < l.length; s++) l[s].style.left = o;
              }
              e.options.fixedGutter && (t.gutters.style.left = n + i + "px");
            }
          }
          function fi(e) {
            if (!e.options.lineNumbers) return !1;
            var t = e.doc,
              r = Qe(e.options, t.first + t.size - 1),
              n = e.display;
            if (r.length != n.lineNumChars) {
              var i = n.measure.appendChild(M("div", [M("div", r)], "CodeMirror-linenumber CodeMirror-gutter-elt")),
                o = i.firstChild.offsetWidth,
                a = i.offsetWidth - o;
              return n.lineGutter.style.width = "", n.lineNumInnerWidth = Math.max(o, n.lineGutter.offsetWidth - a) + 1, n.lineNumWidth = n.lineNumInnerWidth + a, n.lineNumChars = n.lineNumInnerWidth ? r.length : -1, n.lineGutter.style.width = n.lineNumWidth + "px", ci(e.display), !0;
            }
            return !1;
          }
          function hi(e, t) {
            for (var r = [], n = !1, i = 0; i < e.length; i++) {
              var o = e[i],
                a = null;
              if ("string" != typeof o && (a = o.style, o = o.className), "CodeMirror-linenumbers" == o) {
                if (!t) continue;
                n = !0;
              }
              r.push({
                className: o,
                style: a
              });
            }
            return t && !n && r.push({
              className: "CodeMirror-linenumbers",
              style: null
            }), r;
          }
          function pi(e) {
            var t = e.gutters,
              r = e.gutterSpecs;
            N(t), e.lineGutter = null;
            for (var n = 0; n < r.length; ++n) {
              var i = r[n],
                o = i.className,
                a = i.style,
                l = t.appendChild(M("div", null, "CodeMirror-gutter " + o));
              a && (l.style.cssText = a), "CodeMirror-linenumbers" == o && (e.lineGutter = l, l.style.width = (e.lineNumWidth || 1) + "px");
            }
            t.style.display = r.length ? "" : "none", ci(e);
          }
          function mi(e) {
            pi(e.display), dn(e), di(e);
          }
          function gi(e, t, n, i) {
            var o = this;
            this.input = n, o.scrollbarFiller = M("div", null, "CodeMirror-scrollbar-filler"), o.scrollbarFiller.setAttribute("cm-not-content", "true"), o.gutterFiller = M("div", null, "CodeMirror-gutter-filler"), o.gutterFiller.setAttribute("cm-not-content", "true"), o.lineDiv = A("div", null, "CodeMirror-code"), o.selectionDiv = M("div", null, null, "position: relative; z-index: 1"), o.cursorDiv = M("div", null, "CodeMirror-cursors"), o.measure = M("div", null, "CodeMirror-measure"), o.lineMeasure = M("div", null, "CodeMirror-measure"), o.lineSpace = A("div", [o.measure, o.lineMeasure, o.selectionDiv, o.cursorDiv, o.lineDiv], null, "position: relative; outline: none");
            var c = A("div", [o.lineSpace], "CodeMirror-lines");
            o.mover = M("div", [c], null, "position: relative"), o.sizer = M("div", [o.mover], "CodeMirror-sizer"), o.sizerWidth = null, o.heightForcer = M("div", null, null, "position: absolute; height: 50px; width: 1px;"), o.gutters = M("div", null, "CodeMirror-gutters"), o.lineGutter = null, o.scroller = M("div", [o.sizer, o.heightForcer, o.gutters], "CodeMirror-scroll"), o.scroller.setAttribute("tabIndex", "-1"), o.wrapper = M("div", [o.scrollbarFiller, o.gutterFiller, o.scroller], "CodeMirror"), o.wrapper.setAttribute("translate", "no"), a && l < 8 && (o.gutters.style.zIndex = -1, o.scroller.style.paddingRight = 0), s || r && v || (o.scroller.draggable = !0), e && (e.appendChild ? e.appendChild(o.wrapper) : e(o.wrapper)), o.viewFrom = o.viewTo = t.first, o.reportedViewFrom = o.reportedViewTo = t.first, o.view = [], o.renderedView = null, o.externalMeasured = null, o.viewOffset = 0, o.lastWrapHeight = o.lastWrapWidth = 0, o.updateLineNumbers = null, o.nativeBarWidth = o.barHeight = o.barWidth = 0, o.scrollbarsClipped = !1, o.lineNumWidth = o.lineNumInnerWidth = o.lineNumChars = null, o.alignWidgets = !1, o.cachedCharWidth = o.cachedTextHeight = o.cachedPaddingH = null, o.maxLine = null, o.maxLineLength = 0, o.maxLineChanged = !1, o.wheelDX = o.wheelDY = o.wheelStartX = o.wheelStartY = null, o.shift = !1, o.selForContextMenu = null, o.activeTouch = null, o.gutterSpecs = hi(i.gutters, i.lineNumbers), pi(o), n.init(o);
          }
          oi.prototype.signal = function (e, t) {
            ve(e, t) && this.events.push(arguments);
          }, oi.prototype.finish = function () {
            for (var e = 0; e < this.events.length; e++) pe.apply(null, this.events[e]);
          };
          var vi = 0,
            yi = null;
          function bi(e) {
            var t = e.wheelDeltaX,
              r = e.wheelDeltaY;
            return null == t && e.detail && e.axis == e.HORIZONTAL_AXIS && (t = e.detail), null == r && e.detail && e.axis == e.VERTICAL_AXIS ? r = e.detail : null == r && (r = e.wheelDelta), {
              x: t,
              y: r
            };
          }
          function xi(e) {
            var t = bi(e);
            return t.x *= yi, t.y *= yi, t;
          }
          function wi(e, t) {
            var n = bi(t),
              i = n.x,
              o = n.y,
              a = yi;
            0 === t.deltaMode && (i = t.deltaX, o = t.deltaY, a = 1);
            var l = e.display,
              c = l.scroller,
              u = c.scrollWidth > c.clientWidth,
              f = c.scrollHeight > c.clientHeight;
            if (i && u || o && f) {
              if (o && y && s) e: for (var h = t.target, p = l.view; h != c; h = h.parentNode) for (var m = 0; m < p.length; m++) if (p[m].node == h) {
                e.display.currentWheelTarget = h;
                break e;
              }
              if (i && !r && !d && null != a) return o && f && In(e, Math.max(0, c.scrollTop + o * a)), Hn(e, Math.max(0, c.scrollLeft + i * a)), (!o || o && f) && be(t), void (l.wheelStartX = null);
              if (o && null != a) {
                var g = o * a,
                  v = e.doc.scrollTop,
                  b = v + l.wrapper.clientHeight;
                g < 0 ? v = Math.max(0, v + g - 50) : b = Math.min(e.doc.height, b + g + 50), si(e, {
                  top: v,
                  bottom: b
                });
              }
              vi < 20 && 0 !== t.deltaMode && (null == l.wheelStartX ? (l.wheelStartX = c.scrollLeft, l.wheelStartY = c.scrollTop, l.wheelDX = i, l.wheelDY = o, setTimeout(function () {
                if (null != l.wheelStartX) {
                  var e = c.scrollLeft - l.wheelStartX,
                    t = c.scrollTop - l.wheelStartY,
                    r = t && l.wheelDY && t / l.wheelDY || e && l.wheelDX && e / l.wheelDX;
                  l.wheelStartX = l.wheelStartY = null, r && (yi = (yi * vi + r) / (vi + 1), ++vi);
                }
              }, 200)) : (l.wheelDX += i, l.wheelDY += o));
            }
          }
          a ? yi = -.53 : r ? yi = 15 : u ? yi = -.7 : f && (yi = -1 / 3);
          var ki = function (e, t) {
            this.ranges = e, this.primIndex = t;
          };
          ki.prototype.primary = function () {
            return this.ranges[this.primIndex];
          }, ki.prototype.equals = function (e) {
            if (e == this) return !0;
            if (e.primIndex != this.primIndex || e.ranges.length != this.ranges.length) return !1;
            for (var t = 0; t < this.ranges.length; t++) {
              var r = this.ranges[t],
                n = e.ranges[t];
              if (!rt(r.anchor, n.anchor) || !rt(r.head, n.head)) return !1;
            }
            return !0;
          }, ki.prototype.deepCopy = function () {
            for (var e = [], t = 0; t < this.ranges.length; t++) e[t] = new Ci(nt(this.ranges[t].anchor), nt(this.ranges[t].head));
            return new ki(e, this.primIndex);
          }, ki.prototype.somethingSelected = function () {
            for (var e = 0; e < this.ranges.length; e++) if (!this.ranges[e].empty()) return !0;
            return !1;
          }, ki.prototype.contains = function (e, t) {
            t || (t = e);
            for (var r = 0; r < this.ranges.length; r++) {
              var n = this.ranges[r];
              if (tt(t, n.from()) >= 0 && tt(e, n.to()) <= 0) return r;
            }
            return -1;
          };
          var Ci = function (e, t) {
            this.anchor = e, this.head = t;
          };
          function Si(e, t, r) {
            var n = e && e.options.selectionsMayTouch,
              i = t[r];
            t.sort(function (e, t) {
              return tt(e.from(), t.from());
            }), r = _(t, i);
            for (var o = 1; o < t.length; o++) {
              var a = t[o],
                l = t[o - 1],
                s = tt(l.to(), a.from());
              if (n && !a.empty() ? s > 0 : s >= 0) {
                var c = ot(l.from(), a.from()),
                  u = it(l.to(), a.to()),
                  d = l.empty() ? a.from() == a.head : l.from() == l.head;
                o <= r && --r, t.splice(--o, 2, new Ci(d ? u : c, d ? c : u));
              }
            }
            return new ki(t, r);
          }
          function Ti(e, t) {
            return new ki([new Ci(e, t || e)], 0);
          }
          function Li(e) {
            return e.text ? et(e.from.line + e.text.length - 1, X(e.text).length + (1 == e.text.length ? e.from.ch : 0)) : e.to;
          }
          function Ni(e, t) {
            if (tt(e, t.from) < 0) return e;
            if (tt(e, t.to) <= 0) return Li(t);
            var r = e.line + t.text.length - (t.to.line - t.from.line) - 1,
              n = e.ch;
            return e.line == t.to.line && (n += Li(t).ch - t.to.ch), et(r, n);
          }
          function Ei(e, t) {
            for (var r = [], n = 0; n < e.sel.ranges.length; n++) {
              var i = e.sel.ranges[n];
              r.push(new Ci(Ni(i.anchor, t), Ni(i.head, t)));
            }
            return Si(e.cm, r, e.sel.primIndex);
          }
          function Mi(e, t, r) {
            return e.line == t.line ? et(r.line, e.ch - t.ch + r.ch) : et(r.line + (e.line - t.line), e.ch);
          }
          function Ai(e) {
            e.doc.mode = ze(e.options, e.doc.modeOption), Oi(e);
          }
          function Oi(e) {
            e.doc.iter(function (e) {
              e.stateAfter && (e.stateAfter = null), e.styles && (e.styles = null);
            }), e.doc.modeFrontier = e.doc.highlightFrontier = e.doc.first, ni(e, 100), e.state.modeGen++, e.curOp && dn(e);
          }
          function Di(e, t) {
            return 0 == t.from.ch && 0 == t.to.ch && "" == X(t.text) && (!e.cm || e.cm.options.wholeLineUpdateBefore);
          }
          function Ri(e, t, r, n) {
            function i(e) {
              return r ? r[e] : null;
            }
            function o(e, r, i) {
              (function (e, t, r, n) {
                e.text = t, e.stateAfter && (e.stateAfter = null), e.styles && (e.styles = null), null != e.order && (e.order = null), Et(e), Mt(e, r);
                var i = n ? n(e) : 1;
                i != e.height && qe(e, i);
              })(e, r, i, n), lr(e, "change", e, t);
            }
            function a(e, t) {
              for (var r = [], o = e; o < t; ++o) r.push(new Kt(c[o], i(o), n));
              return r;
            }
            var l = t.from,
              s = t.to,
              c = t.text,
              u = Ke(e, l.line),
              d = Ke(e, s.line),
              f = X(c),
              h = i(c.length - 1),
              p = s.line - l.line;
            if (t.full) e.insert(0, a(0, c.length)), e.remove(c.length, e.size - c.length);else if (Di(e, t)) {
              var m = a(0, c.length - 1);
              o(d, d.text, h), p && e.remove(l.line, p), m.length && e.insert(l.line, m);
            } else if (u == d) {
              if (1 == c.length) o(u, u.text.slice(0, l.ch) + f + u.text.slice(s.ch), h);else {
                var g = a(1, c.length - 1);
                g.push(new Kt(f + u.text.slice(s.ch), h, n)), o(u, u.text.slice(0, l.ch) + c[0], i(0)), e.insert(l.line + 1, g);
              }
            } else if (1 == c.length) o(u, u.text.slice(0, l.ch) + c[0] + d.text.slice(s.ch), i(0)), e.remove(l.line + 1, p);else {
              o(u, u.text.slice(0, l.ch) + c[0], i(0)), o(d, f + d.text.slice(s.ch), h);
              var v = a(1, c.length - 1);
              p > 1 && e.remove(l.line + 1, p - 1), e.insert(l.line + 1, v);
            }
            lr(e, "change", e, t);
          }
          function Wi(e, t, r) {
            !function e(n, i, o) {
              if (n.linked) for (var a = 0; a < n.linked.length; ++a) {
                var l = n.linked[a];
                if (l.doc != i) {
                  var s = o && l.sharedHist;
                  r && !s || (t(l.doc, s), e(l.doc, n, s));
                }
              }
            }(e, null, !0);
          }
          function Ii(e, t) {
            if (t.cm) throw new Error("This document is already in use.");
            e.doc = t, t.cm = e, sn(e), Ai(e), Pi(e), e.options.direction = t.direction, e.options.lineWrapping || Vt(e), e.options.mode = t.modeOption, dn(e);
          }
          function Pi(e) {
            ("rtl" == e.doc.direction ? R : L)(e.display.lineDiv, "CodeMirror-rtl");
          }
          function Hi(e) {
            this.done = [], this.undone = [], this.undoDepth = e ? e.undoDepth : 1 / 0, this.lastModTime = this.lastSelTime = 0, this.lastOp = this.lastSelOp = null, this.lastOrigin = this.lastSelOrigin = null, this.generation = this.maxGeneration = e ? e.maxGeneration : 1;
          }
          function Fi(e, t) {
            var r = {
              from: nt(t.from),
              to: Li(t),
              text: Ye(e, t.from, t.to)
            };
            return Ui(e, r, t.from.line, t.to.line + 1), Wi(e, function (e) {
              return Ui(e, r, t.from.line, t.to.line + 1);
            }, !0), r;
          }
          function zi(e) {
            for (; e.length && X(e).ranges;) e.pop();
          }
          function _i(e, t, r, n) {
            var i = e.history;
            i.undone.length = 0;
            var o,
              a,
              l = +new Date();
            if ((i.lastOp == n || i.lastOrigin == t.origin && t.origin && ("+" == t.origin.charAt(0) && i.lastModTime > l - (e.cm ? e.cm.options.historyEventDelay : 500) || "*" == t.origin.charAt(0))) && (o = function (e, t) {
              return t ? (zi(e.done), X(e.done)) : e.done.length && !X(e.done).ranges ? X(e.done) : e.done.length > 1 && !e.done[e.done.length - 2].ranges ? (e.done.pop(), X(e.done)) : void 0;
            }(i, i.lastOp == n))) a = X(o.changes), 0 == tt(t.from, t.to) && 0 == tt(t.from, a.to) ? a.to = Li(t) : o.changes.push(Fi(e, t));else {
              var s = X(i.done);
              for (s && s.ranges || ji(e.sel, i.done), o = {
                changes: [Fi(e, t)],
                generation: i.generation
              }, i.done.push(o); i.done.length > i.undoDepth;) i.done.shift(), i.done[0].ranges || i.done.shift();
            }
            i.done.push(r), i.generation = ++i.maxGeneration, i.lastModTime = i.lastSelTime = l, i.lastOp = i.lastSelOp = n, i.lastOrigin = i.lastSelOrigin = t.origin, a || pe(e, "historyAdded");
          }
          function Bi(e, t, r, n) {
            var i = e.history,
              o = n && n.origin;
            r == i.lastSelOp || o && i.lastSelOrigin == o && (i.lastModTime == i.lastSelTime && i.lastOrigin == o || function (e, t, r, n) {
              var i = t.charAt(0);
              return "*" == i || "+" == i && r.ranges.length == n.ranges.length && r.somethingSelected() == n.somethingSelected() && new Date() - e.history.lastSelTime <= (e.cm ? e.cm.options.historyEventDelay : 500);
            }(e, o, X(i.done), t)) ? i.done[i.done.length - 1] = t : ji(t, i.done), i.lastSelTime = +new Date(), i.lastSelOrigin = o, i.lastSelOp = r, n && !1 !== n.clearRedo && zi(i.undone);
          }
          function ji(e, t) {
            var r = X(t);
            r && r.ranges && r.equals(e) || t.push(e);
          }
          function Ui(e, t, r, n) {
            var i = t["spans_" + e.id],
              o = 0;
            e.iter(Math.max(e.first, r), Math.min(e.first + e.size, n), function (r) {
              r.markedSpans && ((i || (i = t["spans_" + e.id] = {}))[o] = r.markedSpans), ++o;
            });
          }
          function Gi(e) {
            if (!e) return null;
            for (var t, r = 0; r < e.length; ++r) e[r].marker.explicitlyCleared ? t || (t = e.slice(0, r)) : t && t.push(e[r]);
            return t ? t.length ? t : null : e;
          }
          function Vi(e, t) {
            var r = function (e, t) {
                var r = t["spans_" + e.id];
                if (!r) return null;
                for (var n = [], i = 0; i < t.text.length; ++i) n.push(Gi(r[i]));
                return n;
              }(e, t),
              n = Lt(e, t);
            if (!r) return n;
            if (!n) return r;
            for (var i = 0; i < r.length; ++i) {
              var o = r[i],
                a = n[i];
              if (o && a) e: for (var l = 0; l < a.length; ++l) {
                for (var s = a[l], c = 0; c < o.length; ++c) if (o[c].marker == s.marker) continue e;
                o.push(s);
              } else a && (r[i] = a);
            }
            return r;
          }
          function Ki(e, t, r) {
            for (var n = [], i = 0; i < e.length; ++i) {
              var o = e[i];
              if (o.ranges) n.push(r ? ki.prototype.deepCopy.call(o) : o);else {
                var a = o.changes,
                  l = [];
                n.push({
                  changes: l
                });
                for (var s = 0; s < a.length; ++s) {
                  var c = a[s],
                    u = void 0;
                  if (l.push({
                    from: c.from,
                    to: c.to,
                    text: c.text
                  }), t) for (var d in c) (u = d.match(/^spans_(\d+)$/)) && _(t, Number(u[1])) > -1 && (X(l)[d] = c[d], delete c[d]);
                }
              }
            }
            return n;
          }
          function Yi(e, t, r, n) {
            if (n) {
              var i = e.anchor;
              if (r) {
                var o = tt(t, i) < 0;
                o != tt(r, i) < 0 ? (i = t, t = r) : o != tt(t, r) < 0 && (t = r);
              }
              return new Ci(i, t);
            }
            return new Ci(r || t, t);
          }
          function Xi(e, t, r, n, i) {
            null == i && (i = e.cm && (e.cm.display.shift || e.extend)), Qi(e, new ki([Yi(e.sel.primary(), t, r, i)], 0), n);
          }
          function qi(e, t, r) {
            for (var n = [], i = e.cm && (e.cm.display.shift || e.extend), o = 0; o < e.sel.ranges.length; o++) n[o] = Yi(e.sel.ranges[o], t[o], null, i);
            Qi(e, Si(e.cm, n, e.sel.primIndex), r);
          }
          function $i(e, t, r, n) {
            var i = e.sel.ranges.slice(0);
            i[t] = r, Qi(e, Si(e.cm, i, e.sel.primIndex), n);
          }
          function Ji(e, t, r, n) {
            Qi(e, Ti(t, r), n);
          }
          function Zi(e, t, r) {
            var n = e.history.done,
              i = X(n);
            i && i.ranges ? (n[n.length - 1] = t, eo(e, t, r)) : Qi(e, t, r);
          }
          function Qi(e, t, r) {
            eo(e, t, r), Bi(e, e.sel, e.cm ? e.cm.curOp.id : NaN, r);
          }
          function eo(e, t, r) {
            (ve(e, "beforeSelectionChange") || e.cm && ve(e.cm, "beforeSelectionChange")) && (t = function (e, t, r) {
              var n = {
                ranges: t.ranges,
                update: function (t) {
                  this.ranges = [];
                  for (var r = 0; r < t.length; r++) this.ranges[r] = new Ci(lt(e, t[r].anchor), lt(e, t[r].head));
                },
                origin: r && r.origin
              };
              return pe(e, "beforeSelectionChange", e, n), e.cm && pe(e.cm, "beforeSelectionChange", e.cm, n), n.ranges != t.ranges ? Si(e.cm, n.ranges, n.ranges.length - 1) : t;
            }(e, t, r));
            var n = r && r.bias || (tt(t.primary().head, e.sel.primary().head) < 0 ? -1 : 1);
            to(e, no(e, t, n, !0)), r && !1 === r.scroll || !e.cm || "nocursor" == e.cm.getOption("readOnly") || On(e.cm);
          }
          function to(e, t) {
            t.equals(e.sel) || (e.sel = t, e.cm && (e.cm.curOp.updateInput = 1, e.cm.curOp.selectionChanged = !0, ge(e.cm)), lr(e, "cursorActivity", e));
          }
          function ro(e) {
            to(e, no(e, e.sel, null, !1));
          }
          function no(e, t, r, n) {
            for (var i, o = 0; o < t.ranges.length; o++) {
              var a = t.ranges[o],
                l = t.ranges.length == e.sel.ranges.length && e.sel.ranges[o],
                s = oo(e, a.anchor, l && l.anchor, r, n),
                c = oo(e, a.head, l && l.head, r, n);
              (i || s != a.anchor || c != a.head) && (i || (i = t.ranges.slice(0, o)), i[o] = new Ci(s, c));
            }
            return i ? Si(e.cm, i, t.primIndex) : t;
          }
          function io(e, t, r, n, i) {
            var o = Ke(e, t.line);
            if (o.markedSpans) for (var a = 0; a < o.markedSpans.length; ++a) {
              var l = o.markedSpans[a],
                s = l.marker,
                c = "selectLeft" in s ? !s.selectLeft : s.inclusiveLeft,
                u = "selectRight" in s ? !s.selectRight : s.inclusiveRight;
              if ((null == l.from || (c ? l.from <= t.ch : l.from < t.ch)) && (null == l.to || (u ? l.to >= t.ch : l.to > t.ch))) {
                if (i && (pe(s, "beforeCursorEnter"), s.explicitlyCleared)) {
                  if (o.markedSpans) {
                    --a;
                    continue;
                  }
                  break;
                }
                if (!s.atomic) continue;
                if (r) {
                  var d = s.find(n < 0 ? 1 : -1),
                    f = void 0;
                  if ((n < 0 ? u : c) && (d = ao(e, d, -n, d && d.line == t.line ? o : null)), d && d.line == t.line && (f = tt(d, r)) && (n < 0 ? f < 0 : f > 0)) return io(e, d, t, n, i);
                }
                var h = s.find(n < 0 ? -1 : 1);
                return (n < 0 ? c : u) && (h = ao(e, h, n, h.line == t.line ? o : null)), h ? io(e, h, t, n, i) : null;
              }
            }
            return t;
          }
          function oo(e, t, r, n, i) {
            var o = n || 1;
            return io(e, t, r, o, i) || !i && io(e, t, r, o, !0) || io(e, t, r, -o, i) || !i && io(e, t, r, -o, !0) || (e.cantEdit = !0, et(e.first, 0));
          }
          function ao(e, t, r, n) {
            return r < 0 && 0 == t.ch ? t.line > e.first ? lt(e, et(t.line - 1)) : null : r > 0 && t.ch == (n || Ke(e, t.line)).text.length ? t.line < e.first + e.size - 1 ? et(t.line + 1, 0) : null : new et(t.line, t.ch + r);
          }
          function lo(e) {
            e.setSelection(et(e.firstLine(), 0), et(e.lastLine()), j);
          }
          function so(e, t, r) {
            var n = {
              canceled: !1,
              from: t.from,
              to: t.to,
              text: t.text,
              origin: t.origin,
              cancel: function () {
                return n.canceled = !0;
              }
            };
            return r && (n.update = function (t, r, i, o) {
              t && (n.from = lt(e, t)), r && (n.to = lt(e, r)), i && (n.text = i), void 0 !== o && (n.origin = o);
            }), pe(e, "beforeChange", e, n), e.cm && pe(e.cm, "beforeChange", e.cm, n), n.canceled ? (e.cm && (e.cm.curOp.updateInput = 2), null) : {
              from: n.from,
              to: n.to,
              text: n.text,
              origin: n.origin
            };
          }
          function co(e, t, r) {
            if (e.cm) {
              if (!e.cm.curOp) return ei(e.cm, co)(e, t, r);
              if (e.cm.state.suppressEdits) return;
            }
            if (!(ve(e, "beforeChange") || e.cm && ve(e.cm, "beforeChange")) || (t = so(e, t, !0))) {
              var n = wt && !r && function (e, t, r) {
                var n = null;
                if (e.iter(t.line, r.line + 1, function (e) {
                  if (e.markedSpans) for (var t = 0; t < e.markedSpans.length; ++t) {
                    var r = e.markedSpans[t].marker;
                    !r.readOnly || n && -1 != _(n, r) || (n || (n = [])).push(r);
                  }
                }), !n) return null;
                for (var i = [{
                    from: t,
                    to: r
                  }], o = 0; o < n.length; ++o) for (var a = n[o], l = a.find(0), s = 0; s < i.length; ++s) {
                  var c = i[s];
                  if (!(tt(c.to, l.from) < 0 || tt(c.from, l.to) > 0)) {
                    var u = [s, 1],
                      d = tt(c.from, l.from),
                      f = tt(c.to, l.to);
                    (d < 0 || !a.inclusiveLeft && !d) && u.push({
                      from: c.from,
                      to: l.from
                    }), (f > 0 || !a.inclusiveRight && !f) && u.push({
                      from: l.to,
                      to: c.to
                    }), i.splice.apply(i, u), s += u.length - 3;
                  }
                }
                return i;
              }(e, t.from, t.to);
              if (n) for (var i = n.length - 1; i >= 0; --i) uo(e, {
                from: n[i].from,
                to: n[i].to,
                text: i ? [""] : t.text,
                origin: t.origin
              });else uo(e, t);
            }
          }
          function uo(e, t) {
            if (1 != t.text.length || "" != t.text[0] || 0 != tt(t.from, t.to)) {
              var r = Ei(e, t);
              _i(e, t, r, e.cm ? e.cm.curOp.id : NaN), po(e, t, r, Lt(e, t));
              var n = [];
              Wi(e, function (e, r) {
                r || -1 != _(n, e.history) || (yo(e.history, t), n.push(e.history)), po(e, t, null, Lt(e, t));
              });
            }
          }
          function fo(e, t, r) {
            var n = e.cm && e.cm.state.suppressEdits;
            if (!n || r) {
              for (var i, o = e.history, a = e.sel, l = "undo" == t ? o.done : o.undone, s = "undo" == t ? o.undone : o.done, c = 0; c < l.length && (i = l[c], r ? !i.ranges || i.equals(e.sel) : i.ranges); c++);
              if (c != l.length) {
                for (o.lastOrigin = o.lastSelOrigin = null;;) {
                  if (!(i = l.pop()).ranges) {
                    if (n) return void l.push(i);
                    break;
                  }
                  if (ji(i, s), r && !i.equals(e.sel)) return void Qi(e, i, {
                    clearRedo: !1
                  });
                  a = i;
                }
                var u = [];
                ji(a, s), s.push({
                  changes: u,
                  generation: o.generation
                }), o.generation = i.generation || ++o.maxGeneration;
                for (var d = ve(e, "beforeChange") || e.cm && ve(e.cm, "beforeChange"), f = function (r) {
                    var n = i.changes[r];
                    if (n.origin = t, d && !so(e, n, !1)) return l.length = 0, {};
                    u.push(Fi(e, n));
                    var o = r ? Ei(e, n) : X(l);
                    po(e, n, o, Vi(e, n)), !r && e.cm && e.cm.scrollIntoView({
                      from: n.from,
                      to: Li(n)
                    });
                    var a = [];
                    Wi(e, function (e, t) {
                      t || -1 != _(a, e.history) || (yo(e.history, n), a.push(e.history)), po(e, n, null, Vi(e, n));
                    });
                  }, h = i.changes.length - 1; h >= 0; --h) {
                  var p = f(h);
                  if (p) return p.v;
                }
              }
            }
          }
          function ho(e, t) {
            if (0 != t && (e.first += t, e.sel = new ki(q(e.sel.ranges, function (e) {
              return new Ci(et(e.anchor.line + t, e.anchor.ch), et(e.head.line + t, e.head.ch));
            }), e.sel.primIndex), e.cm)) {
              dn(e.cm, e.first, e.first - t, t);
              for (var r = e.cm.display, n = r.viewFrom; n < r.viewTo; n++) fn(e.cm, n, "gutter");
            }
          }
          function po(e, t, r, n) {
            if (e.cm && !e.cm.curOp) return ei(e.cm, po)(e, t, r, n);
            if (t.to.line < e.first) ho(e, t.text.length - 1 - (t.to.line - t.from.line));else if (!(t.from.line > e.lastLine())) {
              if (t.from.line < e.first) {
                var i = t.text.length - 1 - (e.first - t.from.line);
                ho(e, i), t = {
                  from: et(e.first, 0),
                  to: et(t.to.line + i, t.to.ch),
                  text: [X(t.text)],
                  origin: t.origin
                };
              }
              var o = e.lastLine();
              t.to.line > o && (t = {
                from: t.from,
                to: et(o, Ke(e, o).text.length),
                text: [t.text[0]],
                origin: t.origin
              }), t.removed = Ye(e, t.from, t.to), r || (r = Ei(e, t)), e.cm ? function (e, t, r) {
                var n = e.doc,
                  i = e.display,
                  o = t.from,
                  a = t.to,
                  l = !1,
                  s = o.line;
                e.options.lineWrapping || (s = $e(Ft(Ke(n, o.line))), n.iter(s, a.line + 1, function (e) {
                  if (e == i.maxLine) return l = !0, !0;
                })), n.sel.contains(t.from, t.to) > -1 && ge(e), Ri(n, t, r, ln(e)), e.options.lineWrapping || (n.iter(s, o.line + t.text.length, function (e) {
                  var t = Gt(e);
                  t > i.maxLineLength && (i.maxLine = e, i.maxLineLength = t, i.maxLineChanged = !0, l = !1);
                }), l && (e.curOp.updateMaxLine = !0)), function (e, t) {
                  if (e.modeFrontier = Math.min(e.modeFrontier, t), !(e.highlightFrontier < t - 10)) {
                    for (var r = e.first, n = t - 1; n > r; n--) {
                      var i = Ke(e, n).stateAfter;
                      if (i && (!(i instanceof ct) || n + i.lookAhead < t)) {
                        r = n + 1;
                        break;
                      }
                    }
                    e.highlightFrontier = Math.min(e.highlightFrontier, r);
                  }
                }(n, o.line), ni(e, 400);
                var c = t.text.length - (a.line - o.line) - 1;
                t.full ? dn(e) : o.line != a.line || 1 != t.text.length || Di(e.doc, t) ? dn(e, o.line, a.line + 1, c) : fn(e, o.line, "text");
                var u = ve(e, "changes"),
                  d = ve(e, "change");
                if (d || u) {
                  var f = {
                    from: o,
                    to: a,
                    text: t.text,
                    removed: t.removed,
                    origin: t.origin
                  };
                  d && lr(e, "change", e, f), u && (e.curOp.changeObjs || (e.curOp.changeObjs = [])).push(f);
                }
                e.display.selForContextMenu = null;
              }(e.cm, t, n) : Ri(e, t, n), eo(e, r, j), e.cantEdit && oo(e, et(e.firstLine(), 0)) && (e.cantEdit = !1);
            }
          }
          function mo(e, t, r, n, i) {
            var o;
            n || (n = r), tt(n, r) < 0 && (r = (o = [n, r])[0], n = o[1]), "string" == typeof t && (t = e.splitLines(t)), co(e, {
              from: r,
              to: n,
              text: t,
              origin: i
            });
          }
          function go(e, t, r, n) {
            r < e.line ? e.line += n : t < e.line && (e.line = t, e.ch = 0);
          }
          function vo(e, t, r, n) {
            for (var i = 0; i < e.length; ++i) {
              var o = e[i],
                a = !0;
              if (o.ranges) {
                o.copied || ((o = e[i] = o.deepCopy()).copied = !0);
                for (var l = 0; l < o.ranges.length; l++) go(o.ranges[l].anchor, t, r, n), go(o.ranges[l].head, t, r, n);
              } else {
                for (var s = 0; s < o.changes.length; ++s) {
                  var c = o.changes[s];
                  if (r < c.from.line) c.from = et(c.from.line + n, c.from.ch), c.to = et(c.to.line + n, c.to.ch);else if (t <= c.to.line) {
                    a = !1;
                    break;
                  }
                }
                a || (e.splice(0, i + 1), i = 0);
              }
            }
          }
          function yo(e, t) {
            var r = t.from.line,
              n = t.to.line,
              i = t.text.length - (n - r) - 1;
            vo(e.done, r, n, i), vo(e.undone, r, n, i);
          }
          function bo(e, t, r, n) {
            var i = t,
              o = t;
            return "number" == typeof t ? o = Ke(e, at(e, t)) : i = $e(t), null == i ? null : (n(o, i) && e.cm && fn(e.cm, i, r), o);
          }
          function xo(e) {
            this.lines = e, this.parent = null;
            for (var t = 0, r = 0; r < e.length; ++r) e[r].parent = this, t += e[r].height;
            this.height = t;
          }
          function wo(e) {
            this.children = e;
            for (var t = 0, r = 0, n = 0; n < e.length; ++n) {
              var i = e[n];
              t += i.chunkSize(), r += i.height, i.parent = this;
            }
            this.size = t, this.height = r, this.parent = null;
          }
          Ci.prototype.from = function () {
            return ot(this.anchor, this.head);
          }, Ci.prototype.to = function () {
            return it(this.anchor, this.head);
          }, Ci.prototype.empty = function () {
            return this.head.line == this.anchor.line && this.head.ch == this.anchor.ch;
          }, xo.prototype = {
            chunkSize: function () {
              return this.lines.length;
            },
            removeInner: function (e, t) {
              for (var r = e, n = e + t; r < n; ++r) {
                var i = this.lines[r];
                this.height -= i.height, Yt(i), lr(i, "delete");
              }
              this.lines.splice(e, t);
            },
            collapse: function (e) {
              e.push.apply(e, this.lines);
            },
            insertInner: function (e, t, r) {
              this.height += r, this.lines = this.lines.slice(0, e).concat(t).concat(this.lines.slice(e));
              for (var n = 0; n < t.length; ++n) t[n].parent = this;
            },
            iterN: function (e, t, r) {
              for (var n = e + t; e < n; ++e) if (r(this.lines[e])) return !0;
            }
          }, wo.prototype = {
            chunkSize: function () {
              return this.size;
            },
            removeInner: function (e, t) {
              this.size -= t;
              for (var r = 0; r < this.children.length; ++r) {
                var n = this.children[r],
                  i = n.chunkSize();
                if (e < i) {
                  var o = Math.min(t, i - e),
                    a = n.height;
                  if (n.removeInner(e, o), this.height -= a - n.height, i == o && (this.children.splice(r--, 1), n.parent = null), 0 == (t -= o)) break;
                  e = 0;
                } else e -= i;
              }
              if (this.size - t < 25 && (this.children.length > 1 || !(this.children[0] instanceof xo))) {
                var l = [];
                this.collapse(l), this.children = [new xo(l)], this.children[0].parent = this;
              }
            },
            collapse: function (e) {
              for (var t = 0; t < this.children.length; ++t) this.children[t].collapse(e);
            },
            insertInner: function (e, t, r) {
              this.size += t.length, this.height += r;
              for (var n = 0; n < this.children.length; ++n) {
                var i = this.children[n],
                  o = i.chunkSize();
                if (e <= o) {
                  if (i.insertInner(e, t, r), i.lines && i.lines.length > 50) {
                    for (var a = i.lines.length % 25 + 25, l = a; l < i.lines.length;) {
                      var s = new xo(i.lines.slice(l, l += 25));
                      i.height -= s.height, this.children.splice(++n, 0, s), s.parent = this;
                    }
                    i.lines = i.lines.slice(0, a), this.maybeSpill();
                  }
                  break;
                }
                e -= o;
              }
            },
            maybeSpill: function () {
              if (!(this.children.length <= 10)) {
                var e = this;
                do {
                  var t = new wo(e.children.splice(e.children.length - 5, 5));
                  if (e.parent) {
                    e.size -= t.size, e.height -= t.height;
                    var r = _(e.parent.children, e);
                    e.parent.children.splice(r + 1, 0, t);
                  } else {
                    var n = new wo(e.children);
                    n.parent = e, e.children = [n, t], e = n;
                  }
                  t.parent = e.parent;
                } while (e.children.length > 10);
                e.parent.maybeSpill();
              }
            },
            iterN: function (e, t, r) {
              for (var n = 0; n < this.children.length; ++n) {
                var i = this.children[n],
                  o = i.chunkSize();
                if (e < o) {
                  var a = Math.min(t, o - e);
                  if (i.iterN(e, a, r)) return !0;
                  if (0 == (t -= a)) break;
                  e = 0;
                } else e -= o;
              }
            }
          };
          var ko = function (e, t, r) {
            if (r) for (var n in r) r.hasOwnProperty(n) && (this[n] = r[n]);
            this.doc = e, this.node = t;
          };
          function Co(e, t, r) {
            Ut(t) < (e.curOp && e.curOp.scrollTop || e.doc.scrollTop) && An(e, r);
          }
          ko.prototype.clear = function () {
            var e = this.doc.cm,
              t = this.line.widgets,
              r = this.line,
              n = $e(r);
            if (null != n && t) {
              for (var i = 0; i < t.length; ++i) t[i] == this && t.splice(i--, 1);
              t.length || (r.widgets = null);
              var o = xr(this);
              qe(r, Math.max(0, r.height - o)), e && (Qn(e, function () {
                Co(e, r, -o), fn(e, n, "widget");
              }), lr(e, "lineWidgetCleared", e, this, n));
            }
          }, ko.prototype.changed = function () {
            var e = this,
              t = this.height,
              r = this.doc.cm,
              n = this.line;
            this.height = null;
            var i = xr(this) - t;
            i && (Bt(this.doc, n) || qe(n, n.height + i), r && Qn(r, function () {
              r.curOp.forceUpdate = !0, Co(r, n, i), lr(r, "lineWidgetChanged", r, e, $e(n));
            }));
          }, ye(ko);
          var So = 0,
            To = function (e, t) {
              this.lines = [], this.type = t, this.doc = e, this.id = ++So;
            };
          function Lo(e, t, r, n, i) {
            if (n && n.shared) return function (e, t, r, n, i) {
              (n = H(n)).shared = !1;
              var o = [Lo(e, t, r, n, i)],
                a = o[0],
                l = n.widgetNode;
              return Wi(e, function (e) {
                l && (n.widgetNode = l.cloneNode(!0)), o.push(Lo(e, lt(e, t), lt(e, r), n, i));
                for (var s = 0; s < e.linked.length; ++s) if (e.linked[s].isParent) return;
                a = X(o);
              }), new No(o, a);
            }(e, t, r, n, i);
            if (e.cm && !e.cm.curOp) return ei(e.cm, Lo)(e, t, r, n, i);
            var o = new To(e, i),
              a = tt(t, r);
            if (n && H(n, o, !1), a > 0 || 0 == a && !1 !== o.clearWhenEmpty) return o;
            if (o.replacedWith && (o.collapsed = !0, o.widgetNode = A("span", [o.replacedWith], "CodeMirror-widget"), n.handleMouseEvents || o.widgetNode.setAttribute("cm-ignore-events", "true"), n.insertLeft && (o.widgetNode.insertLeft = !0)), o.collapsed) {
              if (Ht(e, t.line, t, r, o) || t.line != r.line && Ht(e, r.line, t, r, o)) throw new Error("Inserting collapsed marker partially overlapping an existing one");
              kt = !0;
            }
            o.addToHistory && _i(e, {
              from: t,
              to: r,
              origin: "markText"
            }, e.sel, NaN);
            var l,
              s = t.line,
              c = e.cm;
            if (e.iter(s, r.line + 1, function (n) {
              c && o.collapsed && !c.options.lineWrapping && Ft(n) == c.display.maxLine && (l = !0), o.collapsed && s != t.line && qe(n, 0), function (e, t, r) {
                var n = r && window.WeakSet && (r.markedSpans || (r.markedSpans = new WeakSet()));
                n && n.has(e.markedSpans) ? e.markedSpans.push(t) : (e.markedSpans = e.markedSpans ? e.markedSpans.concat([t]) : [t], n && n.add(e.markedSpans)), t.marker.attachLine(e);
              }(n, new Ct(o, s == t.line ? t.ch : null, s == r.line ? r.ch : null), e.cm && e.cm.curOp), ++s;
            }), o.collapsed && e.iter(t.line, r.line + 1, function (t) {
              Bt(e, t) && qe(t, 0);
            }), o.clearOnEnter && de(o, "beforeCursorEnter", function () {
              return o.clear();
            }), o.readOnly && (wt = !0, (e.history.done.length || e.history.undone.length) && e.clearHistory()), o.collapsed && (o.id = ++So, o.atomic = !0), c) {
              if (l && (c.curOp.updateMaxLine = !0), o.collapsed) dn(c, t.line, r.line + 1);else if (o.className || o.startStyle || o.endStyle || o.css || o.attributes || o.title) for (var u = t.line; u <= r.line; u++) fn(c, u, "text");
              o.atomic && ro(c.doc), lr(c, "markerAdded", c, o);
            }
            return o;
          }
          To.prototype.clear = function () {
            if (!this.explicitlyCleared) {
              var e = this.doc.cm,
                t = e && !e.curOp;
              if (t && Kn(e), ve(this, "clear")) {
                var r = this.find();
                r && lr(this, "clear", r.from, r.to);
              }
              for (var n = null, i = null, o = 0; o < this.lines.length; ++o) {
                var a = this.lines[o],
                  l = St(a.markedSpans, this);
                e && !this.collapsed ? fn(e, $e(a), "text") : e && (null != l.to && (i = $e(a)), null != l.from && (n = $e(a))), a.markedSpans = Tt(a.markedSpans, l), null == l.from && this.collapsed && !Bt(this.doc, a) && e && qe(a, rn(e.display));
              }
              if (e && this.collapsed && !e.options.lineWrapping) for (var s = 0; s < this.lines.length; ++s) {
                var c = Ft(this.lines[s]),
                  u = Gt(c);
                u > e.display.maxLineLength && (e.display.maxLine = c, e.display.maxLineLength = u, e.display.maxLineChanged = !0);
              }
              null != n && e && this.collapsed && dn(e, n, i + 1), this.lines.length = 0, this.explicitlyCleared = !0, this.atomic && this.doc.cantEdit && (this.doc.cantEdit = !1, e && ro(e.doc)), e && lr(e, "markerCleared", e, this, n, i), t && Yn(e), this.parent && this.parent.clear();
            }
          }, To.prototype.find = function (e, t) {
            var r, n;
            null == e && "bookmark" == this.type && (e = 1);
            for (var i = 0; i < this.lines.length; ++i) {
              var o = this.lines[i],
                a = St(o.markedSpans, this);
              if (null != a.from && (r = et(t ? o : $e(o), a.from), -1 == e)) return r;
              if (null != a.to && (n = et(t ? o : $e(o), a.to), 1 == e)) return n;
            }
            return r && {
              from: r,
              to: n
            };
          }, To.prototype.changed = function () {
            var e = this,
              t = this.find(-1, !0),
              r = this,
              n = this.doc.cm;
            t && n && Qn(n, function () {
              var i = t.line,
                o = $e(t.line),
                a = Ar(n, o);
              if (a && (Hr(a), n.curOp.selectionChanged = n.curOp.forceUpdate = !0), n.curOp.updateMaxLine = !0, !Bt(r.doc, i) && null != r.height) {
                var l = r.height;
                r.height = null;
                var s = xr(r) - l;
                s && qe(i, i.height + s);
              }
              lr(n, "markerChanged", n, e);
            });
          }, To.prototype.attachLine = function (e) {
            if (!this.lines.length && this.doc.cm) {
              var t = this.doc.cm.curOp;
              t.maybeHiddenMarkers && -1 != _(t.maybeHiddenMarkers, this) || (t.maybeUnhiddenMarkers || (t.maybeUnhiddenMarkers = [])).push(this);
            }
            this.lines.push(e);
          }, To.prototype.detachLine = function (e) {
            if (this.lines.splice(_(this.lines, e), 1), !this.lines.length && this.doc.cm) {
              var t = this.doc.cm.curOp;
              (t.maybeHiddenMarkers || (t.maybeHiddenMarkers = [])).push(this);
            }
          }, ye(To);
          var No = function (e, t) {
            this.markers = e, this.primary = t;
            for (var r = 0; r < e.length; ++r) e[r].parent = this;
          };
          function Eo(e) {
            return e.findMarks(et(e.first, 0), e.clipPos(et(e.lastLine())), function (e) {
              return e.parent;
            });
          }
          function Mo(e) {
            for (var t = function (t) {
                var r = e[t],
                  n = [r.primary.doc];
                Wi(r.primary.doc, function (e) {
                  return n.push(e);
                });
                for (var i = 0; i < r.markers.length; i++) {
                  var o = r.markers[i];
                  -1 == _(n, o.doc) && (o.parent = null, r.markers.splice(i--, 1));
                }
              }, r = 0; r < e.length; r++) t(r);
          }
          No.prototype.clear = function () {
            if (!this.explicitlyCleared) {
              this.explicitlyCleared = !0;
              for (var e = 0; e < this.markers.length; ++e) this.markers[e].clear();
              lr(this, "clear");
            }
          }, No.prototype.find = function (e, t) {
            return this.primary.find(e, t);
          }, ye(No);
          var Ao = 0,
            Oo = function (e, t, r, n, i) {
              if (!(this instanceof Oo)) return new Oo(e, t, r, n, i);
              null == r && (r = 0), wo.call(this, [new xo([new Kt("", null)])]), this.first = r, this.scrollTop = this.scrollLeft = 0, this.cantEdit = !1, this.cleanGeneration = 1, this.modeFrontier = this.highlightFrontier = r;
              var o = et(r, 0);
              this.sel = Ti(o), this.history = new Hi(null), this.id = ++Ao, this.modeOption = t, this.lineSep = n, this.direction = "rtl" == i ? "rtl" : "ltr", this.extend = !1, "string" == typeof e && (e = this.splitLines(e)), Ri(this, {
                from: o,
                to: o,
                text: e
              }), Qi(this, Ti(o), j);
            };
          Oo.prototype = J(wo.prototype, {
            constructor: Oo,
            iter: function (e, t, r) {
              r ? this.iterN(e - this.first, t - e, r) : this.iterN(this.first, this.first + this.size, e);
            },
            insert: function (e, t) {
              for (var r = 0, n = 0; n < t.length; ++n) r += t[n].height;
              this.insertInner(e - this.first, t, r);
            },
            remove: function (e, t) {
              this.removeInner(e - this.first, t);
            },
            getValue: function (e) {
              var t = Xe(this, this.first, this.first + this.size);
              return !1 === e ? t : t.join(e || this.lineSeparator());
            },
            setValue: ri(function (e) {
              var t = et(this.first, 0),
                r = this.first + this.size - 1;
              co(this, {
                from: t,
                to: et(r, Ke(this, r).text.length),
                text: this.splitLines(e),
                origin: "setValue",
                full: !0
              }, !0), this.cm && Dn(this.cm, 0, 0), Qi(this, Ti(t), j);
            }),
            replaceRange: function (e, t, r, n) {
              mo(this, e, t = lt(this, t), r = r ? lt(this, r) : t, n);
            },
            getRange: function (e, t, r) {
              var n = Ye(this, lt(this, e), lt(this, t));
              return !1 === r ? n : "" === r ? n.join("") : n.join(r || this.lineSeparator());
            },
            getLine: function (e) {
              var t = this.getLineHandle(e);
              return t && t.text;
            },
            getLineHandle: function (e) {
              if (Ze(this, e)) return Ke(this, e);
            },
            getLineNumber: function (e) {
              return $e(e);
            },
            getLineHandleVisualStart: function (e) {
              return "number" == typeof e && (e = Ke(this, e)), Ft(e);
            },
            lineCount: function () {
              return this.size;
            },
            firstLine: function () {
              return this.first;
            },
            lastLine: function () {
              return this.first + this.size - 1;
            },
            clipPos: function (e) {
              return lt(this, e);
            },
            getCursor: function (e) {
              var t = this.sel.primary();
              return null == e || "head" == e ? t.head : "anchor" == e ? t.anchor : "end" == e || "to" == e || !1 === e ? t.to() : t.from();
            },
            listSelections: function () {
              return this.sel.ranges;
            },
            somethingSelected: function () {
              return this.sel.somethingSelected();
            },
            setCursor: ri(function (e, t, r) {
              Ji(this, lt(this, "number" == typeof e ? et(e, t || 0) : e), null, r);
            }),
            setSelection: ri(function (e, t, r) {
              Ji(this, lt(this, e), lt(this, t || e), r);
            }),
            extendSelection: ri(function (e, t, r) {
              Xi(this, lt(this, e), t && lt(this, t), r);
            }),
            extendSelections: ri(function (e, t) {
              qi(this, st(this, e), t);
            }),
            extendSelectionsBy: ri(function (e, t) {
              qi(this, st(this, q(this.sel.ranges, e)), t);
            }),
            setSelections: ri(function (e, t, r) {
              if (e.length) {
                for (var n = [], i = 0; i < e.length; i++) n[i] = new Ci(lt(this, e[i].anchor), lt(this, e[i].head || e[i].anchor));
                null == t && (t = Math.min(e.length - 1, this.sel.primIndex)), Qi(this, Si(this.cm, n, t), r);
              }
            }),
            addSelection: ri(function (e, t, r) {
              var n = this.sel.ranges.slice(0);
              n.push(new Ci(lt(this, e), lt(this, t || e))), Qi(this, Si(this.cm, n, n.length - 1), r);
            }),
            getSelection: function (e) {
              for (var t, r = this.sel.ranges, n = 0; n < r.length; n++) {
                var i = Ye(this, r[n].from(), r[n].to());
                t = t ? t.concat(i) : i;
              }
              return !1 === e ? t : t.join(e || this.lineSeparator());
            },
            getSelections: function (e) {
              for (var t = [], r = this.sel.ranges, n = 0; n < r.length; n++) {
                var i = Ye(this, r[n].from(), r[n].to());
                !1 !== e && (i = i.join(e || this.lineSeparator())), t[n] = i;
              }
              return t;
            },
            replaceSelection: function (e, t, r) {
              for (var n = [], i = 0; i < this.sel.ranges.length; i++) n[i] = e;
              this.replaceSelections(n, t, r || "+input");
            },
            replaceSelections: ri(function (e, t, r) {
              for (var n = [], i = this.sel, o = 0; o < i.ranges.length; o++) {
                var a = i.ranges[o];
                n[o] = {
                  from: a.from(),
                  to: a.to(),
                  text: this.splitLines(e[o]),
                  origin: r
                };
              }
              for (var l = t && "end" != t && function (e, t, r) {
                  for (var n = [], i = et(e.first, 0), o = i, a = 0; a < t.length; a++) {
                    var l = t[a],
                      s = Mi(l.from, i, o),
                      c = Mi(Li(l), i, o);
                    if (i = l.to, o = c, "around" == r) {
                      var u = e.sel.ranges[a],
                        d = tt(u.head, u.anchor) < 0;
                      n[a] = new Ci(d ? c : s, d ? s : c);
                    } else n[a] = new Ci(s, s);
                  }
                  return new ki(n, e.sel.primIndex);
                }(this, n, t), s = n.length - 1; s >= 0; s--) co(this, n[s]);
              l ? Zi(this, l) : this.cm && On(this.cm);
            }),
            undo: ri(function () {
              fo(this, "undo");
            }),
            redo: ri(function () {
              fo(this, "redo");
            }),
            undoSelection: ri(function () {
              fo(this, "undo", !0);
            }),
            redoSelection: ri(function () {
              fo(this, "redo", !0);
            }),
            setExtending: function (e) {
              this.extend = e;
            },
            getExtending: function () {
              return this.extend;
            },
            historySize: function () {
              for (var e = this.history, t = 0, r = 0, n = 0; n < e.done.length; n++) e.done[n].ranges || ++t;
              for (var i = 0; i < e.undone.length; i++) e.undone[i].ranges || ++r;
              return {
                undo: t,
                redo: r
              };
            },
            clearHistory: function () {
              var e = this;
              this.history = new Hi(this.history), Wi(this, function (t) {
                return t.history = e.history;
              }, !0);
            },
            markClean: function () {
              this.cleanGeneration = this.changeGeneration(!0);
            },
            changeGeneration: function (e) {
              return e && (this.history.lastOp = this.history.lastSelOp = this.history.lastOrigin = null), this.history.generation;
            },
            isClean: function (e) {
              return this.history.generation == (e || this.cleanGeneration);
            },
            getHistory: function () {
              return {
                done: Ki(this.history.done),
                undone: Ki(this.history.undone)
              };
            },
            setHistory: function (e) {
              var t = this.history = new Hi(this.history);
              t.done = Ki(e.done.slice(0), null, !0), t.undone = Ki(e.undone.slice(0), null, !0);
            },
            setGutterMarker: ri(function (e, t, r) {
              return bo(this, e, "gutter", function (e) {
                var n = e.gutterMarkers || (e.gutterMarkers = {});
                return n[t] = r, !r && te(n) && (e.gutterMarkers = null), !0;
              });
            }),
            clearGutter: ri(function (e) {
              var t = this;
              this.iter(function (r) {
                r.gutterMarkers && r.gutterMarkers[e] && bo(t, r, "gutter", function () {
                  return r.gutterMarkers[e] = null, te(r.gutterMarkers) && (r.gutterMarkers = null), !0;
                });
              });
            }),
            lineInfo: function (e) {
              var t;
              if ("number" == typeof e) {
                if (!Ze(this, e)) return null;
                if (t = e, !(e = Ke(this, e))) return null;
              } else if (null == (t = $e(e))) return null;
              return {
                line: t,
                handle: e,
                text: e.text,
                gutterMarkers: e.gutterMarkers,
                textClass: e.textClass,
                bgClass: e.bgClass,
                wrapClass: e.wrapClass,
                widgets: e.widgets
              };
            },
            addLineClass: ri(function (e, t, r) {
              return bo(this, e, "gutter" == t ? "gutter" : "class", function (e) {
                var n = "text" == t ? "textClass" : "background" == t ? "bgClass" : "gutter" == t ? "gutterClass" : "wrapClass";
                if (e[n]) {
                  if (S(r).test(e[n])) return !1;
                  e[n] += " " + r;
                } else e[n] = r;
                return !0;
              });
            }),
            removeLineClass: ri(function (e, t, r) {
              return bo(this, e, "gutter" == t ? "gutter" : "class", function (e) {
                var n = "text" == t ? "textClass" : "background" == t ? "bgClass" : "gutter" == t ? "gutterClass" : "wrapClass",
                  i = e[n];
                if (!i) return !1;
                if (null == r) e[n] = null;else {
                  var o = i.match(S(r));
                  if (!o) return !1;
                  var a = o.index + o[0].length;
                  e[n] = i.slice(0, o.index) + (o.index && a != i.length ? " " : "") + i.slice(a) || null;
                }
                return !0;
              });
            }),
            addLineWidget: ri(function (e, t, r) {
              return function (e, t, r, n) {
                var i = new ko(e, r, n),
                  o = e.cm;
                return o && i.noHScroll && (o.display.alignWidgets = !0), bo(e, t, "widget", function (t) {
                  var r = t.widgets || (t.widgets = []);
                  if (null == i.insertAt ? r.push(i) : r.splice(Math.min(r.length, Math.max(0, i.insertAt)), 0, i), i.line = t, o && !Bt(e, t)) {
                    var n = Ut(t) < e.scrollTop;
                    qe(t, t.height + xr(i)), n && An(o, i.height), o.curOp.forceUpdate = !0;
                  }
                  return !0;
                }), o && lr(o, "lineWidgetAdded", o, i, "number" == typeof t ? t : $e(t)), i;
              }(this, e, t, r);
            }),
            removeLineWidget: function (e) {
              e.clear();
            },
            markText: function (e, t, r) {
              return Lo(this, lt(this, e), lt(this, t), r, r && r.type || "range");
            },
            setBookmark: function (e, t) {
              var r = {
                replacedWith: t && (null == t.nodeType ? t.widget : t),
                insertLeft: t && t.insertLeft,
                clearWhenEmpty: !1,
                shared: t && t.shared,
                handleMouseEvents: t && t.handleMouseEvents
              };
              return Lo(this, e = lt(this, e), e, r, "bookmark");
            },
            findMarksAt: function (e) {
              var t = [],
                r = Ke(this, (e = lt(this, e)).line).markedSpans;
              if (r) for (var n = 0; n < r.length; ++n) {
                var i = r[n];
                (null == i.from || i.from <= e.ch) && (null == i.to || i.to >= e.ch) && t.push(i.marker.parent || i.marker);
              }
              return t;
            },
            findMarks: function (e, t, r) {
              e = lt(this, e), t = lt(this, t);
              var n = [],
                i = e.line;
              return this.iter(e.line, t.line + 1, function (o) {
                var a = o.markedSpans;
                if (a) for (var l = 0; l < a.length; l++) {
                  var s = a[l];
                  null != s.to && i == e.line && e.ch >= s.to || null == s.from && i != e.line || null != s.from && i == t.line && s.from >= t.ch || r && !r(s.marker) || n.push(s.marker.parent || s.marker);
                }
                ++i;
              }), n;
            },
            getAllMarks: function () {
              var e = [];
              return this.iter(function (t) {
                var r = t.markedSpans;
                if (r) for (var n = 0; n < r.length; ++n) null != r[n].from && e.push(r[n].marker);
              }), e;
            },
            posFromIndex: function (e) {
              var t,
                r = this.first,
                n = this.lineSeparator().length;
              return this.iter(function (i) {
                var o = i.text.length + n;
                if (o > e) return t = e, !0;
                e -= o, ++r;
              }), lt(this, et(r, t));
            },
            indexFromPos: function (e) {
              var t = (e = lt(this, e)).ch;
              if (e.line < this.first || e.ch < 0) return 0;
              var r = this.lineSeparator().length;
              return this.iter(this.first, e.line, function (e) {
                t += e.text.length + r;
              }), t;
            },
            copy: function (e) {
              var t = new Oo(Xe(this, this.first, this.first + this.size), this.modeOption, this.first, this.lineSep, this.direction);
              return t.scrollTop = this.scrollTop, t.scrollLeft = this.scrollLeft, t.sel = this.sel, t.extend = !1, e && (t.history.undoDepth = this.history.undoDepth, t.setHistory(this.getHistory())), t;
            },
            linkedDoc: function (e) {
              e || (e = {});
              var t = this.first,
                r = this.first + this.size;
              null != e.from && e.from > t && (t = e.from), null != e.to && e.to < r && (r = e.to);
              var n = new Oo(Xe(this, t, r), e.mode || this.modeOption, t, this.lineSep, this.direction);
              return e.sharedHist && (n.history = this.history), (this.linked || (this.linked = [])).push({
                doc: n,
                sharedHist: e.sharedHist
              }), n.linked = [{
                doc: this,
                isParent: !0,
                sharedHist: e.sharedHist
              }], function (e, t) {
                for (var r = 0; r < t.length; r++) {
                  var n = t[r],
                    i = n.find(),
                    o = e.clipPos(i.from),
                    a = e.clipPos(i.to);
                  if (tt(o, a)) {
                    var l = Lo(e, o, a, n.primary, n.primary.type);
                    n.markers.push(l), l.parent = n;
                  }
                }
              }(n, Eo(this)), n;
            },
            unlinkDoc: function (e) {
              if (e instanceof Na && (e = e.doc), this.linked) for (var t = 0; t < this.linked.length; ++t) if (this.linked[t].doc == e) {
                this.linked.splice(t, 1), e.unlinkDoc(this), Mo(Eo(this));
                break;
              }
              if (e.history == this.history) {
                var r = [e.id];
                Wi(e, function (e) {
                  return r.push(e.id);
                }, !0), e.history = new Hi(null), e.history.done = Ki(this.history.done, r), e.history.undone = Ki(this.history.undone, r);
              }
            },
            iterLinkedDocs: function (e) {
              Wi(this, e);
            },
            getMode: function () {
              return this.mode;
            },
            getEditor: function () {
              return this.cm;
            },
            splitLines: function (e) {
              return this.lineSep ? e.split(this.lineSep) : Oe(e);
            },
            lineSeparator: function () {
              return this.lineSep || "\n";
            },
            setDirection: ri(function (e) {
              var t;
              "rtl" != e && (e = "ltr"), e != this.direction && (this.direction = e, this.iter(function (e) {
                return e.order = null;
              }), this.cm && Qn(t = this.cm, function () {
                Pi(t), dn(t);
              }));
            })
          }), Oo.prototype.eachLine = Oo.prototype.iter;
          var Do = 0;
          function Ro(e) {
            var t = this;
            if (Wo(t), !me(t, e) && !wr(t.display, e)) {
              be(e), a && (Do = +new Date());
              var r = cn(t, e, !0),
                n = e.dataTransfer.files;
              if (r && !t.isReadOnly()) if (n && n.length && window.FileReader && window.File) for (var i = n.length, o = Array(i), l = 0, s = function () {
                  ++l == i && ei(t, function () {
                    var e = {
                      from: r = lt(t.doc, r),
                      to: r,
                      text: t.doc.splitLines(o.filter(function (e) {
                        return null != e;
                      }).join(t.doc.lineSeparator())),
                      origin: "paste"
                    };
                    co(t.doc, e), Zi(t.doc, Ti(lt(t.doc, r), lt(t.doc, Li(e))));
                  })();
                }, c = function (e, r) {
                  if (t.options.allowDropFileTypes && -1 == _(t.options.allowDropFileTypes, e.type)) s();else {
                    var n = new FileReader();
                    n.onerror = function () {
                      return s();
                    }, n.onload = function () {
                      var e = n.result;
                      /[\x00-\x08\x0e-\x1f]{2}/.test(e) || (o[r] = e), s();
                    }, n.readAsText(e);
                  }
                }, u = 0; u < n.length; u++) c(n[u], u);else {
                if (t.state.draggingText && t.doc.sel.contains(r) > -1) return t.state.draggingText(e), void setTimeout(function () {
                  return t.display.input.focus();
                }, 20);
                try {
                  var d = e.dataTransfer.getData("Text");
                  if (d) {
                    var f;
                    if (t.state.draggingText && !t.state.draggingText.copy && (f = t.listSelections()), eo(t.doc, Ti(r, r)), f) for (var h = 0; h < f.length; ++h) mo(t.doc, "", f[h].anchor, f[h].head, "drag");
                    t.replaceSelection(d, "around", "paste"), t.display.input.focus();
                  }
                } catch (e) {}
              }
            }
          }
          function Wo(e) {
            e.display.dragCursor && (e.display.lineSpace.removeChild(e.display.dragCursor), e.display.dragCursor = null);
          }
          function Io(e) {
            if (document.getElementsByClassName) {
              for (var t = document.getElementsByClassName("CodeMirror"), r = [], n = 0; n < t.length; n++) {
                var i = t[n].CodeMirror;
                i && r.push(i);
              }
              r.length && r[0].operation(function () {
                for (var t = 0; t < r.length; t++) e(r[t]);
              });
            }
          }
          var Po = !1;
          function Ho() {
            var e;
            Po || (de(window, "resize", function () {
              null == e && (e = setTimeout(function () {
                e = null, Io(Fo);
              }, 100));
            }), de(window, "blur", function () {
              return Io(Tn);
            }), Po = !0);
          }
          function Fo(e) {
            var t = e.display;
            t.cachedCharWidth = t.cachedTextHeight = t.cachedPaddingH = null, t.scrollbarsClipped = !1, e.setSize();
          }
          for (var zo = {
              3: "Pause",
              8: "Backspace",
              9: "Tab",
              13: "Enter",
              16: "Shift",
              17: "Ctrl",
              18: "Alt",
              19: "Pause",
              20: "CapsLock",
              27: "Esc",
              32: "Space",
              33: "PageUp",
              34: "PageDown",
              35: "End",
              36: "Home",
              37: "Left",
              38: "Up",
              39: "Right",
              40: "Down",
              44: "PrintScrn",
              45: "Insert",
              46: "Delete",
              59: ";",
              61: "=",
              91: "Mod",
              92: "Mod",
              93: "Mod",
              106: "*",
              107: "=",
              109: "-",
              110: ".",
              111: "/",
              145: "ScrollLock",
              173: "-",
              186: ";",
              187: "=",
              188: ",",
              189: "-",
              190: ".",
              191: "/",
              192: "`",
              219: "[",
              220: "\\",
              221: "]",
              222: "'",
              224: "Mod",
              63232: "Up",
              63233: "Down",
              63234: "Left",
              63235: "Right",
              63272: "Delete",
              63273: "Home",
              63275: "End",
              63276: "PageUp",
              63277: "PageDown",
              63302: "Insert"
            }, _o = 0; _o < 10; _o++) zo[_o + 48] = zo[_o + 96] = String(_o);
          for (var Bo = 65; Bo <= 90; Bo++) zo[Bo] = String.fromCharCode(Bo);
          for (var jo = 1; jo <= 12; jo++) zo[jo + 111] = zo[jo + 63235] = "F" + jo;
          var Uo = {};
          function Go(e) {
            var t,
              r,
              n,
              i,
              o = e.split(/-(?!$)/);
            e = o[o.length - 1];
            for (var a = 0; a < o.length - 1; a++) {
              var l = o[a];
              if (/^(cmd|meta|m)$/i.test(l)) i = !0;else if (/^a(lt)?$/i.test(l)) t = !0;else if (/^(c|ctrl|control)$/i.test(l)) r = !0;else {
                if (!/^s(hift)?$/i.test(l)) throw new Error("Unrecognized modifier name: " + l);
                n = !0;
              }
            }
            return t && (e = "Alt-" + e), r && (e = "Ctrl-" + e), i && (e = "Cmd-" + e), n && (e = "Shift-" + e), e;
          }
          function Vo(e) {
            var t = {};
            for (var r in e) if (e.hasOwnProperty(r)) {
              var n = e[r];
              if (/^(name|fallthrough|(de|at)tach)$/.test(r)) continue;
              if ("..." == n) {
                delete e[r];
                continue;
              }
              for (var i = q(r.split(" "), Go), o = 0; o < i.length; o++) {
                var a = void 0,
                  l = void 0;
                o == i.length - 1 ? (l = i.join(" "), a = n) : (l = i.slice(0, o + 1).join(" "), a = "...");
                var s = t[l];
                if (s) {
                  if (s != a) throw new Error("Inconsistent bindings for " + l);
                } else t[l] = a;
              }
              delete e[r];
            }
            for (var c in t) e[c] = t[c];
            return e;
          }
          function Ko(e, t, r, n) {
            var i = (t = $o(t)).call ? t.call(e, n) : t[e];
            if (!1 === i) return "nothing";
            if ("..." === i) return "multi";
            if (null != i && r(i)) return "handled";
            if (t.fallthrough) {
              if ("[object Array]" != Object.prototype.toString.call(t.fallthrough)) return Ko(e, t.fallthrough, r, n);
              for (var o = 0; o < t.fallthrough.length; o++) {
                var a = Ko(e, t.fallthrough[o], r, n);
                if (a) return a;
              }
            }
          }
          function Yo(e) {
            var t = "string" == typeof e ? e : zo[e.keyCode];
            return "Ctrl" == t || "Alt" == t || "Shift" == t || "Mod" == t;
          }
          function Xo(e, t, r) {
            var n = e;
            return t.altKey && "Alt" != n && (e = "Alt-" + e), (k ? t.metaKey : t.ctrlKey) && "Ctrl" != n && (e = "Ctrl-" + e), (k ? t.ctrlKey : t.metaKey) && "Mod" != n && (e = "Cmd-" + e), !r && t.shiftKey && "Shift" != n && (e = "Shift-" + e), e;
          }
          function qo(e, t) {
            if (d && 34 == e.keyCode && e.char) return !1;
            var r = zo[e.keyCode];
            return null != r && !e.altGraphKey && (3 == e.keyCode && e.code && (r = e.code), Xo(r, e, t));
          }
          function $o(e) {
            return "string" == typeof e ? Uo[e] : e;
          }
          function Jo(e, t) {
            for (var r = e.doc.sel.ranges, n = [], i = 0; i < r.length; i++) {
              for (var o = t(r[i]); n.length && tt(o.from, X(n).to) <= 0;) {
                var a = n.pop();
                if (tt(a.from, o.from) < 0) {
                  o.from = a.from;
                  break;
                }
              }
              n.push(o);
            }
            Qn(e, function () {
              for (var t = n.length - 1; t >= 0; t--) mo(e.doc, "", n[t].from, n[t].to, "+delete");
              On(e);
            });
          }
          function Zo(e, t, r) {
            var n = ie(e.text, t + r, r);
            return n < 0 || n > e.text.length ? null : n;
          }
          function Qo(e, t, r) {
            var n = Zo(e, t.ch, r);
            return null == n ? null : new et(t.line, n, r < 0 ? "after" : "before");
          }
          function ea(e, t, r, n, i) {
            if (e) {
              "rtl" == t.doc.direction && (i = -i);
              var o = ce(r, t.doc.direction);
              if (o) {
                var a,
                  l = i < 0 ? X(o) : o[0],
                  s = i < 0 == (1 == l.level) ? "after" : "before";
                if (l.level > 0 || "rtl" == t.doc.direction) {
                  var c = Or(t, r);
                  a = i < 0 ? r.text.length - 1 : 0;
                  var u = Dr(t, c, a).top;
                  a = oe(function (e) {
                    return Dr(t, c, e).top == u;
                  }, i < 0 == (1 == l.level) ? l.from : l.to - 1, a), "before" == s && (a = Zo(r, a, 1));
                } else a = i < 0 ? l.to : l.from;
                return new et(n, a, s);
              }
            }
            return new et(n, i < 0 ? r.text.length : 0, i < 0 ? "before" : "after");
          }
          Uo.basic = {
            Left: "goCharLeft",
            Right: "goCharRight",
            Up: "goLineUp",
            Down: "goLineDown",
            End: "goLineEnd",
            Home: "goLineStartSmart",
            PageUp: "goPageUp",
            PageDown: "goPageDown",
            Delete: "delCharAfter",
            Backspace: "delCharBefore",
            "Shift-Backspace": "delCharBefore",
            Tab: "defaultTab",
            "Shift-Tab": "indentAuto",
            Enter: "newlineAndIndent",
            Insert: "toggleOverwrite",
            Esc: "singleSelection"
          }, Uo.pcDefault = {
            "Ctrl-A": "selectAll",
            "Ctrl-D": "deleteLine",
            "Ctrl-Z": "undo",
            "Shift-Ctrl-Z": "redo",
            "Ctrl-Y": "redo",
            "Ctrl-Home": "goDocStart",
            "Ctrl-End": "goDocEnd",
            "Ctrl-Up": "goLineUp",
            "Ctrl-Down": "goLineDown",
            "Ctrl-Left": "goGroupLeft",
            "Ctrl-Right": "goGroupRight",
            "Alt-Left": "goLineStart",
            "Alt-Right": "goLineEnd",
            "Ctrl-Backspace": "delGroupBefore",
            "Ctrl-Delete": "delGroupAfter",
            "Ctrl-S": "save",
            "Ctrl-F": "find",
            "Ctrl-G": "findNext",
            "Shift-Ctrl-G": "findPrev",
            "Shift-Ctrl-F": "replace",
            "Shift-Ctrl-R": "replaceAll",
            "Ctrl-[": "indentLess",
            "Ctrl-]": "indentMore",
            "Ctrl-U": "undoSelection",
            "Shift-Ctrl-U": "redoSelection",
            "Alt-U": "redoSelection",
            fallthrough: "basic"
          }, Uo.emacsy = {
            "Ctrl-F": "goCharRight",
            "Ctrl-B": "goCharLeft",
            "Ctrl-P": "goLineUp",
            "Ctrl-N": "goLineDown",
            "Ctrl-A": "goLineStart",
            "Ctrl-E": "goLineEnd",
            "Ctrl-V": "goPageDown",
            "Shift-Ctrl-V": "goPageUp",
            "Ctrl-D": "delCharAfter",
            "Ctrl-H": "delCharBefore",
            "Alt-Backspace": "delWordBefore",
            "Ctrl-K": "killLine",
            "Ctrl-T": "transposeChars",
            "Ctrl-O": "openLine"
          }, Uo.macDefault = {
            "Cmd-A": "selectAll",
            "Cmd-D": "deleteLine",
            "Cmd-Z": "undo",
            "Shift-Cmd-Z": "redo",
            "Cmd-Y": "redo",
            "Cmd-Home": "goDocStart",
            "Cmd-Up": "goDocStart",
            "Cmd-End": "goDocEnd",
            "Cmd-Down": "goDocEnd",
            "Alt-Left": "goGroupLeft",
            "Alt-Right": "goGroupRight",
            "Cmd-Left": "goLineLeft",
            "Cmd-Right": "goLineRight",
            "Alt-Backspace": "delGroupBefore",
            "Ctrl-Alt-Backspace": "delGroupAfter",
            "Alt-Delete": "delGroupAfter",
            "Cmd-S": "save",
            "Cmd-F": "find",
            "Cmd-G": "findNext",
            "Shift-Cmd-G": "findPrev",
            "Cmd-Alt-F": "replace",
            "Shift-Cmd-Alt-F": "replaceAll",
            "Cmd-[": "indentLess",
            "Cmd-]": "indentMore",
            "Cmd-Backspace": "delWrappedLineLeft",
            "Cmd-Delete": "delWrappedLineRight",
            "Cmd-U": "undoSelection",
            "Shift-Cmd-U": "redoSelection",
            "Ctrl-Up": "goDocStart",
            "Ctrl-Down": "goDocEnd",
            fallthrough: ["basic", "emacsy"]
          }, Uo.default = y ? Uo.macDefault : Uo.pcDefault;
          var ta = {
            selectAll: lo,
            singleSelection: function (e) {
              return e.setSelection(e.getCursor("anchor"), e.getCursor("head"), j);
            },
            killLine: function (e) {
              return Jo(e, function (t) {
                if (t.empty()) {
                  var r = Ke(e.doc, t.head.line).text.length;
                  return t.head.ch == r && t.head.line < e.lastLine() ? {
                    from: t.head,
                    to: et(t.head.line + 1, 0)
                  } : {
                    from: t.head,
                    to: et(t.head.line, r)
                  };
                }
                return {
                  from: t.from(),
                  to: t.to()
                };
              });
            },
            deleteLine: function (e) {
              return Jo(e, function (t) {
                return {
                  from: et(t.from().line, 0),
                  to: lt(e.doc, et(t.to().line + 1, 0))
                };
              });
            },
            delLineLeft: function (e) {
              return Jo(e, function (e) {
                return {
                  from: et(e.from().line, 0),
                  to: e.from()
                };
              });
            },
            delWrappedLineLeft: function (e) {
              return Jo(e, function (t) {
                var r = e.charCoords(t.head, "div").top + 5;
                return {
                  from: e.coordsChar({
                    left: 0,
                    top: r
                  }, "div"),
                  to: t.from()
                };
              });
            },
            delWrappedLineRight: function (e) {
              return Jo(e, function (t) {
                var r = e.charCoords(t.head, "div").top + 5,
                  n = e.coordsChar({
                    left: e.display.lineDiv.offsetWidth + 100,
                    top: r
                  }, "div");
                return {
                  from: t.from(),
                  to: n
                };
              });
            },
            undo: function (e) {
              return e.undo();
            },
            redo: function (e) {
              return e.redo();
            },
            undoSelection: function (e) {
              return e.undoSelection();
            },
            redoSelection: function (e) {
              return e.redoSelection();
            },
            goDocStart: function (e) {
              return e.extendSelection(et(e.firstLine(), 0));
            },
            goDocEnd: function (e) {
              return e.extendSelection(et(e.lastLine()));
            },
            goLineStart: function (e) {
              return e.extendSelectionsBy(function (t) {
                return ra(e, t.head.line);
              }, {
                origin: "+move",
                bias: 1
              });
            },
            goLineStartSmart: function (e) {
              return e.extendSelectionsBy(function (t) {
                return na(e, t.head);
              }, {
                origin: "+move",
                bias: 1
              });
            },
            goLineEnd: function (e) {
              return e.extendSelectionsBy(function (t) {
                return function (e, t) {
                  var r = Ke(e.doc, t),
                    n = function (e) {
                      for (var t; t = It(e);) e = t.find(1, !0).line;
                      return e;
                    }(r);
                  return n != r && (t = $e(n)), ea(!0, e, r, t, -1);
                }(e, t.head.line);
              }, {
                origin: "+move",
                bias: -1
              });
            },
            goLineRight: function (e) {
              return e.extendSelectionsBy(function (t) {
                var r = e.cursorCoords(t.head, "div").top + 5;
                return e.coordsChar({
                  left: e.display.lineDiv.offsetWidth + 100,
                  top: r
                }, "div");
              }, G);
            },
            goLineLeft: function (e) {
              return e.extendSelectionsBy(function (t) {
                var r = e.cursorCoords(t.head, "div").top + 5;
                return e.coordsChar({
                  left: 0,
                  top: r
                }, "div");
              }, G);
            },
            goLineLeftSmart: function (e) {
              return e.extendSelectionsBy(function (t) {
                var r = e.cursorCoords(t.head, "div").top + 5,
                  n = e.coordsChar({
                    left: 0,
                    top: r
                  }, "div");
                return n.ch < e.getLine(n.line).search(/\S/) ? na(e, t.head) : n;
              }, G);
            },
            goLineUp: function (e) {
              return e.moveV(-1, "line");
            },
            goLineDown: function (e) {
              return e.moveV(1, "line");
            },
            goPageUp: function (e) {
              return e.moveV(-1, "page");
            },
            goPageDown: function (e) {
              return e.moveV(1, "page");
            },
            goCharLeft: function (e) {
              return e.moveH(-1, "char");
            },
            goCharRight: function (e) {
              return e.moveH(1, "char");
            },
            goColumnLeft: function (e) {
              return e.moveH(-1, "column");
            },
            goColumnRight: function (e) {
              return e.moveH(1, "column");
            },
            goWordLeft: function (e) {
              return e.moveH(-1, "word");
            },
            goGroupRight: function (e) {
              return e.moveH(1, "group");
            },
            goGroupLeft: function (e) {
              return e.moveH(-1, "group");
            },
            goWordRight: function (e) {
              return e.moveH(1, "word");
            },
            delCharBefore: function (e) {
              return e.deleteH(-1, "codepoint");
            },
            delCharAfter: function (e) {
              return e.deleteH(1, "char");
            },
            delWordBefore: function (e) {
              return e.deleteH(-1, "word");
            },
            delWordAfter: function (e) {
              return e.deleteH(1, "word");
            },
            delGroupBefore: function (e) {
              return e.deleteH(-1, "group");
            },
            delGroupAfter: function (e) {
              return e.deleteH(1, "group");
            },
            indentAuto: function (e) {
              return e.indentSelection("smart");
            },
            indentMore: function (e) {
              return e.indentSelection("add");
            },
            indentLess: function (e) {
              return e.indentSelection("subtract");
            },
            insertTab: function (e) {
              return e.replaceSelection("\t");
            },
            insertSoftTab: function (e) {
              for (var t = [], r = e.listSelections(), n = e.options.tabSize, i = 0; i < r.length; i++) {
                var o = r[i].from(),
                  a = F(e.getLine(o.line), o.ch, n);
                t.push(Y(n - a % n));
              }
              e.replaceSelections(t);
            },
            defaultTab: function (e) {
              e.somethingSelected() ? e.indentSelection("add") : e.execCommand("insertTab");
            },
            transposeChars: function (e) {
              return Qn(e, function () {
                for (var t = e.listSelections(), r = [], n = 0; n < t.length; n++) if (t[n].empty()) {
                  var i = t[n].head,
                    o = Ke(e.doc, i.line).text;
                  if (o) if (i.ch == o.length && (i = new et(i.line, i.ch - 1)), i.ch > 0) i = new et(i.line, i.ch + 1), e.replaceRange(o.charAt(i.ch - 1) + o.charAt(i.ch - 2), et(i.line, i.ch - 2), i, "+transpose");else if (i.line > e.doc.first) {
                    var a = Ke(e.doc, i.line - 1).text;
                    a && (i = new et(i.line, 1), e.replaceRange(o.charAt(0) + e.doc.lineSeparator() + a.charAt(a.length - 1), et(i.line - 1, a.length - 1), i, "+transpose"));
                  }
                  r.push(new Ci(i, i));
                }
                e.setSelections(r);
              });
            },
            newlineAndIndent: function (e) {
              return Qn(e, function () {
                for (var t = e.listSelections(), r = t.length - 1; r >= 0; r--) e.replaceRange(e.doc.lineSeparator(), t[r].anchor, t[r].head, "+input");
                t = e.listSelections();
                for (var n = 0; n < t.length; n++) e.indentLine(t[n].from().line, null, !0);
                On(e);
              });
            },
            openLine: function (e) {
              return e.replaceSelection("\n", "start");
            },
            toggleOverwrite: function (e) {
              return e.toggleOverwrite();
            }
          };
          function ra(e, t) {
            var r = Ke(e.doc, t),
              n = Ft(r);
            return n != r && (t = $e(n)), ea(!0, e, n, t, 1);
          }
          function na(e, t) {
            var r = ra(e, t.line),
              n = Ke(e.doc, r.line),
              i = ce(n, e.doc.direction);
            if (!i || 0 == i[0].level) {
              var o = Math.max(r.ch, n.text.search(/\S/)),
                a = t.line == r.line && t.ch <= o && t.ch;
              return et(r.line, a ? 0 : o, r.sticky);
            }
            return r;
          }
          function ia(e, t, r) {
            if ("string" == typeof t && !(t = ta[t])) return !1;
            e.display.input.ensurePolled();
            var n = e.display.shift,
              i = !1;
            try {
              e.isReadOnly() && (e.state.suppressEdits = !0), r && (e.display.shift = !1), i = t(e) != B;
            } finally {
              e.display.shift = n, e.state.suppressEdits = !1;
            }
            return i;
          }
          var oa = new z();
          function aa(e, t, r, n) {
            var i = e.state.keySeq;
            if (i) {
              if (Yo(t)) return "handled";
              if (/\'$/.test(t) ? e.state.keySeq = null : oa.set(50, function () {
                e.state.keySeq == i && (e.state.keySeq = null, e.display.input.reset());
              }), la(e, i + " " + t, r, n)) return !0;
            }
            return la(e, t, r, n);
          }
          function la(e, t, r, n) {
            var i = function (e, t, r) {
              for (var n = 0; n < e.state.keyMaps.length; n++) {
                var i = Ko(t, e.state.keyMaps[n], r, e);
                if (i) return i;
              }
              return e.options.extraKeys && Ko(t, e.options.extraKeys, r, e) || Ko(t, e.options.keyMap, r, e);
            }(e, t, n);
            return "multi" == i && (e.state.keySeq = t), "handled" == i && lr(e, "keyHandled", e, t, r), "handled" != i && "multi" != i || (be(r), wn(e)), !!i;
          }
          function sa(e, t) {
            var r = qo(t, !0);
            return !!r && (t.shiftKey && !e.state.keySeq ? aa(e, "Shift-" + r, t, function (t) {
              return ia(e, t, !0);
            }) || aa(e, r, t, function (t) {
              if ("string" == typeof t ? /^go[A-Z]/.test(t) : t.motion) return ia(e, t);
            }) : aa(e, r, t, function (t) {
              return ia(e, t);
            }));
          }
          var ca = null;
          function ua(e) {
            var t = this;
            if (!(e.target && e.target != t.display.input.getField() || (t.curOp.focus = D(), me(t, e)))) {
              a && l < 11 && 27 == e.keyCode && (e.returnValue = !1);
              var n = e.keyCode;
              t.display.shift = 16 == n || e.shiftKey;
              var i = sa(t, e);
              d && (ca = i ? n : null, i || 88 != n || Re || !(y ? e.metaKey : e.ctrlKey) || t.replaceSelection("", null, "cut")), r && !y && !i && 46 == n && e.shiftKey && !e.ctrlKey && document.execCommand && document.execCommand("cut"), 18 != n || /\bCodeMirror-crosshair\b/.test(t.display.lineDiv.className) || function (e) {
                var t = e.display.lineDiv;
                function r(e) {
                  18 != e.keyCode && e.altKey || (L(t, "CodeMirror-crosshair"), he(document, "keyup", r), he(document, "mouseover", r));
                }
                R(t, "CodeMirror-crosshair"), de(document, "keyup", r), de(document, "mouseover", r);
              }(t);
            }
          }
          function da(e) {
            16 == e.keyCode && (this.doc.sel.shift = !1), me(this, e);
          }
          function fa(e) {
            var t = this;
            if (!(e.target && e.target != t.display.input.getField() || wr(t.display, e) || me(t, e) || e.ctrlKey && !e.altKey || y && e.metaKey)) {
              var r = e.keyCode,
                n = e.charCode;
              if (d && r == ca) return ca = null, void be(e);
              if (!d || e.which && !(e.which < 10) || !sa(t, e)) {
                var i = String.fromCharCode(null == n ? r : n);
                "\b" != i && (function (e, t, r) {
                  return aa(e, "'" + r + "'", t, function (t) {
                    return ia(e, t, !0);
                  });
                }(t, e, i) || t.display.input.onKeyPress(e));
              }
            }
          }
          var ha,
            pa,
            ma = function (e, t, r) {
              this.time = e, this.pos = t, this.button = r;
            };
          function ga(e) {
            var t = this,
              r = t.display;
            if (!(me(t, e) || r.activeTouch && r.input.supportsTouch())) if (r.input.ensurePolled(), r.shift = e.shiftKey, wr(r, e)) s || (r.scroller.draggable = !1, setTimeout(function () {
              return r.scroller.draggable = !0;
            }, 100));else if (!ba(t, e)) {
              var n = cn(t, e),
                i = Se(e),
                o = n ? function (e, t) {
                  var r = +new Date();
                  return pa && pa.compare(r, e, t) ? (ha = pa = null, "triple") : ha && ha.compare(r, e, t) ? (pa = new ma(r, e, t), ha = null, "double") : (ha = new ma(r, e, t), pa = null, "single");
                }(n, i) : "single";
              window.focus(), 1 == i && t.state.selectingText && t.state.selectingText(e), n && function (e, t, r, n, i) {
                var o = "Click";
                return "double" == n ? o = "Double" + o : "triple" == n && (o = "Triple" + o), aa(e, Xo(o = (1 == t ? "Left" : 2 == t ? "Middle" : "Right") + o, i), i, function (t) {
                  if ("string" == typeof t && (t = ta[t]), !t) return !1;
                  var n = !1;
                  try {
                    e.isReadOnly() && (e.state.suppressEdits = !0), n = t(e, r) != B;
                  } finally {
                    e.state.suppressEdits = !1;
                  }
                  return n;
                });
              }(t, i, n, o, e) || (1 == i ? n ? function (e, t, r, n) {
                a ? setTimeout(P(kn, e), 0) : e.curOp.focus = D();
                var i,
                  o = function (e, t, r) {
                    var n = e.getOption("configureMouse"),
                      i = n ? n(e, t, r) : {};
                    if (null == i.unit) {
                      var o = b ? r.shiftKey && r.metaKey : r.altKey;
                      i.unit = o ? "rectangle" : "single" == t ? "char" : "double" == t ? "word" : "line";
                    }
                    return (null == i.extend || e.doc.extend) && (i.extend = e.doc.extend || r.shiftKey), null == i.addNew && (i.addNew = y ? r.metaKey : r.ctrlKey), null == i.moveOnDrag && (i.moveOnDrag = !(y ? r.altKey : r.ctrlKey)), i;
                  }(e, r, n),
                  c = e.doc.sel;
                e.options.dragDrop && Ne && !e.isReadOnly() && "single" == r && (i = c.contains(t)) > -1 && (tt((i = c.ranges[i]).from(), t) < 0 || t.xRel > 0) && (tt(i.to(), t) > 0 || t.xRel < 0) ? function (e, t, r, n) {
                  var i = e.display,
                    o = !1,
                    c = ei(e, function (t) {
                      s && (i.scroller.draggable = !1), e.state.draggingText = !1, e.state.delayingBlurEvent && (e.hasFocus() ? e.state.delayingBlurEvent = !1 : Cn(e)), he(i.wrapper.ownerDocument, "mouseup", c), he(i.wrapper.ownerDocument, "mousemove", u), he(i.scroller, "dragstart", d), he(i.scroller, "drop", c), o || (be(t), n.addNew || Xi(e.doc, r, null, null, n.extend), s && !f || a && 9 == l ? setTimeout(function () {
                        i.wrapper.ownerDocument.body.focus({
                          preventScroll: !0
                        }), i.input.focus();
                      }, 20) : i.input.focus());
                    }),
                    u = function (e) {
                      o = o || Math.abs(t.clientX - e.clientX) + Math.abs(t.clientY - e.clientY) >= 10;
                    },
                    d = function () {
                      return o = !0;
                    };
                  s && (i.scroller.draggable = !0), e.state.draggingText = c, c.copy = !n.moveOnDrag, de(i.wrapper.ownerDocument, "mouseup", c), de(i.wrapper.ownerDocument, "mousemove", u), de(i.scroller, "dragstart", d), de(i.scroller, "drop", c), e.state.delayingBlurEvent = !0, setTimeout(function () {
                    return i.input.focus();
                  }, 20), i.scroller.dragDrop && i.scroller.dragDrop();
                }(e, n, t, o) : function (e, t, r, n) {
                  a && Cn(e);
                  var i = e.display,
                    o = e.doc;
                  be(t);
                  var l,
                    s,
                    c = o.sel,
                    u = c.ranges;
                  if (n.addNew && !n.extend ? (s = o.sel.contains(r), l = s > -1 ? u[s] : new Ci(r, r)) : (l = o.sel.primary(), s = o.sel.primIndex), "rectangle" == n.unit) n.addNew || (l = new Ci(r, r)), r = cn(e, t, !0, !0), s = -1;else {
                    var d = va(e, r, n.unit);
                    l = n.extend ? Yi(l, d.anchor, d.head, n.extend) : d;
                  }
                  n.addNew ? -1 == s ? (s = u.length, Qi(o, Si(e, u.concat([l]), s), {
                    scroll: !1,
                    origin: "*mouse"
                  })) : u.length > 1 && u[s].empty() && "char" == n.unit && !n.extend ? (Qi(o, Si(e, u.slice(0, s).concat(u.slice(s + 1)), 0), {
                    scroll: !1,
                    origin: "*mouse"
                  }), c = o.sel) : $i(o, s, l, U) : (s = 0, Qi(o, new ki([l], 0), U), c = o.sel);
                  var f = r;
                  function h(t) {
                    if (0 != tt(f, t)) if (f = t, "rectangle" == n.unit) {
                      for (var i = [], a = e.options.tabSize, u = F(Ke(o, r.line).text, r.ch, a), d = F(Ke(o, t.line).text, t.ch, a), h = Math.min(u, d), p = Math.max(u, d), m = Math.min(r.line, t.line), g = Math.min(e.lastLine(), Math.max(r.line, t.line)); m <= g; m++) {
                        var v = Ke(o, m).text,
                          y = V(v, h, a);
                        h == p ? i.push(new Ci(et(m, y), et(m, y))) : v.length > y && i.push(new Ci(et(m, y), et(m, V(v, p, a))));
                      }
                      i.length || i.push(new Ci(r, r)), Qi(o, Si(e, c.ranges.slice(0, s).concat(i), s), {
                        origin: "*mouse",
                        scroll: !1
                      }), e.scrollIntoView(t);
                    } else {
                      var b,
                        x = l,
                        w = va(e, t, n.unit),
                        k = x.anchor;
                      tt(w.anchor, k) > 0 ? (b = w.head, k = ot(x.from(), w.anchor)) : (b = w.anchor, k = it(x.to(), w.head));
                      var C = c.ranges.slice(0);
                      C[s] = function (e, t) {
                        var r = t.anchor,
                          n = t.head,
                          i = Ke(e.doc, r.line);
                        if (0 == tt(r, n) && r.sticky == n.sticky) return t;
                        var o = ce(i);
                        if (!o) return t;
                        var a = le(o, r.ch, r.sticky),
                          l = o[a];
                        if (l.from != r.ch && l.to != r.ch) return t;
                        var s,
                          c = a + (l.from == r.ch == (1 != l.level) ? 0 : 1);
                        if (0 == c || c == o.length) return t;
                        if (n.line != r.line) s = (n.line - r.line) * ("ltr" == e.doc.direction ? 1 : -1) > 0;else {
                          var u = le(o, n.ch, n.sticky),
                            d = u - a || (n.ch - r.ch) * (1 == l.level ? -1 : 1);
                          s = u == c - 1 || u == c ? d < 0 : d > 0;
                        }
                        var f = o[c + (s ? -1 : 0)],
                          h = s == (1 == f.level),
                          p = h ? f.from : f.to,
                          m = h ? "after" : "before";
                        return r.ch == p && r.sticky == m ? t : new Ci(new et(r.line, p, m), n);
                      }(e, new Ci(lt(o, k), b)), Qi(o, Si(e, C, s), U);
                    }
                  }
                  var p = i.wrapper.getBoundingClientRect(),
                    m = 0;
                  function g(t) {
                    var r = ++m,
                      a = cn(e, t, !0, "rectangle" == n.unit);
                    if (a) if (0 != tt(a, f)) {
                      e.curOp.focus = D(), h(a);
                      var l = En(i, o);
                      (a.line >= l.to || a.line < l.from) && setTimeout(ei(e, function () {
                        m == r && g(t);
                      }), 150);
                    } else {
                      var s = t.clientY < p.top ? -20 : t.clientY > p.bottom ? 20 : 0;
                      s && setTimeout(ei(e, function () {
                        m == r && (i.scroller.scrollTop += s, g(t));
                      }), 50);
                    }
                  }
                  function v(t) {
                    e.state.selectingText = !1, m = 1 / 0, t && (be(t), i.input.focus()), he(i.wrapper.ownerDocument, "mousemove", y), he(i.wrapper.ownerDocument, "mouseup", b), o.history.lastSelOrigin = null;
                  }
                  var y = ei(e, function (e) {
                      0 !== e.buttons && Se(e) ? g(e) : v(e);
                    }),
                    b = ei(e, v);
                  e.state.selectingText = b, de(i.wrapper.ownerDocument, "mousemove", y), de(i.wrapper.ownerDocument, "mouseup", b);
                }(e, n, t, o);
              }(t, n, o, e) : Ce(e) == r.scroller && be(e) : 2 == i ? (n && Xi(t.doc, n), setTimeout(function () {
                return r.input.focus();
              }, 20)) : 3 == i && (C ? t.display.input.onContextMenu(e) : Cn(t)));
            }
          }
          function va(e, t, r) {
            if ("char" == r) return new Ci(t, t);
            if ("word" == r) return e.findWordAt(t);
            if ("line" == r) return new Ci(et(t.line, 0), lt(e.doc, et(t.line + 1, 0)));
            var n = r(e, t);
            return new Ci(n.from, n.to);
          }
          function ya(e, t, r, n) {
            var i, o;
            if (t.touches) i = t.touches[0].clientX, o = t.touches[0].clientY;else try {
              i = t.clientX, o = t.clientY;
            } catch (e) {
              return !1;
            }
            if (i >= Math.floor(e.display.gutters.getBoundingClientRect().right)) return !1;
            n && be(t);
            var a = e.display,
              l = a.lineDiv.getBoundingClientRect();
            if (o > l.bottom || !ve(e, r)) return we(t);
            o -= l.top - a.viewOffset;
            for (var s = 0; s < e.display.gutterSpecs.length; ++s) {
              var c = a.gutters.childNodes[s];
              if (c && c.getBoundingClientRect().right >= i) return pe(e, r, e, Je(e.doc, o), e.display.gutterSpecs[s].className, t), we(t);
            }
          }
          function ba(e, t) {
            return ya(e, t, "gutterClick", !0);
          }
          function xa(e, t) {
            wr(e.display, t) || function (e, t) {
              return !!ve(e, "gutterContextMenu") && ya(e, t, "gutterContextMenu", !1);
            }(e, t) || me(e, t, "contextmenu") || C || e.display.input.onContextMenu(t);
          }
          function wa(e) {
            e.display.wrapper.className = e.display.wrapper.className.replace(/\s*cm-s-\S+/g, "") + e.options.theme.replace(/(^|\s)\s*/g, " cm-s-"), zr(e);
          }
          ma.prototype.compare = function (e, t, r) {
            return this.time + 400 > e && 0 == tt(t, this.pos) && r == this.button;
          };
          var ka = {
              toString: function () {
                return "CodeMirror.Init";
              }
            },
            Ca = {},
            Sa = {};
          function Ta(e, t, r) {
            if (!t != !(r && r != ka)) {
              var n = e.display.dragFunctions,
                i = t ? de : he;
              i(e.display.scroller, "dragstart", n.start), i(e.display.scroller, "dragenter", n.enter), i(e.display.scroller, "dragover", n.over), i(e.display.scroller, "dragleave", n.leave), i(e.display.scroller, "drop", n.drop);
            }
          }
          function La(e) {
            e.options.lineWrapping ? (R(e.display.wrapper, "CodeMirror-wrap"), e.display.sizer.style.minWidth = "", e.display.sizerWidth = null) : (L(e.display.wrapper, "CodeMirror-wrap"), Vt(e)), sn(e), dn(e), zr(e), setTimeout(function () {
              return Bn(e);
            }, 100);
          }
          function Na(e, t) {
            var r = this;
            if (!(this instanceof Na)) return new Na(e, t);
            this.options = t = t ? H(t) : {}, H(Ca, t, !1);
            var n = t.value;
            "string" == typeof n ? n = new Oo(n, t.mode, null, t.lineSeparator, t.direction) : t.mode && (n.modeOption = t.mode), this.doc = n;
            var i = new Na.inputStyles[t.inputStyle](this),
              o = this.display = new gi(e, n, i, t);
            for (var c in o.wrapper.CodeMirror = this, wa(this), t.lineWrapping && (this.display.wrapper.className += " CodeMirror-wrap"), Gn(this), this.state = {
              keyMaps: [],
              overlays: [],
              modeGen: 0,
              overwrite: !1,
              delayingBlurEvent: !1,
              focused: !1,
              suppressEdits: !1,
              pasteIncoming: -1,
              cutIncoming: -1,
              selectingText: !1,
              draggingText: !1,
              highlight: new z(),
              keySeq: null,
              specialChars: null
            }, t.autofocus && !v && o.input.focus(), a && l < 11 && setTimeout(function () {
              return r.display.input.reset(!0);
            }, 20), function (e) {
              var t = e.display;
              de(t.scroller, "mousedown", ei(e, ga)), de(t.scroller, "dblclick", a && l < 11 ? ei(e, function (t) {
                if (!me(e, t)) {
                  var r = cn(e, t);
                  if (r && !ba(e, t) && !wr(e.display, t)) {
                    be(t);
                    var n = e.findWordAt(r);
                    Xi(e.doc, n.anchor, n.head);
                  }
                }
              }) : function (t) {
                return me(e, t) || be(t);
              }), de(t.scroller, "contextmenu", function (t) {
                return xa(e, t);
              }), de(t.input.getField(), "contextmenu", function (r) {
                t.scroller.contains(r.target) || xa(e, r);
              });
              var r,
                n = {
                  end: 0
                };
              function i() {
                t.activeTouch && (r = setTimeout(function () {
                  return t.activeTouch = null;
                }, 1e3), (n = t.activeTouch).end = +new Date());
              }
              function o(e) {
                if (1 != e.touches.length) return !1;
                var t = e.touches[0];
                return t.radiusX <= 1 && t.radiusY <= 1;
              }
              function s(e, t) {
                if (null == t.left) return !0;
                var r = t.left - e.left,
                  n = t.top - e.top;
                return r * r + n * n > 400;
              }
              de(t.scroller, "touchstart", function (i) {
                if (!me(e, i) && !o(i) && !ba(e, i)) {
                  t.input.ensurePolled(), clearTimeout(r);
                  var a = +new Date();
                  t.activeTouch = {
                    start: a,
                    moved: !1,
                    prev: a - n.end <= 300 ? n : null
                  }, 1 == i.touches.length && (t.activeTouch.left = i.touches[0].pageX, t.activeTouch.top = i.touches[0].pageY);
                }
              }), de(t.scroller, "touchmove", function () {
                t.activeTouch && (t.activeTouch.moved = !0);
              }), de(t.scroller, "touchend", function (r) {
                var n = t.activeTouch;
                if (n && !wr(t, r) && null != n.left && !n.moved && new Date() - n.start < 300) {
                  var o,
                    a = e.coordsChar(t.activeTouch, "page");
                  o = !n.prev || s(n, n.prev) ? new Ci(a, a) : !n.prev.prev || s(n, n.prev.prev) ? e.findWordAt(a) : new Ci(et(a.line, 0), lt(e.doc, et(a.line + 1, 0))), e.setSelection(o.anchor, o.head), e.focus(), be(r);
                }
                i();
              }), de(t.scroller, "touchcancel", i), de(t.scroller, "scroll", function () {
                t.scroller.clientHeight && (In(e, t.scroller.scrollTop), Hn(e, t.scroller.scrollLeft, !0), pe(e, "scroll", e));
              }), de(t.scroller, "mousewheel", function (t) {
                return wi(e, t);
              }), de(t.scroller, "DOMMouseScroll", function (t) {
                return wi(e, t);
              }), de(t.wrapper, "scroll", function () {
                return t.wrapper.scrollTop = t.wrapper.scrollLeft = 0;
              }), t.dragFunctions = {
                enter: function (t) {
                  me(e, t) || ke(t);
                },
                over: function (t) {
                  me(e, t) || (function (e, t) {
                    var r = cn(e, t);
                    if (r) {
                      var n = document.createDocumentFragment();
                      yn(e, r, n), e.display.dragCursor || (e.display.dragCursor = M("div", null, "CodeMirror-cursors CodeMirror-dragcursors"), e.display.lineSpace.insertBefore(e.display.dragCursor, e.display.cursorDiv)), E(e.display.dragCursor, n);
                    }
                  }(e, t), ke(t));
                },
                start: function (t) {
                  return function (e, t) {
                    if (a && (!e.state.draggingText || +new Date() - Do < 100)) ke(t);else if (!me(e, t) && !wr(e.display, t) && (t.dataTransfer.setData("Text", e.getSelection()), t.dataTransfer.effectAllowed = "copyMove", t.dataTransfer.setDragImage && !f)) {
                      var r = M("img", null, null, "position: fixed; left: 0; top: 0;");
                      r.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==", d && (r.width = r.height = 1, e.display.wrapper.appendChild(r), r._top = r.offsetTop), t.dataTransfer.setDragImage(r, 0, 0), d && r.parentNode.removeChild(r);
                    }
                  }(e, t);
                },
                drop: ei(e, Ro),
                leave: function (t) {
                  me(e, t) || Wo(e);
                }
              };
              var c = t.input.getField();
              de(c, "keyup", function (t) {
                return da.call(e, t);
              }), de(c, "keydown", ei(e, ua)), de(c, "keypress", ei(e, fa)), de(c, "focus", function (t) {
                return Sn(e, t);
              }), de(c, "blur", function (t) {
                return Tn(e, t);
              });
            }(this), Ho(), Kn(this), this.curOp.forceUpdate = !0, Ii(this, n), t.autofocus && !v || this.hasFocus() ? setTimeout(function () {
              r.hasFocus() && !r.state.focused && Sn(r);
            }, 20) : Tn(this), Sa) Sa.hasOwnProperty(c) && Sa[c](this, t[c], ka);
            fi(this), t.finishInit && t.finishInit(this);
            for (var u = 0; u < Ea.length; ++u) Ea[u](this);
            Yn(this), s && t.lineWrapping && "optimizelegibility" == getComputedStyle(o.lineDiv).textRendering && (o.lineDiv.style.textRendering = "auto");
          }
          Na.defaults = Ca, Na.optionHandlers = Sa;
          var Ea = [];
          function Ma(e, t, r, n) {
            var i,
              o = e.doc;
            null == r && (r = "add"), "smart" == r && (o.mode.indent ? i = ht(e, t).state : r = "prev");
            var a = e.options.tabSize,
              l = Ke(o, t),
              s = F(l.text, null, a);
            l.stateAfter && (l.stateAfter = null);
            var c,
              u = l.text.match(/^\s*/)[0];
            if (n || /\S/.test(l.text)) {
              if ("smart" == r && ((c = o.mode.indent(i, l.text.slice(u.length), l.text)) == B || c > 150)) {
                if (!n) return;
                r = "prev";
              }
            } else c = 0, r = "not";
            "prev" == r ? c = t > o.first ? F(Ke(o, t - 1).text, null, a) : 0 : "add" == r ? c = s + e.options.indentUnit : "subtract" == r ? c = s - e.options.indentUnit : "number" == typeof r && (c = s + r), c = Math.max(0, c);
            var d = "",
              f = 0;
            if (e.options.indentWithTabs) for (var h = Math.floor(c / a); h; --h) f += a, d += "\t";
            if (f < c && (d += Y(c - f)), d != u) return mo(o, d, et(t, 0), et(t, u.length), "+input"), l.stateAfter = null, !0;
            for (var p = 0; p < o.sel.ranges.length; p++) {
              var m = o.sel.ranges[p];
              if (m.head.line == t && m.head.ch < u.length) {
                var g = et(t, u.length);
                $i(o, p, new Ci(g, g));
                break;
              }
            }
          }
          Na.defineInitHook = function (e) {
            return Ea.push(e);
          };
          var Aa = null;
          function Oa(e) {
            Aa = e;
          }
          function Da(e, t, r, n, i) {
            var o = e.doc;
            e.display.shift = !1, n || (n = o.sel);
            var a = +new Date() - 200,
              l = "paste" == i || e.state.pasteIncoming > a,
              s = Oe(t),
              c = null;
            if (l && n.ranges.length > 1) if (Aa && Aa.text.join("\n") == t) {
              if (n.ranges.length % Aa.text.length == 0) {
                c = [];
                for (var u = 0; u < Aa.text.length; u++) c.push(o.splitLines(Aa.text[u]));
              }
            } else s.length == n.ranges.length && e.options.pasteLinesPerSelection && (c = q(s, function (e) {
              return [e];
            }));
            for (var d = e.curOp.updateInput, f = n.ranges.length - 1; f >= 0; f--) {
              var h = n.ranges[f],
                p = h.from(),
                m = h.to();
              h.empty() && (r && r > 0 ? p = et(p.line, p.ch - r) : e.state.overwrite && !l ? m = et(m.line, Math.min(Ke(o, m.line).text.length, m.ch + X(s).length)) : l && Aa && Aa.lineWise && Aa.text.join("\n") == s.join("\n") && (p = m = et(p.line, 0)));
              var g = {
                from: p,
                to: m,
                text: c ? c[f % c.length] : s,
                origin: i || (l ? "paste" : e.state.cutIncoming > a ? "cut" : "+input")
              };
              co(e.doc, g), lr(e, "inputRead", e, g);
            }
            t && !l && Wa(e, t), On(e), e.curOp.updateInput < 2 && (e.curOp.updateInput = d), e.curOp.typing = !0, e.state.pasteIncoming = e.state.cutIncoming = -1;
          }
          function Ra(e, t) {
            var r = e.clipboardData && e.clipboardData.getData("Text");
            if (r) return e.preventDefault(), t.isReadOnly() || t.options.disableInput || Qn(t, function () {
              return Da(t, r, 0, null, "paste");
            }), !0;
          }
          function Wa(e, t) {
            if (e.options.electricChars && e.options.smartIndent) for (var r = e.doc.sel, n = r.ranges.length - 1; n >= 0; n--) {
              var i = r.ranges[n];
              if (!(i.head.ch > 100 || n && r.ranges[n - 1].head.line == i.head.line)) {
                var o = e.getModeAt(i.head),
                  a = !1;
                if (o.electricChars) {
                  for (var l = 0; l < o.electricChars.length; l++) if (t.indexOf(o.electricChars.charAt(l)) > -1) {
                    a = Ma(e, i.head.line, "smart");
                    break;
                  }
                } else o.electricInput && o.electricInput.test(Ke(e.doc, i.head.line).text.slice(0, i.head.ch)) && (a = Ma(e, i.head.line, "smart"));
                a && lr(e, "electricInput", e, i.head.line);
              }
            }
          }
          function Ia(e) {
            for (var t = [], r = [], n = 0; n < e.doc.sel.ranges.length; n++) {
              var i = e.doc.sel.ranges[n].head.line,
                o = {
                  anchor: et(i, 0),
                  head: et(i + 1, 0)
                };
              r.push(o), t.push(e.getRange(o.anchor, o.head));
            }
            return {
              text: t,
              ranges: r
            };
          }
          function Pa(e, t, r, n) {
            e.setAttribute("autocorrect", r ? "" : "off"), e.setAttribute("autocapitalize", n ? "" : "off"), e.setAttribute("spellcheck", !!t);
          }
          function Ha() {
            var e = M("textarea", null, null, "position: absolute; bottom: -1em; padding: 0; width: 1px; height: 1em; min-height: 1em; outline: none"),
              t = M("div", [e], null, "overflow: hidden; position: relative; width: 3px; height: 0px;");
            return s ? e.style.width = "1000px" : e.setAttribute("wrap", "off"), m && (e.style.border = "1px solid black"), Pa(e), t;
          }
          function Fa(e, t, r, n, i) {
            var o = t,
              a = r,
              l = Ke(e, t.line),
              s = i && "rtl" == e.direction ? -r : r;
            function c(o) {
              var a, c;
              if ("codepoint" == n) {
                var u = l.text.charCodeAt(t.ch + (r > 0 ? 0 : -1));
                if (isNaN(u)) a = null;else {
                  var d = r > 0 ? u >= 55296 && u < 56320 : u >= 56320 && u < 57343;
                  a = new et(t.line, Math.max(0, Math.min(l.text.length, t.ch + r * (d ? 2 : 1))), -r);
                }
              } else a = i ? function (e, t, r, n) {
                var i = ce(t, e.doc.direction);
                if (!i) return Qo(t, r, n);
                r.ch >= t.text.length ? (r.ch = t.text.length, r.sticky = "before") : r.ch <= 0 && (r.ch = 0, r.sticky = "after");
                var o = le(i, r.ch, r.sticky),
                  a = i[o];
                if ("ltr" == e.doc.direction && a.level % 2 == 0 && (n > 0 ? a.to > r.ch : a.from < r.ch)) return Qo(t, r, n);
                var l,
                  s = function (e, r) {
                    return Zo(t, e instanceof et ? e.ch : e, r);
                  },
                  c = function (r) {
                    return e.options.lineWrapping ? (l = l || Or(e, t), Jr(e, t, l, r)) : {
                      begin: 0,
                      end: t.text.length
                    };
                  },
                  u = c("before" == r.sticky ? s(r, -1) : r.ch);
                if ("rtl" == e.doc.direction || 1 == a.level) {
                  var d = 1 == a.level == n < 0,
                    f = s(r, d ? 1 : -1);
                  if (null != f && (d ? f <= a.to && f <= u.end : f >= a.from && f >= u.begin)) {
                    var h = d ? "before" : "after";
                    return new et(r.line, f, h);
                  }
                }
                var p = function (e, t, n) {
                    for (var o = function (e, t) {
                      return t ? new et(r.line, s(e, 1), "before") : new et(r.line, e, "after");
                    }; e >= 0 && e < i.length; e += t) {
                      var a = i[e],
                        l = t > 0 == (1 != a.level),
                        c = l ? n.begin : s(n.end, -1);
                      if (a.from <= c && c < a.to) return o(c, l);
                      if (c = l ? a.from : s(a.to, -1), n.begin <= c && c < n.end) return o(c, l);
                    }
                  },
                  m = p(o + n, n, u);
                if (m) return m;
                var g = n > 0 ? u.end : s(u.begin, -1);
                return null == g || n > 0 && g == t.text.length || !(m = p(n > 0 ? 0 : i.length - 1, n, c(g))) ? null : m;
              }(e.cm, l, t, r) : Qo(l, t, r);
              if (null == a) {
                if (o || (c = t.line + s) < e.first || c >= e.first + e.size || (t = new et(c, t.ch, t.sticky), !(l = Ke(e, c)))) return !1;
                t = ea(i, e.cm, l, t.line, s);
              } else t = a;
              return !0;
            }
            if ("char" == n || "codepoint" == n) c();else if ("column" == n) c(!0);else if ("word" == n || "group" == n) for (var u = null, d = "group" == n, f = e.cm && e.cm.getHelper(t, "wordChars"), h = !0; !(r < 0) || c(!h); h = !1) {
              var p = l.text.charAt(t.ch) || "\n",
                m = ee(p, f) ? "w" : d && "\n" == p ? "n" : !d || /\s/.test(p) ? null : "p";
              if (!d || h || m || (m = "s"), u && u != m) {
                r < 0 && (r = 1, c(), t.sticky = "after");
                break;
              }
              if (m && (u = m), r > 0 && !c(!h)) break;
            }
            var g = oo(e, t, o, a, !0);
            return rt(o, g) && (g.hitSide = !0), g;
          }
          function za(e, t, r, n) {
            var i,
              o,
              a = e.doc,
              l = t.left;
            if ("page" == n) {
              var s = Math.min(e.display.wrapper.clientHeight, window.innerHeight || document.documentElement.clientHeight),
                c = Math.max(s - .5 * rn(e.display), 3);
              i = (r > 0 ? t.bottom : t.top) + r * c;
            } else "line" == n && (i = r > 0 ? t.bottom + 3 : t.top - 3);
            for (; (o = qr(e, l, i)).outside;) {
              if (r < 0 ? i <= 0 : i >= a.height) {
                o.hitSide = !0;
                break;
              }
              i += 5 * r;
            }
            return o;
          }
          var _a = function (e) {
            this.cm = e, this.lastAnchorNode = this.lastAnchorOffset = this.lastFocusNode = this.lastFocusOffset = null, this.polling = new z(), this.composing = null, this.gracePeriod = !1, this.readDOMTimeout = null;
          };
          function Ba(e, t) {
            var r = Ar(e, t.line);
            if (!r || r.hidden) return null;
            var n = Ke(e.doc, t.line),
              i = Er(r, n, t.line),
              o = ce(n, e.doc.direction),
              a = "left";
            o && (a = le(o, t.ch) % 2 ? "right" : "left");
            var l = Ir(i.map, t.ch, a);
            return l.offset = "right" == l.collapse ? l.end : l.start, l;
          }
          function ja(e, t) {
            return t && (e.bad = !0), e;
          }
          function Ua(e, t, r) {
            var n;
            if (t == e.display.lineDiv) {
              if (!(n = e.display.lineDiv.childNodes[r])) return ja(e.clipPos(et(e.display.viewTo - 1)), !0);
              t = null, r = 0;
            } else for (n = t;; n = n.parentNode) {
              if (!n || n == e.display.lineDiv) return null;
              if (n.parentNode && n.parentNode == e.display.lineDiv) break;
            }
            for (var i = 0; i < e.display.view.length; i++) {
              var o = e.display.view[i];
              if (o.node == n) return Ga(o, t, r);
            }
          }
          function Ga(e, t, r) {
            var n = e.text.firstChild,
              i = !1;
            if (!t || !O(n, t)) return ja(et($e(e.line), 0), !0);
            if (t == n && (i = !0, t = n.childNodes[r], r = 0, !t)) {
              var o = e.rest ? X(e.rest) : e.line;
              return ja(et($e(o), o.text.length), i);
            }
            var a = 3 == t.nodeType ? t : null,
              l = t;
            for (a || 1 != t.childNodes.length || 3 != t.firstChild.nodeType || (a = t.firstChild, r && (r = a.nodeValue.length)); l.parentNode != n;) l = l.parentNode;
            var s = e.measure,
              c = s.maps;
            function u(t, r, n) {
              for (var i = -1; i < (c ? c.length : 0); i++) for (var o = i < 0 ? s.map : c[i], a = 0; a < o.length; a += 3) {
                var l = o[a + 2];
                if (l == t || l == r) {
                  var u = $e(i < 0 ? e.line : e.rest[i]),
                    d = o[a] + n;
                  return (n < 0 || l != t) && (d = o[a + (n ? 1 : 0)]), et(u, d);
                }
              }
            }
            var d = u(a, l, r);
            if (d) return ja(d, i);
            for (var f = l.nextSibling, h = a ? a.nodeValue.length - r : 0; f; f = f.nextSibling) {
              if (d = u(f, f.firstChild, 0)) return ja(et(d.line, d.ch - h), i);
              h += f.textContent.length;
            }
            for (var p = l.previousSibling, m = r; p; p = p.previousSibling) {
              if (d = u(p, p.firstChild, -1)) return ja(et(d.line, d.ch + m), i);
              m += p.textContent.length;
            }
          }
          _a.prototype.init = function (e) {
            var t = this,
              r = this,
              n = r.cm,
              i = r.div = e.lineDiv;
            function o(e) {
              for (var t = e.target; t; t = t.parentNode) {
                if (t == i) return !0;
                if (/\bCodeMirror-(?:line)?widget\b/.test(t.className)) break;
              }
              return !1;
            }
            function a(e) {
              if (o(e) && !me(n, e)) {
                if (n.somethingSelected()) Oa({
                  lineWise: !1,
                  text: n.getSelections()
                }), "cut" == e.type && n.replaceSelection("", null, "cut");else {
                  if (!n.options.lineWiseCopyCut) return;
                  var t = Ia(n);
                  Oa({
                    lineWise: !0,
                    text: t.text
                  }), "cut" == e.type && n.operation(function () {
                    n.setSelections(t.ranges, 0, j), n.replaceSelection("", null, "cut");
                  });
                }
                if (e.clipboardData) {
                  e.clipboardData.clearData();
                  var a = Aa.text.join("\n");
                  if (e.clipboardData.setData("Text", a), e.clipboardData.getData("Text") == a) return void e.preventDefault();
                }
                var l = Ha(),
                  s = l.firstChild;
                n.display.lineSpace.insertBefore(l, n.display.lineSpace.firstChild), s.value = Aa.text.join("\n");
                var c = D();
                I(s), setTimeout(function () {
                  n.display.lineSpace.removeChild(l), c.focus(), c == i && r.showPrimarySelection();
                }, 50);
              }
            }
            i.contentEditable = !0, Pa(i, n.options.spellcheck, n.options.autocorrect, n.options.autocapitalize), de(i, "paste", function (e) {
              !o(e) || me(n, e) || Ra(e, n) || l <= 11 && setTimeout(ei(n, function () {
                return t.updateFromDOM();
              }), 20);
            }), de(i, "compositionstart", function (e) {
              t.composing = {
                data: e.data,
                done: !1
              };
            }), de(i, "compositionupdate", function (e) {
              t.composing || (t.composing = {
                data: e.data,
                done: !1
              });
            }), de(i, "compositionend", function (e) {
              t.composing && (e.data != t.composing.data && t.readFromDOMSoon(), t.composing.done = !0);
            }), de(i, "touchstart", function () {
              return r.forceCompositionEnd();
            }), de(i, "input", function () {
              t.composing || t.readFromDOMSoon();
            }), de(i, "copy", a), de(i, "cut", a);
          }, _a.prototype.screenReaderLabelChanged = function (e) {
            e ? this.div.setAttribute("aria-label", e) : this.div.removeAttribute("aria-label");
          }, _a.prototype.prepareSelection = function () {
            var e = vn(this.cm, !1);
            return e.focus = D() == this.div, e;
          }, _a.prototype.showSelection = function (e, t) {
            e && this.cm.display.view.length && ((e.focus || t) && this.showPrimarySelection(), this.showMultipleSelections(e));
          }, _a.prototype.getSelection = function () {
            return this.cm.display.wrapper.ownerDocument.getSelection();
          }, _a.prototype.showPrimarySelection = function () {
            var e = this.getSelection(),
              t = this.cm,
              n = t.doc.sel.primary(),
              i = n.from(),
              o = n.to();
            if (t.display.viewTo == t.display.viewFrom || i.line >= t.display.viewTo || o.line < t.display.viewFrom) e.removeAllRanges();else {
              var a = Ua(t, e.anchorNode, e.anchorOffset),
                l = Ua(t, e.focusNode, e.focusOffset);
              if (!a || a.bad || !l || l.bad || 0 != tt(ot(a, l), i) || 0 != tt(it(a, l), o)) {
                var s = t.display.view,
                  c = i.line >= t.display.viewFrom && Ba(t, i) || {
                    node: s[0].measure.map[2],
                    offset: 0
                  },
                  u = o.line < t.display.viewTo && Ba(t, o);
                if (!u) {
                  var d = s[s.length - 1].measure,
                    f = d.maps ? d.maps[d.maps.length - 1] : d.map;
                  u = {
                    node: f[f.length - 1],
                    offset: f[f.length - 2] - f[f.length - 3]
                  };
                }
                if (c && u) {
                  var h,
                    p = e.rangeCount && e.getRangeAt(0);
                  try {
                    h = T(c.node, c.offset, u.offset, u.node);
                  } catch (e) {}
                  h && (!r && t.state.focused ? (e.collapse(c.node, c.offset), h.collapsed || (e.removeAllRanges(), e.addRange(h))) : (e.removeAllRanges(), e.addRange(h)), p && null == e.anchorNode ? e.addRange(p) : r && this.startGracePeriod()), this.rememberSelection();
                } else e.removeAllRanges();
              }
            }
          }, _a.prototype.startGracePeriod = function () {
            var e = this;
            clearTimeout(this.gracePeriod), this.gracePeriod = setTimeout(function () {
              e.gracePeriod = !1, e.selectionChanged() && e.cm.operation(function () {
                return e.cm.curOp.selectionChanged = !0;
              });
            }, 20);
          }, _a.prototype.showMultipleSelections = function (e) {
            E(this.cm.display.cursorDiv, e.cursors), E(this.cm.display.selectionDiv, e.selection);
          }, _a.prototype.rememberSelection = function () {
            var e = this.getSelection();
            this.lastAnchorNode = e.anchorNode, this.lastAnchorOffset = e.anchorOffset, this.lastFocusNode = e.focusNode, this.lastFocusOffset = e.focusOffset;
          }, _a.prototype.selectionInEditor = function () {
            var e = this.getSelection();
            if (!e.rangeCount) return !1;
            var t = e.getRangeAt(0).commonAncestorContainer;
            return O(this.div, t);
          }, _a.prototype.focus = function () {
            "nocursor" != this.cm.options.readOnly && (this.selectionInEditor() && D() == this.div || this.showSelection(this.prepareSelection(), !0), this.div.focus());
          }, _a.prototype.blur = function () {
            this.div.blur();
          }, _a.prototype.getField = function () {
            return this.div;
          }, _a.prototype.supportsTouch = function () {
            return !0;
          }, _a.prototype.receivedFocus = function () {
            var e = this,
              t = this;
            this.selectionInEditor() ? setTimeout(function () {
              return e.pollSelection();
            }, 20) : Qn(this.cm, function () {
              return t.cm.curOp.selectionChanged = !0;
            }), this.polling.set(this.cm.options.pollInterval, function e() {
              t.cm.state.focused && (t.pollSelection(), t.polling.set(t.cm.options.pollInterval, e));
            });
          }, _a.prototype.selectionChanged = function () {
            var e = this.getSelection();
            return e.anchorNode != this.lastAnchorNode || e.anchorOffset != this.lastAnchorOffset || e.focusNode != this.lastFocusNode || e.focusOffset != this.lastFocusOffset;
          }, _a.prototype.pollSelection = function () {
            if (null == this.readDOMTimeout && !this.gracePeriod && this.selectionChanged()) {
              var e = this.getSelection(),
                t = this.cm;
              if (g && u && this.cm.display.gutterSpecs.length && function (e) {
                for (var t = e; t; t = t.parentNode) if (/CodeMirror-gutter-wrapper/.test(t.className)) return !0;
                return !1;
              }(e.anchorNode)) return this.cm.triggerOnKeyDown({
                type: "keydown",
                keyCode: 8,
                preventDefault: Math.abs
              }), this.blur(), void this.focus();
              if (!this.composing) {
                this.rememberSelection();
                var r = Ua(t, e.anchorNode, e.anchorOffset),
                  n = Ua(t, e.focusNode, e.focusOffset);
                r && n && Qn(t, function () {
                  Qi(t.doc, Ti(r, n), j), (r.bad || n.bad) && (t.curOp.selectionChanged = !0);
                });
              }
            }
          }, _a.prototype.pollContent = function () {
            null != this.readDOMTimeout && (clearTimeout(this.readDOMTimeout), this.readDOMTimeout = null);
            var e,
              t,
              r,
              n = this.cm,
              i = n.display,
              o = n.doc.sel.primary(),
              a = o.from(),
              l = o.to();
            if (0 == a.ch && a.line > n.firstLine() && (a = et(a.line - 1, Ke(n.doc, a.line - 1).length)), l.ch == Ke(n.doc, l.line).text.length && l.line < n.lastLine() && (l = et(l.line + 1, 0)), a.line < i.viewFrom || l.line > i.viewTo - 1) return !1;
            a.line == i.viewFrom || 0 == (e = un(n, a.line)) ? (t = $e(i.view[0].line), r = i.view[0].node) : (t = $e(i.view[e].line), r = i.view[e - 1].node.nextSibling);
            var s,
              c,
              u = un(n, l.line);
            if (u == i.view.length - 1 ? (s = i.viewTo - 1, c = i.lineDiv.lastChild) : (s = $e(i.view[u + 1].line) - 1, c = i.view[u + 1].node.previousSibling), !r) return !1;
            for (var d = n.doc.splitLines(function (e, t, r, n, i) {
                var o = "",
                  a = !1,
                  l = e.doc.lineSeparator(),
                  s = !1;
                function c() {
                  a && (o += l, s && (o += l), a = s = !1);
                }
                function u(e) {
                  e && (c(), o += e);
                }
                function d(t) {
                  if (1 == t.nodeType) {
                    var r = t.getAttribute("cm-text");
                    if (r) return void u(r);
                    var o,
                      f = t.getAttribute("cm-marker");
                    if (f) {
                      var h = e.findMarks(et(n, 0), et(i + 1, 0), (g = +f, function (e) {
                        return e.id == g;
                      }));
                      return void (h.length && (o = h[0].find(0)) && u(Ye(e.doc, o.from, o.to).join(l)));
                    }
                    if ("false" == t.getAttribute("contenteditable")) return;
                    var p = /^(pre|div|p|li|table|br)$/i.test(t.nodeName);
                    if (!/^br$/i.test(t.nodeName) && 0 == t.textContent.length) return;
                    p && c();
                    for (var m = 0; m < t.childNodes.length; m++) d(t.childNodes[m]);
                    /^(pre|p)$/i.test(t.nodeName) && (s = !0), p && (a = !0);
                  } else 3 == t.nodeType && u(t.nodeValue.replace(/\u200b/g, "").replace(/\u00a0/g, " "));
                  var g;
                }
                for (; d(t), t != r;) t = t.nextSibling, s = !1;
                return o;
              }(n, r, c, t, s)), f = Ye(n.doc, et(t, 0), et(s, Ke(n.doc, s).text.length)); d.length > 1 && f.length > 1;) if (X(d) == X(f)) d.pop(), f.pop(), s--;else {
              if (d[0] != f[0]) break;
              d.shift(), f.shift(), t++;
            }
            for (var h = 0, p = 0, m = d[0], g = f[0], v = Math.min(m.length, g.length); h < v && m.charCodeAt(h) == g.charCodeAt(h);) ++h;
            for (var y = X(d), b = X(f), x = Math.min(y.length - (1 == d.length ? h : 0), b.length - (1 == f.length ? h : 0)); p < x && y.charCodeAt(y.length - p - 1) == b.charCodeAt(b.length - p - 1);) ++p;
            if (1 == d.length && 1 == f.length && t == a.line) for (; h && h > a.ch && y.charCodeAt(y.length - p - 1) == b.charCodeAt(b.length - p - 1);) h--, p++;
            d[d.length - 1] = y.slice(0, y.length - p).replace(/^\u200b+/, ""), d[0] = d[0].slice(h).replace(/\u200b+$/, "");
            var w = et(t, h),
              k = et(s, f.length ? X(f).length - p : 0);
            return d.length > 1 || d[0] || tt(w, k) ? (mo(n.doc, d, w, k, "+input"), !0) : void 0;
          }, _a.prototype.ensurePolled = function () {
            this.forceCompositionEnd();
          }, _a.prototype.reset = function () {
            this.forceCompositionEnd();
          }, _a.prototype.forceCompositionEnd = function () {
            this.composing && (clearTimeout(this.readDOMTimeout), this.composing = null, this.updateFromDOM(), this.div.blur(), this.div.focus());
          }, _a.prototype.readFromDOMSoon = function () {
            var e = this;
            null == this.readDOMTimeout && (this.readDOMTimeout = setTimeout(function () {
              if (e.readDOMTimeout = null, e.composing) {
                if (!e.composing.done) return;
                e.composing = null;
              }
              e.updateFromDOM();
            }, 80));
          }, _a.prototype.updateFromDOM = function () {
            var e = this;
            !this.cm.isReadOnly() && this.pollContent() || Qn(this.cm, function () {
              return dn(e.cm);
            });
          }, _a.prototype.setUneditable = function (e) {
            e.contentEditable = "false";
          }, _a.prototype.onKeyPress = function (e) {
            0 == e.charCode || this.composing || (e.preventDefault(), this.cm.isReadOnly() || ei(this.cm, Da)(this.cm, String.fromCharCode(null == e.charCode ? e.keyCode : e.charCode), 0));
          }, _a.prototype.readOnlyChanged = function (e) {
            this.div.contentEditable = String("nocursor" != e);
          }, _a.prototype.onContextMenu = function () {}, _a.prototype.resetPosition = function () {}, _a.prototype.needsContentAttribute = !0;
          var Va = function (e) {
            this.cm = e, this.prevInput = "", this.pollingFast = !1, this.polling = new z(), this.hasSelection = !1, this.composing = null;
          };
          Va.prototype.init = function (e) {
            var t = this,
              r = this,
              n = this.cm;
            this.createField(e);
            var i = this.textarea;
            function o(e) {
              if (!me(n, e)) {
                if (n.somethingSelected()) Oa({
                  lineWise: !1,
                  text: n.getSelections()
                });else {
                  if (!n.options.lineWiseCopyCut) return;
                  var t = Ia(n);
                  Oa({
                    lineWise: !0,
                    text: t.text
                  }), "cut" == e.type ? n.setSelections(t.ranges, null, j) : (r.prevInput = "", i.value = t.text.join("\n"), I(i));
                }
                "cut" == e.type && (n.state.cutIncoming = +new Date());
              }
            }
            e.wrapper.insertBefore(this.wrapper, e.wrapper.firstChild), m && (i.style.width = "0px"), de(i, "input", function () {
              a && l >= 9 && t.hasSelection && (t.hasSelection = null), r.poll();
            }), de(i, "paste", function (e) {
              me(n, e) || Ra(e, n) || (n.state.pasteIncoming = +new Date(), r.fastPoll());
            }), de(i, "cut", o), de(i, "copy", o), de(e.scroller, "paste", function (t) {
              if (!wr(e, t) && !me(n, t)) {
                if (!i.dispatchEvent) return n.state.pasteIncoming = +new Date(), void r.focus();
                var o = new Event("paste");
                o.clipboardData = t.clipboardData, i.dispatchEvent(o);
              }
            }), de(e.lineSpace, "selectstart", function (t) {
              wr(e, t) || be(t);
            }), de(i, "compositionstart", function () {
              var e = n.getCursor("from");
              r.composing && r.composing.range.clear(), r.composing = {
                start: e,
                range: n.markText(e, n.getCursor("to"), {
                  className: "CodeMirror-composing"
                })
              };
            }), de(i, "compositionend", function () {
              r.composing && (r.poll(), r.composing.range.clear(), r.composing = null);
            });
          }, Va.prototype.createField = function (e) {
            this.wrapper = Ha(), this.textarea = this.wrapper.firstChild;
          }, Va.prototype.screenReaderLabelChanged = function (e) {
            e ? this.textarea.setAttribute("aria-label", e) : this.textarea.removeAttribute("aria-label");
          }, Va.prototype.prepareSelection = function () {
            var e = this.cm,
              t = e.display,
              r = e.doc,
              n = vn(e);
            if (e.options.moveInputWithCursor) {
              var i = Kr(e, r.sel.primary().head, "div"),
                o = t.wrapper.getBoundingClientRect(),
                a = t.lineDiv.getBoundingClientRect();
              n.teTop = Math.max(0, Math.min(t.wrapper.clientHeight - 10, i.top + a.top - o.top)), n.teLeft = Math.max(0, Math.min(t.wrapper.clientWidth - 10, i.left + a.left - o.left));
            }
            return n;
          }, Va.prototype.showSelection = function (e) {
            var t = this.cm.display;
            E(t.cursorDiv, e.cursors), E(t.selectionDiv, e.selection), null != e.teTop && (this.wrapper.style.top = e.teTop + "px", this.wrapper.style.left = e.teLeft + "px");
          }, Va.prototype.reset = function (e) {
            if (!this.contextMenuPending && !this.composing) {
              var t = this.cm;
              if (t.somethingSelected()) {
                this.prevInput = "";
                var r = t.getSelection();
                this.textarea.value = r, t.state.focused && I(this.textarea), a && l >= 9 && (this.hasSelection = r);
              } else e || (this.prevInput = this.textarea.value = "", a && l >= 9 && (this.hasSelection = null));
            }
          }, Va.prototype.getField = function () {
            return this.textarea;
          }, Va.prototype.supportsTouch = function () {
            return !1;
          }, Va.prototype.focus = function () {
            if ("nocursor" != this.cm.options.readOnly && (!v || D() != this.textarea)) try {
              this.textarea.focus();
            } catch (e) {}
          }, Va.prototype.blur = function () {
            this.textarea.blur();
          }, Va.prototype.resetPosition = function () {
            this.wrapper.style.top = this.wrapper.style.left = 0;
          }, Va.prototype.receivedFocus = function () {
            this.slowPoll();
          }, Va.prototype.slowPoll = function () {
            var e = this;
            this.pollingFast || this.polling.set(this.cm.options.pollInterval, function () {
              e.poll(), e.cm.state.focused && e.slowPoll();
            });
          }, Va.prototype.fastPoll = function () {
            var e = !1,
              t = this;
            t.pollingFast = !0, t.polling.set(20, function r() {
              t.poll() || e ? (t.pollingFast = !1, t.slowPoll()) : (e = !0, t.polling.set(60, r));
            });
          }, Va.prototype.poll = function () {
            var e = this,
              t = this.cm,
              r = this.textarea,
              n = this.prevInput;
            if (this.contextMenuPending || !t.state.focused || De(r) && !n && !this.composing || t.isReadOnly() || t.options.disableInput || t.state.keySeq) return !1;
            var i = r.value;
            if (i == n && !t.somethingSelected()) return !1;
            if (a && l >= 9 && this.hasSelection === i || y && /[\uf700-\uf7ff]/.test(i)) return t.display.input.reset(), !1;
            if (t.doc.sel == t.display.selForContextMenu) {
              var o = i.charCodeAt(0);
              if (8203 != o || n || (n = "​"), 8666 == o) return this.reset(), this.cm.execCommand("undo");
            }
            for (var s = 0, c = Math.min(n.length, i.length); s < c && n.charCodeAt(s) == i.charCodeAt(s);) ++s;
            return Qn(t, function () {
              Da(t, i.slice(s), n.length - s, null, e.composing ? "*compose" : null), i.length > 1e3 || i.indexOf("\n") > -1 ? r.value = e.prevInput = "" : e.prevInput = i, e.composing && (e.composing.range.clear(), e.composing.range = t.markText(e.composing.start, t.getCursor("to"), {
                className: "CodeMirror-composing"
              }));
            }), !0;
          }, Va.prototype.ensurePolled = function () {
            this.pollingFast && this.poll() && (this.pollingFast = !1);
          }, Va.prototype.onKeyPress = function () {
            a && l >= 9 && (this.hasSelection = null), this.fastPoll();
          }, Va.prototype.onContextMenu = function (e) {
            var t = this,
              r = t.cm,
              n = r.display,
              i = t.textarea;
            t.contextMenuPending && t.contextMenuPending();
            var o = cn(r, e),
              c = n.scroller.scrollTop;
            if (o && !d) {
              r.options.resetSelectionOnContextMenu && -1 == r.doc.sel.contains(o) && ei(r, Qi)(r.doc, Ti(o), j);
              var u,
                f = i.style.cssText,
                h = t.wrapper.style.cssText,
                p = t.wrapper.offsetParent.getBoundingClientRect();
              if (t.wrapper.style.cssText = "position: static", i.style.cssText = "position: absolute; width: 30px; height: 30px;\n      top: " + (e.clientY - p.top - 5) + "px; left: " + (e.clientX - p.left - 5) + "px;\n      z-index: 1000; background: " + (a ? "rgba(255, 255, 255, .05)" : "transparent") + ";\n      outline: none; border-width: 0; outline: none; overflow: hidden; opacity: .05; filter: alpha(opacity=5);", s && (u = window.scrollY), n.input.focus(), s && window.scrollTo(null, u), n.input.reset(), r.somethingSelected() || (i.value = t.prevInput = " "), t.contextMenuPending = v, n.selForContextMenu = r.doc.sel, clearTimeout(n.detectingSelectAll), a && l >= 9 && g(), C) {
                ke(e);
                var m = function () {
                  he(window, "mouseup", m), setTimeout(v, 20);
                };
                de(window, "mouseup", m);
              } else setTimeout(v, 50);
            }
            function g() {
              if (null != i.selectionStart) {
                var e = r.somethingSelected(),
                  o = "​" + (e ? i.value : "");
                i.value = "⇚", i.value = o, t.prevInput = e ? "" : "​", i.selectionStart = 1, i.selectionEnd = o.length, n.selForContextMenu = r.doc.sel;
              }
            }
            function v() {
              if (t.contextMenuPending == v && (t.contextMenuPending = !1, t.wrapper.style.cssText = h, i.style.cssText = f, a && l < 9 && n.scrollbars.setScrollTop(n.scroller.scrollTop = c), null != i.selectionStart)) {
                (!a || a && l < 9) && g();
                var e = 0,
                  o = function () {
                    n.selForContextMenu == r.doc.sel && 0 == i.selectionStart && i.selectionEnd > 0 && "​" == t.prevInput ? ei(r, lo)(r) : e++ < 10 ? n.detectingSelectAll = setTimeout(o, 500) : (n.selForContextMenu = null, n.input.reset());
                  };
                n.detectingSelectAll = setTimeout(o, 200);
              }
            }
          }, Va.prototype.readOnlyChanged = function (e) {
            e || this.reset(), this.textarea.disabled = "nocursor" == e, this.textarea.readOnly = !!e;
          }, Va.prototype.setUneditable = function () {}, Va.prototype.needsContentAttribute = !1, function (e) {
            var t = e.optionHandlers;
            function r(r, n, i, o) {
              e.defaults[r] = n, i && (t[r] = o ? function (e, t, r) {
                r != ka && i(e, t, r);
              } : i);
            }
            e.defineOption = r, e.Init = ka, r("value", "", function (e, t) {
              return e.setValue(t);
            }, !0), r("mode", null, function (e, t) {
              e.doc.modeOption = t, Ai(e);
            }, !0), r("indentUnit", 2, Ai, !0), r("indentWithTabs", !1), r("smartIndent", !0), r("tabSize", 4, function (e) {
              Oi(e), zr(e), dn(e);
            }, !0), r("lineSeparator", null, function (e, t) {
              if (e.doc.lineSep = t, t) {
                var r = [],
                  n = e.doc.first;
                e.doc.iter(function (e) {
                  for (var i = 0;;) {
                    var o = e.text.indexOf(t, i);
                    if (-1 == o) break;
                    i = o + t.length, r.push(et(n, o));
                  }
                  n++;
                });
                for (var i = r.length - 1; i >= 0; i--) mo(e.doc, t, r[i], et(r[i].line, r[i].ch + t.length));
              }
            }), r("specialChars", /[\u0000-\u001f\u007f-\u009f\u00ad\u061c\u200b\u200e\u200f\u2028\u2029\ufeff\ufff9-\ufffc]/g, function (e, t, r) {
              e.state.specialChars = new RegExp(t.source + (t.test("\t") ? "" : "|\t"), "g"), r != ka && e.refresh();
            }), r("specialCharPlaceholder", Zt, function (e) {
              return e.refresh();
            }, !0), r("electricChars", !0), r("inputStyle", v ? "contenteditable" : "textarea", function () {
              throw new Error("inputStyle can not (yet) be changed in a running editor");
            }, !0), r("spellcheck", !1, function (e, t) {
              return e.getInputField().spellcheck = t;
            }, !0), r("autocorrect", !1, function (e, t) {
              return e.getInputField().autocorrect = t;
            }, !0), r("autocapitalize", !1, function (e, t) {
              return e.getInputField().autocapitalize = t;
            }, !0), r("rtlMoveVisually", !x), r("wholeLineUpdateBefore", !0), r("theme", "default", function (e) {
              wa(e), mi(e);
            }, !0), r("keyMap", "default", function (e, t, r) {
              var n = $o(t),
                i = r != ka && $o(r);
              i && i.detach && i.detach(e, n), n.attach && n.attach(e, i || null);
            }), r("extraKeys", null), r("configureMouse", null), r("lineWrapping", !1, La, !0), r("gutters", [], function (e, t) {
              e.display.gutterSpecs = hi(t, e.options.lineNumbers), mi(e);
            }, !0), r("fixedGutter", !0, function (e, t) {
              e.display.gutters.style.left = t ? an(e.display) + "px" : "0", e.refresh();
            }, !0), r("coverGutterNextToScrollbar", !1, function (e) {
              return Bn(e);
            }, !0), r("scrollbarStyle", "native", function (e) {
              Gn(e), Bn(e), e.display.scrollbars.setScrollTop(e.doc.scrollTop), e.display.scrollbars.setScrollLeft(e.doc.scrollLeft);
            }, !0), r("lineNumbers", !1, function (e, t) {
              e.display.gutterSpecs = hi(e.options.gutters, t), mi(e);
            }, !0), r("firstLineNumber", 1, mi, !0), r("lineNumberFormatter", function (e) {
              return e;
            }, mi, !0), r("showCursorWhenSelecting", !1, gn, !0), r("resetSelectionOnContextMenu", !0), r("lineWiseCopyCut", !0), r("pasteLinesPerSelection", !0), r("selectionsMayTouch", !1), r("readOnly", !1, function (e, t) {
              "nocursor" == t && (Tn(e), e.display.input.blur()), e.display.input.readOnlyChanged(t);
            }), r("screenReaderLabel", null, function (e, t) {
              t = "" === t ? null : t, e.display.input.screenReaderLabelChanged(t);
            }), r("disableInput", !1, function (e, t) {
              t || e.display.input.reset();
            }, !0), r("dragDrop", !0, Ta), r("allowDropFileTypes", null), r("cursorBlinkRate", 530), r("cursorScrollMargin", 0), r("cursorHeight", 1, gn, !0), r("singleCursorHeightPerLine", !0, gn, !0), r("workTime", 100), r("workDelay", 100), r("flattenSpans", !0, Oi, !0), r("addModeClass", !1, Oi, !0), r("pollInterval", 100), r("undoDepth", 200, function (e, t) {
              return e.doc.history.undoDepth = t;
            }), r("historyEventDelay", 1250), r("viewportMargin", 10, function (e) {
              return e.refresh();
            }, !0), r("maxHighlightLength", 1e4, Oi, !0), r("moveInputWithCursor", !0, function (e, t) {
              t || e.display.input.resetPosition();
            }), r("tabindex", null, function (e, t) {
              return e.display.input.getField().tabIndex = t || "";
            }), r("autofocus", null), r("direction", "ltr", function (e, t) {
              return e.doc.setDirection(t);
            }, !0), r("phrases", null);
          }(Na), function (e) {
            var t = e.optionHandlers,
              r = e.helpers = {};
            e.prototype = {
              constructor: e,
              focus: function () {
                window.focus(), this.display.input.focus();
              },
              setOption: function (e, r) {
                var n = this.options,
                  i = n[e];
                n[e] == r && "mode" != e || (n[e] = r, t.hasOwnProperty(e) && ei(this, t[e])(this, r, i), pe(this, "optionChange", this, e));
              },
              getOption: function (e) {
                return this.options[e];
              },
              getDoc: function () {
                return this.doc;
              },
              addKeyMap: function (e, t) {
                this.state.keyMaps[t ? "push" : "unshift"]($o(e));
              },
              removeKeyMap: function (e) {
                for (var t = this.state.keyMaps, r = 0; r < t.length; ++r) if (t[r] == e || t[r].name == e) return t.splice(r, 1), !0;
              },
              addOverlay: ti(function (t, r) {
                var n = t.token ? t : e.getMode(this.options, t);
                if (n.startState) throw new Error("Overlays may not be stateful.");
                (function (e, t, r) {
                  for (var n = 0, i = r(t); n < e.length && r(e[n]) <= i;) n++;
                  e.splice(n, 0, t);
                })(this.state.overlays, {
                  mode: n,
                  modeSpec: t,
                  opaque: r && r.opaque,
                  priority: r && r.priority || 0
                }, function (e) {
                  return e.priority;
                }), this.state.modeGen++, dn(this);
              }),
              removeOverlay: ti(function (e) {
                for (var t = this.state.overlays, r = 0; r < t.length; ++r) {
                  var n = t[r].modeSpec;
                  if (n == e || "string" == typeof e && n.name == e) return t.splice(r, 1), this.state.modeGen++, void dn(this);
                }
              }),
              indentLine: ti(function (e, t, r) {
                "string" != typeof t && "number" != typeof t && (t = null == t ? this.options.smartIndent ? "smart" : "prev" : t ? "add" : "subtract"), Ze(this.doc, e) && Ma(this, e, t, r);
              }),
              indentSelection: ti(function (e) {
                for (var t = this.doc.sel.ranges, r = -1, n = 0; n < t.length; n++) {
                  var i = t[n];
                  if (i.empty()) i.head.line > r && (Ma(this, i.head.line, e, !0), r = i.head.line, n == this.doc.sel.primIndex && On(this));else {
                    var o = i.from(),
                      a = i.to(),
                      l = Math.max(r, o.line);
                    r = Math.min(this.lastLine(), a.line - (a.ch ? 0 : 1)) + 1;
                    for (var s = l; s < r; ++s) Ma(this, s, e);
                    var c = this.doc.sel.ranges;
                    0 == o.ch && t.length == c.length && c[n].from().ch > 0 && $i(this.doc, n, new Ci(o, c[n].to()), j);
                  }
                }
              }),
              getTokenAt: function (e, t) {
                return yt(this, e, t);
              },
              getLineTokens: function (e, t) {
                return yt(this, et(e), t, !0);
              },
              getTokenTypeAt: function (e) {
                e = lt(this.doc, e);
                var t,
                  r = ft(this, Ke(this.doc, e.line)),
                  n = 0,
                  i = (r.length - 1) / 2,
                  o = e.ch;
                if (0 == o) t = r[2];else for (;;) {
                  var a = n + i >> 1;
                  if ((a ? r[2 * a - 1] : 0) >= o) i = a;else {
                    if (!(r[2 * a + 1] < o)) {
                      t = r[2 * a + 2];
                      break;
                    }
                    n = a + 1;
                  }
                }
                var l = t ? t.indexOf("overlay ") : -1;
                return l < 0 ? t : 0 == l ? null : t.slice(0, l - 1);
              },
              getModeAt: function (t) {
                var r = this.doc.mode;
                return r.innerMode ? e.innerMode(r, this.getTokenAt(t).state).mode : r;
              },
              getHelper: function (e, t) {
                return this.getHelpers(e, t)[0];
              },
              getHelpers: function (e, t) {
                var n = [];
                if (!r.hasOwnProperty(t)) return n;
                var i = r[t],
                  o = this.getModeAt(e);
                if ("string" == typeof o[t]) i[o[t]] && n.push(i[o[t]]);else if (o[t]) for (var a = 0; a < o[t].length; a++) {
                  var l = i[o[t][a]];
                  l && n.push(l);
                } else o.helperType && i[o.helperType] ? n.push(i[o.helperType]) : i[o.name] && n.push(i[o.name]);
                for (var s = 0; s < i._global.length; s++) {
                  var c = i._global[s];
                  c.pred(o, this) && -1 == _(n, c.val) && n.push(c.val);
                }
                return n;
              },
              getStateAfter: function (e, t) {
                var r = this.doc;
                return ht(this, (e = at(r, null == e ? r.first + r.size - 1 : e)) + 1, t).state;
              },
              cursorCoords: function (e, t) {
                var r = this.doc.sel.primary();
                return Kr(this, null == e ? r.head : "object" == typeof e ? lt(this.doc, e) : e ? r.from() : r.to(), t || "page");
              },
              charCoords: function (e, t) {
                return Vr(this, lt(this.doc, e), t || "page");
              },
              coordsChar: function (e, t) {
                return qr(this, (e = Gr(this, e, t || "page")).left, e.top);
              },
              lineAtHeight: function (e, t) {
                return e = Gr(this, {
                  top: e,
                  left: 0
                }, t || "page").top, Je(this.doc, e + this.display.viewOffset);
              },
              heightAtLine: function (e, t, r) {
                var n,
                  i = !1;
                if ("number" == typeof e) {
                  var o = this.doc.first + this.doc.size - 1;
                  e < this.doc.first ? e = this.doc.first : e > o && (e = o, i = !0), n = Ke(this.doc, e);
                } else n = e;
                return Ur(this, n, {
                  top: 0,
                  left: 0
                }, t || "page", r || i).top + (i ? this.doc.height - Ut(n) : 0);
              },
              defaultTextHeight: function () {
                return rn(this.display);
              },
              defaultCharWidth: function () {
                return nn(this.display);
              },
              getViewport: function () {
                return {
                  from: this.display.viewFrom,
                  to: this.display.viewTo
                };
              },
              addWidget: function (e, t, r, n, i) {
                var o,
                  a,
                  l,
                  s = this.display,
                  c = (e = Kr(this, lt(this.doc, e))).bottom,
                  u = e.left;
                if (t.style.position = "absolute", t.setAttribute("cm-ignore-events", "true"), this.display.input.setUneditable(t), s.sizer.appendChild(t), "over" == n) c = e.top;else if ("above" == n || "near" == n) {
                  var d = Math.max(s.wrapper.clientHeight, this.doc.height),
                    f = Math.max(s.sizer.clientWidth, s.lineSpace.clientWidth);
                  ("above" == n || e.bottom + t.offsetHeight > d) && e.top > t.offsetHeight ? c = e.top - t.offsetHeight : e.bottom + t.offsetHeight <= d && (c = e.bottom), u + t.offsetWidth > f && (u = f - t.offsetWidth);
                }
                t.style.top = c + "px", t.style.left = t.style.right = "", "right" == i ? (u = s.sizer.clientWidth - t.offsetWidth, t.style.right = "0px") : ("left" == i ? u = 0 : "middle" == i && (u = (s.sizer.clientWidth - t.offsetWidth) / 2), t.style.left = u + "px"), r && (o = this, a = {
                  left: u,
                  top: c,
                  right: u + t.offsetWidth,
                  bottom: c + t.offsetHeight
                }, null != (l = Mn(o, a)).scrollTop && In(o, l.scrollTop), null != l.scrollLeft && Hn(o, l.scrollLeft));
              },
              triggerOnKeyDown: ti(ua),
              triggerOnKeyPress: ti(fa),
              triggerOnKeyUp: da,
              triggerOnMouseDown: ti(ga),
              execCommand: function (e) {
                if (ta.hasOwnProperty(e)) return ta[e].call(null, this);
              },
              triggerElectric: ti(function (e) {
                Wa(this, e);
              }),
              findPosH: function (e, t, r, n) {
                var i = 1;
                t < 0 && (i = -1, t = -t);
                for (var o = lt(this.doc, e), a = 0; a < t && !(o = Fa(this.doc, o, i, r, n)).hitSide; ++a);
                return o;
              },
              moveH: ti(function (e, t) {
                var r = this;
                this.extendSelectionsBy(function (n) {
                  return r.display.shift || r.doc.extend || n.empty() ? Fa(r.doc, n.head, e, t, r.options.rtlMoveVisually) : e < 0 ? n.from() : n.to();
                }, G);
              }),
              deleteH: ti(function (e, t) {
                var r = this.doc.sel,
                  n = this.doc;
                r.somethingSelected() ? n.replaceSelection("", null, "+delete") : Jo(this, function (r) {
                  var i = Fa(n, r.head, e, t, !1);
                  return e < 0 ? {
                    from: i,
                    to: r.head
                  } : {
                    from: r.head,
                    to: i
                  };
                });
              }),
              findPosV: function (e, t, r, n) {
                var i = 1,
                  o = n;
                t < 0 && (i = -1, t = -t);
                for (var a = lt(this.doc, e), l = 0; l < t; ++l) {
                  var s = Kr(this, a, "div");
                  if (null == o ? o = s.left : s.left = o, (a = za(this, s, i, r)).hitSide) break;
                }
                return a;
              },
              moveV: ti(function (e, t) {
                var r = this,
                  n = this.doc,
                  i = [],
                  o = !this.display.shift && !n.extend && n.sel.somethingSelected();
                if (n.extendSelectionsBy(function (a) {
                  if (o) return e < 0 ? a.from() : a.to();
                  var l = Kr(r, a.head, "div");
                  null != a.goalColumn && (l.left = a.goalColumn), i.push(l.left);
                  var s = za(r, l, e, t);
                  return "page" == t && a == n.sel.primary() && An(r, Vr(r, s, "div").top - l.top), s;
                }, G), i.length) for (var a = 0; a < n.sel.ranges.length; a++) n.sel.ranges[a].goalColumn = i[a];
              }),
              findWordAt: function (e) {
                var t = Ke(this.doc, e.line).text,
                  r = e.ch,
                  n = e.ch;
                if (t) {
                  var i = this.getHelper(e, "wordChars");
                  "before" != e.sticky && n != t.length || !r ? ++n : --r;
                  for (var o = t.charAt(r), a = ee(o, i) ? function (e) {
                      return ee(e, i);
                    } : /\s/.test(o) ? function (e) {
                      return /\s/.test(e);
                    } : function (e) {
                      return !/\s/.test(e) && !ee(e);
                    }; r > 0 && a(t.charAt(r - 1));) --r;
                  for (; n < t.length && a(t.charAt(n));) ++n;
                }
                return new Ci(et(e.line, r), et(e.line, n));
              },
              toggleOverwrite: function (e) {
                null != e && e == this.state.overwrite || ((this.state.overwrite = !this.state.overwrite) ? R(this.display.cursorDiv, "CodeMirror-overwrite") : L(this.display.cursorDiv, "CodeMirror-overwrite"), pe(this, "overwriteToggle", this, this.state.overwrite));
              },
              hasFocus: function () {
                return this.display.input.getField() == D();
              },
              isReadOnly: function () {
                return !(!this.options.readOnly && !this.doc.cantEdit);
              },
              scrollTo: ti(function (e, t) {
                Dn(this, e, t);
              }),
              getScrollInfo: function () {
                var e = this.display.scroller;
                return {
                  left: e.scrollLeft,
                  top: e.scrollTop,
                  height: e.scrollHeight - Tr(this) - this.display.barHeight,
                  width: e.scrollWidth - Tr(this) - this.display.barWidth,
                  clientHeight: Nr(this),
                  clientWidth: Lr(this)
                };
              },
              scrollIntoView: ti(function (e, t) {
                null == e ? (e = {
                  from: this.doc.sel.primary().head,
                  to: null
                }, null == t && (t = this.options.cursorScrollMargin)) : "number" == typeof e ? e = {
                  from: et(e, 0),
                  to: null
                } : null == e.from && (e = {
                  from: e,
                  to: null
                }), e.to || (e.to = e.from), e.margin = t || 0, null != e.from.line ? function (e, t) {
                  Rn(e), e.curOp.scrollToPos = t;
                }(this, e) : Wn(this, e.from, e.to, e.margin);
              }),
              setSize: ti(function (e, t) {
                var r = this,
                  n = function (e) {
                    return "number" == typeof e || /^\d+$/.test(String(e)) ? e + "px" : e;
                  };
                null != e && (this.display.wrapper.style.width = n(e)), null != t && (this.display.wrapper.style.height = n(t)), this.options.lineWrapping && Fr(this);
                var i = this.display.viewFrom;
                this.doc.iter(i, this.display.viewTo, function (e) {
                  if (e.widgets) for (var t = 0; t < e.widgets.length; t++) if (e.widgets[t].noHScroll) {
                    fn(r, i, "widget");
                    break;
                  }
                  ++i;
                }), this.curOp.forceUpdate = !0, pe(this, "refresh", this);
              }),
              operation: function (e) {
                return Qn(this, e);
              },
              startOperation: function () {
                return Kn(this);
              },
              endOperation: function () {
                return Yn(this);
              },
              refresh: ti(function () {
                var e = this.display.cachedTextHeight;
                dn(this), this.curOp.forceUpdate = !0, zr(this), Dn(this, this.doc.scrollLeft, this.doc.scrollTop), ci(this.display), (null == e || Math.abs(e - rn(this.display)) > .5 || this.options.lineWrapping) && sn(this), pe(this, "refresh", this);
              }),
              swapDoc: ti(function (e) {
                var t = this.doc;
                return t.cm = null, this.state.selectingText && this.state.selectingText(), Ii(this, e), zr(this), this.display.input.reset(), Dn(this, e.scrollLeft, e.scrollTop), this.curOp.forceScroll = !0, lr(this, "swapDoc", this, t), t;
              }),
              phrase: function (e) {
                var t = this.options.phrases;
                return t && Object.prototype.hasOwnProperty.call(t, e) ? t[e] : e;
              },
              getInputField: function () {
                return this.display.input.getField();
              },
              getWrapperElement: function () {
                return this.display.wrapper;
              },
              getScrollerElement: function () {
                return this.display.scroller;
              },
              getGutterElement: function () {
                return this.display.gutters;
              }
            }, ye(e), e.registerHelper = function (t, n, i) {
              r.hasOwnProperty(t) || (r[t] = e[t] = {
                _global: []
              }), r[t][n] = i;
            }, e.registerGlobalHelper = function (t, n, i, o) {
              e.registerHelper(t, n, o), r[t]._global.push({
                pred: i,
                val: o
              });
            };
          }(Na);
          var Ka = "iter insert remove copy getEditor constructor".split(" ");
          for (var Ya in Oo.prototype) Oo.prototype.hasOwnProperty(Ya) && _(Ka, Ya) < 0 && (Na.prototype[Ya] = function (e) {
            return function () {
              return e.apply(this.doc, arguments);
            };
          }(Oo.prototype[Ya]));
          return ye(Oo), Na.inputStyles = {
            textarea: Va,
            contenteditable: _a
          }, Na.defineMode = function (e) {
            Na.defaults.mode || "null" == e || (Na.defaults.mode = e), He.apply(this, arguments);
          }, Na.defineMIME = function (e, t) {
            Pe[e] = t;
          }, Na.defineMode("null", function () {
            return {
              token: function (e) {
                return e.skipToEnd();
              }
            };
          }), Na.defineMIME("text/plain", "null"), Na.defineExtension = function (e, t) {
            Na.prototype[e] = t;
          }, Na.defineDocExtension = function (e, t) {
            Oo.prototype[e] = t;
          }, Na.fromTextArea = function (e, t) {
            if ((t = t ? H(t) : {}).value = e.value, !t.tabindex && e.tabIndex && (t.tabindex = e.tabIndex), !t.placeholder && e.placeholder && (t.placeholder = e.placeholder), null == t.autofocus) {
              var r = D();
              t.autofocus = r == e || null != e.getAttribute("autofocus") && r == document.body;
            }
            function n() {
              e.value = l.getValue();
            }
            var i;
            if (e.form && (de(e.form, "submit", n), !t.leaveSubmitMethodAlone)) {
              var o = e.form;
              i = o.submit;
              try {
                var a = o.submit = function () {
                  n(), o.submit = i, o.submit(), o.submit = a;
                };
              } catch (e) {}
            }
            t.finishInit = function (r) {
              r.save = n, r.getTextArea = function () {
                return e;
              }, r.toTextArea = function () {
                r.toTextArea = isNaN, n(), e.parentNode.removeChild(r.getWrapperElement()), e.style.display = "", e.form && (he(e.form, "submit", n), t.leaveSubmitMethodAlone || "function" != typeof e.form.submit || (e.form.submit = i));
              };
            }, e.style.display = "none";
            var l = Na(function (t) {
              return e.parentNode.insertBefore(t, e.nextSibling);
            }, t);
            return l;
          }, function (e) {
            e.off = he, e.on = de, e.wheelEventPixels = xi, e.Doc = Oo, e.splitLines = Oe, e.countColumn = F, e.findColumn = V, e.isWordChar = Q, e.Pass = B, e.signal = pe, e.Line = Kt, e.changeEnd = Li, e.scrollbarModel = Un, e.Pos = et, e.cmpPos = tt, e.modes = Ie, e.mimeModes = Pe, e.resolveMode = Fe, e.getMode = ze, e.modeExtensions = _e, e.extendMode = Be, e.copyState = je, e.startState = Ge, e.innerMode = Ue, e.commands = ta, e.keyMap = Uo, e.keyName = qo, e.isModifierKey = Yo, e.lookupKey = Ko, e.normalizeKeyMap = Vo, e.StringStream = Ve, e.SharedTextMarker = No, e.TextMarker = To, e.LineWidget = ko, e.e_preventDefault = be, e.e_stopPropagation = xe, e.e_stop = ke, e.addClass = R, e.contains = O, e.rmClass = L, e.keyNames = zo;
          }(Na), Na.version = "5.65.0", Na;
        }();
      },
      876: (e, t, r) => {
        !function (e) {
          "use strict";

          e.defineMode("javascript", function (t, r) {
            var n,
              i,
              o = t.indentUnit,
              a = r.statementIndent,
              l = r.jsonld,
              s = r.json || l,
              c = !1 !== r.trackScope,
              u = r.typescript,
              d = r.wordCharacters || /[\w$\xa1-\uffff]/,
              f = function () {
                function e(e) {
                  return {
                    type: e,
                    style: "keyword"
                  };
                }
                var t = e("keyword a"),
                  r = e("keyword b"),
                  n = e("keyword c"),
                  i = e("keyword d"),
                  o = e("operator"),
                  a = {
                    type: "atom",
                    style: "atom"
                  };
                return {
                  if: e("if"),
                  while: t,
                  with: t,
                  else: r,
                  do: r,
                  try: r,
                  finally: r,
                  return: i,
                  break: i,
                  continue: i,
                  new: e("new"),
                  delete: n,
                  void: n,
                  throw: n,
                  debugger: e("debugger"),
                  var: e("var"),
                  const: e("var"),
                  let: e("var"),
                  function: e("function"),
                  catch: e("catch"),
                  for: e("for"),
                  switch: e("switch"),
                  case: e("case"),
                  default: e("default"),
                  in: o,
                  typeof: o,
                  instanceof: o,
                  true: a,
                  false: a,
                  null: a,
                  undefined: a,
                  NaN: a,
                  Infinity: a,
                  this: e("this"),
                  class: e("class"),
                  super: e("atom"),
                  yield: n,
                  export: e("export"),
                  import: e("import"),
                  extends: n,
                  await: n
                };
              }(),
              h = /[+\-*&%=<>!?|~^@]/,
              p = /^@(context|id|value|language|type|container|list|set|reverse|index|base|vocab|graph)"/;
            function m(e, t, r) {
              return n = e, i = r, t;
            }
            function g(e, t) {
              var r,
                n = e.next();
              if ('"' == n || "'" == n) return t.tokenize = (r = n, function (e, t) {
                var n,
                  i = !1;
                if (l && "@" == e.peek() && e.match(p)) return t.tokenize = g, m("jsonld-keyword", "meta");
                for (; null != (n = e.next()) && (n != r || i);) i = !i && "\\" == n;
                return i || (t.tokenize = g), m("string", "string");
              }), t.tokenize(e, t);
              if ("." == n && e.match(/^\d[\d_]*(?:[eE][+\-]?[\d_]+)?/)) return m("number", "number");
              if ("." == n && e.match("..")) return m("spread", "meta");
              if (/[\[\]{}\(\),;\:\.]/.test(n)) return m(n);
              if ("=" == n && e.eat(">")) return m("=>", "operator");
              if ("0" == n && e.match(/^(?:x[\dA-Fa-f_]+|o[0-7_]+|b[01_]+)n?/)) return m("number", "number");
              if (/\d/.test(n)) return e.match(/^[\d_]*(?:n|(?:\.[\d_]*)?(?:[eE][+\-]?[\d_]+)?)?/), m("number", "number");
              if ("/" == n) return e.eat("*") ? (t.tokenize = v, v(e, t)) : e.eat("/") ? (e.skipToEnd(), m("comment", "comment")) : Qe(e, t, 1) ? (function (e) {
                for (var t, r = !1, n = !1; null != (t = e.next());) {
                  if (!r) {
                    if ("/" == t && !n) return;
                    "[" == t ? n = !0 : n && "]" == t && (n = !1);
                  }
                  r = !r && "\\" == t;
                }
              }(e), e.match(/^\b(([gimyus])(?![gimyus]*\2))+\b/), m("regexp", "string-2")) : (e.eat("="), m("operator", "operator", e.current()));
              if ("`" == n) return t.tokenize = y, y(e, t);
              if ("#" == n && "!" == e.peek()) return e.skipToEnd(), m("meta", "meta");
              if ("#" == n && e.eatWhile(d)) return m("variable", "property");
              if ("<" == n && e.match("!--") || "-" == n && e.match("->") && !/\S/.test(e.string.slice(0, e.start))) return e.skipToEnd(), m("comment", "comment");
              if (h.test(n)) return ">" == n && t.lexical && ">" == t.lexical.type || (e.eat("=") ? "!" != n && "=" != n || e.eat("=") : /[<>*+\-|&?]/.test(n) && (e.eat(n), ">" == n && e.eat(n))), "?" == n && e.eat(".") ? m(".") : m("operator", "operator", e.current());
              if (d.test(n)) {
                e.eatWhile(d);
                var i = e.current();
                if ("." != t.lastType) {
                  if (f.propertyIsEnumerable(i)) {
                    var o = f[i];
                    return m(o.type, o.style, i);
                  }
                  if ("async" == i && e.match(/^(\s|\/\*([^*]|\*(?!\/))*?\*\/)*[\[\(\w]/, !1)) return m("async", "keyword", i);
                }
                return m("variable", "variable", i);
              }
            }
            function v(e, t) {
              for (var r, n = !1; r = e.next();) {
                if ("/" == r && n) {
                  t.tokenize = g;
                  break;
                }
                n = "*" == r;
              }
              return m("comment", "comment");
            }
            function y(e, t) {
              for (var r, n = !1; null != (r = e.next());) {
                if (!n && ("`" == r || "$" == r && e.eat("{"))) {
                  t.tokenize = g;
                  break;
                }
                n = !n && "\\" == r;
              }
              return m("quasi", "string-2", e.current());
            }
            function b(e, t) {
              t.fatArrowAt && (t.fatArrowAt = null);
              var r = e.string.indexOf("=>", e.start);
              if (!(r < 0)) {
                if (u) {
                  var n = /:\s*(?:\w+(?:<[^>]*>|\[\])?|\{[^}]*\})\s*$/.exec(e.string.slice(e.start, r));
                  n && (r = n.index);
                }
                for (var i = 0, o = !1, a = r - 1; a >= 0; --a) {
                  var l = e.string.charAt(a),
                    s = "([{}])".indexOf(l);
                  if (s >= 0 && s < 3) {
                    if (!i) {
                      ++a;
                      break;
                    }
                    if (0 == --i) {
                      "(" == l && (o = !0);
                      break;
                    }
                  } else if (s >= 3 && s < 6) ++i;else if (d.test(l)) o = !0;else if (/["'\/`]/.test(l)) for (;; --a) {
                    if (0 == a) return;
                    if (e.string.charAt(a - 1) == l && "\\" != e.string.charAt(a - 2)) {
                      a--;
                      break;
                    }
                  } else if (o && !i) {
                    ++a;
                    break;
                  }
                }
                o && !i && (t.fatArrowAt = a);
              }
            }
            var x = {
              atom: !0,
              number: !0,
              variable: !0,
              string: !0,
              regexp: !0,
              this: !0,
              import: !0,
              "jsonld-keyword": !0
            };
            function w(e, t, r, n, i, o) {
              this.indented = e, this.column = t, this.type = r, this.prev = i, this.info = o, null != n && (this.align = n);
            }
            function k(e, t) {
              if (!c) return !1;
              for (var r = e.localVars; r; r = r.next) if (r.name == t) return !0;
              for (var n = e.context; n; n = n.prev) for (r = n.vars; r; r = r.next) if (r.name == t) return !0;
            }
            function C(e, t, r, n, i) {
              var o = e.cc;
              for (S.state = e, S.stream = i, S.marked = null, S.cc = o, S.style = t, e.lexical.hasOwnProperty("align") || (e.lexical.align = !0);;) if ((o.length ? o.pop() : s ? j : _)(r, n)) {
                for (; o.length && o[o.length - 1].lex;) o.pop()();
                return S.marked ? S.marked : "variable" == r && k(e, n) ? "variable-2" : t;
              }
            }
            var S = {
              state: null,
              column: null,
              marked: null,
              cc: null
            };
            function T() {
              for (var e = arguments.length - 1; e >= 0; e--) S.cc.push(arguments[e]);
            }
            function L() {
              return T.apply(null, arguments), !0;
            }
            function N(e, t) {
              for (var r = t; r; r = r.next) if (r.name == e) return !0;
              return !1;
            }
            function E(e) {
              var t = S.state;
              if (S.marked = "def", c) {
                if (t.context) if ("var" == t.lexical.info && t.context && t.context.block) {
                  var n = M(e, t.context);
                  if (null != n) return void (t.context = n);
                } else if (!N(e, t.localVars)) return void (t.localVars = new D(e, t.localVars));
                r.globalVars && !N(e, t.globalVars) && (t.globalVars = new D(e, t.globalVars));
              }
            }
            function M(e, t) {
              if (t) {
                if (t.block) {
                  var r = M(e, t.prev);
                  return r ? r == t.prev ? t : new O(r, t.vars, !0) : null;
                }
                return N(e, t.vars) ? t : new O(t.prev, new D(e, t.vars), !1);
              }
              return null;
            }
            function A(e) {
              return "public" == e || "private" == e || "protected" == e || "abstract" == e || "readonly" == e;
            }
            function O(e, t, r) {
              this.prev = e, this.vars = t, this.block = r;
            }
            function D(e, t) {
              this.name = e, this.next = t;
            }
            var R = new D("this", new D("arguments", null));
            function W() {
              S.state.context = new O(S.state.context, S.state.localVars, !1), S.state.localVars = R;
            }
            function I() {
              S.state.context = new O(S.state.context, S.state.localVars, !0), S.state.localVars = null;
            }
            function P() {
              S.state.localVars = S.state.context.vars, S.state.context = S.state.context.prev;
            }
            function H(e, t) {
              var r = function () {
                var r = S.state,
                  n = r.indented;
                if ("stat" == r.lexical.type) n = r.lexical.indented;else for (var i = r.lexical; i && ")" == i.type && i.align; i = i.prev) n = i.indented;
                r.lexical = new w(n, S.stream.column(), e, null, r.lexical, t);
              };
              return r.lex = !0, r;
            }
            function F() {
              var e = S.state;
              e.lexical.prev && (")" == e.lexical.type && (e.indented = e.lexical.indented), e.lexical = e.lexical.prev);
            }
            function z(e) {
              return function t(r) {
                return r == e ? L() : ";" == e || "}" == r || ")" == r || "]" == r ? T() : L(t);
              };
            }
            function _(e, t) {
              return "var" == e ? L(H("vardef", t), Se, z(";"), F) : "keyword a" == e ? L(H("form"), G, _, F) : "keyword b" == e ? L(H("form"), _, F) : "keyword d" == e ? S.stream.match(/^\s*$/, !1) ? L() : L(H("stat"), K, z(";"), F) : "debugger" == e ? L(z(";")) : "{" == e ? L(H("}"), I, se, F, P) : ";" == e ? L() : "if" == e ? ("else" == S.state.lexical.info && S.state.cc[S.state.cc.length - 1] == F && S.state.cc.pop()(), L(H("form"), G, _, F, Ae)) : "function" == e ? L(We) : "for" == e ? L(H("form"), I, Oe, _, P, F) : "class" == e || u && "interface" == t ? (S.marked = "keyword", L(H("form", "class" == e ? e : t), ze, F)) : "variable" == e ? u && "declare" == t ? (S.marked = "keyword", L(_)) : u && ("module" == t || "enum" == t || "type" == t) && S.stream.match(/^\s*\w/, !1) ? (S.marked = "keyword", "enum" == t ? L(Je) : "type" == t ? L(Pe, z("operator"), he, z(";")) : L(H("form"), Te, z("{"), H("}"), se, F, F)) : u && "namespace" == t ? (S.marked = "keyword", L(H("form"), j, _, F)) : u && "abstract" == t ? (S.marked = "keyword", L(_)) : L(H("stat"), te) : "switch" == e ? L(H("form"), G, z("{"), H("}", "switch"), I, se, F, F, P) : "case" == e ? L(j, z(":")) : "default" == e ? L(z(":")) : "catch" == e ? L(H("form"), W, B, _, F, P) : "export" == e ? L(H("stat"), Ue, F) : "import" == e ? L(H("stat"), Ve, F) : "async" == e ? L(_) : "@" == t ? L(j, _) : T(H("stat"), j, z(";"), F);
            }
            function B(e) {
              if ("(" == e) return L(He, z(")"));
            }
            function j(e, t) {
              return V(e, t, !1);
            }
            function U(e, t) {
              return V(e, t, !0);
            }
            function G(e) {
              return "(" != e ? T() : L(H(")"), K, z(")"), F);
            }
            function V(e, t, r) {
              if (S.state.fatArrowAt == S.stream.start) {
                var n = r ? Z : J;
                if ("(" == e) return L(W, H(")"), ae(He, ")"), F, z("=>"), n, P);
                if ("variable" == e) return T(W, Te, z("=>"), n, P);
              }
              var i = r ? X : Y;
              return x.hasOwnProperty(e) ? L(i) : "function" == e ? L(We, i) : "class" == e || u && "interface" == t ? (S.marked = "keyword", L(H("form"), Fe, F)) : "keyword c" == e || "async" == e ? L(r ? U : j) : "(" == e ? L(H(")"), K, z(")"), F, i) : "operator" == e || "spread" == e ? L(r ? U : j) : "[" == e ? L(H("]"), $e, F, i) : "{" == e ? le(ne, "}", null, i) : "quasi" == e ? T(q, i) : "new" == e ? L(function (e) {
                return function (t) {
                  return "." == t ? L(e ? ee : Q) : "variable" == t && u ? L(we, e ? X : Y) : T(e ? U : j);
                };
              }(r)) : L();
            }
            function K(e) {
              return e.match(/[;\}\)\],]/) ? T() : T(j);
            }
            function Y(e, t) {
              return "," == e ? L(K) : X(e, t, !1);
            }
            function X(e, t, r) {
              var n = 0 == r ? Y : X,
                i = 0 == r ? j : U;
              return "=>" == e ? L(W, r ? Z : J, P) : "operator" == e ? /\+\+|--/.test(t) || u && "!" == t ? L(n) : u && "<" == t && S.stream.match(/^([^<>]|<[^<>]*>)*>\s*\(/, !1) ? L(H(">"), ae(he, ">"), F, n) : "?" == t ? L(j, z(":"), i) : L(i) : "quasi" == e ? T(q, n) : ";" != e ? "(" == e ? le(U, ")", "call", n) : "." == e ? L(re, n) : "[" == e ? L(H("]"), K, z("]"), F, n) : u && "as" == t ? (S.marked = "keyword", L(he, n)) : "regexp" == e ? (S.state.lastType = S.marked = "operator", S.stream.backUp(S.stream.pos - S.stream.start - 1), L(i)) : void 0 : void 0;
            }
            function q(e, t) {
              return "quasi" != e ? T() : "${" != t.slice(t.length - 2) ? L(q) : L(K, $);
            }
            function $(e) {
              if ("}" == e) return S.marked = "string-2", S.state.tokenize = y, L(q);
            }
            function J(e) {
              return b(S.stream, S.state), T("{" == e ? _ : j);
            }
            function Z(e) {
              return b(S.stream, S.state), T("{" == e ? _ : U);
            }
            function Q(e, t) {
              if ("target" == t) return S.marked = "keyword", L(Y);
            }
            function ee(e, t) {
              if ("target" == t) return S.marked = "keyword", L(X);
            }
            function te(e) {
              return ":" == e ? L(F, _) : T(Y, z(";"), F);
            }
            function re(e) {
              if ("variable" == e) return S.marked = "property", L();
            }
            function ne(e, t) {
              return "async" == e ? (S.marked = "property", L(ne)) : "variable" == e || "keyword" == S.style ? (S.marked = "property", "get" == t || "set" == t ? L(ie) : (u && S.state.fatArrowAt == S.stream.start && (r = S.stream.match(/^\s*:\s*/, !1)) && (S.state.fatArrowAt = S.stream.pos + r[0].length), L(oe))) : "number" == e || "string" == e ? (S.marked = l ? "property" : S.style + " property", L(oe)) : "jsonld-keyword" == e ? L(oe) : u && A(t) ? (S.marked = "keyword", L(ne)) : "[" == e ? L(j, ce, z("]"), oe) : "spread" == e ? L(U, oe) : "*" == t ? (S.marked = "keyword", L(ne)) : ":" == e ? T(oe) : void 0;
              var r;
            }
            function ie(e) {
              return "variable" != e ? T(oe) : (S.marked = "property", L(We));
            }
            function oe(e) {
              return ":" == e ? L(U) : "(" == e ? T(We) : void 0;
            }
            function ae(e, t, r) {
              function n(i, o) {
                if (r ? r.indexOf(i) > -1 : "," == i) {
                  var a = S.state.lexical;
                  return "call" == a.info && (a.pos = (a.pos || 0) + 1), L(function (r, n) {
                    return r == t || n == t ? T() : T(e);
                  }, n);
                }
                return i == t || o == t ? L() : r && r.indexOf(";") > -1 ? T(e) : L(z(t));
              }
              return function (r, i) {
                return r == t || i == t ? L() : T(e, n);
              };
            }
            function le(e, t, r) {
              for (var n = 3; n < arguments.length; n++) S.cc.push(arguments[n]);
              return L(H(t, r), ae(e, t), F);
            }
            function se(e) {
              return "}" == e ? L() : T(_, se);
            }
            function ce(e, t) {
              if (u) {
                if (":" == e) return L(he);
                if ("?" == t) return L(ce);
              }
            }
            function ue(e, t) {
              if (u && (":" == e || "in" == t)) return L(he);
            }
            function de(e) {
              if (u && ":" == e) return S.stream.match(/^\s*\w+\s+is\b/, !1) ? L(j, fe, he) : L(he);
            }
            function fe(e, t) {
              if ("is" == t) return S.marked = "keyword", L();
            }
            function he(e, t) {
              return "keyof" == t || "typeof" == t || "infer" == t || "readonly" == t ? (S.marked = "keyword", L("typeof" == t ? U : he)) : "variable" == e || "void" == t ? (S.marked = "type", L(xe)) : "|" == t || "&" == t ? L(he) : "string" == e || "number" == e || "atom" == e ? L(xe) : "[" == e ? L(H("]"), ae(he, "]", ","), F, xe) : "{" == e ? L(H("}"), me, F, xe) : "(" == e ? L(ae(be, ")"), pe, xe) : "<" == e ? L(ae(he, ">"), he) : "quasi" == e ? T(ve, xe) : void 0;
            }
            function pe(e) {
              if ("=>" == e) return L(he);
            }
            function me(e) {
              return e.match(/[\}\)\]]/) ? L() : "," == e || ";" == e ? L(me) : T(ge, me);
            }
            function ge(e, t) {
              return "variable" == e || "keyword" == S.style ? (S.marked = "property", L(ge)) : "?" == t || "number" == e || "string" == e ? L(ge) : ":" == e ? L(he) : "[" == e ? L(z("variable"), ue, z("]"), ge) : "(" == e ? T(Ie, ge) : e.match(/[;\}\)\],]/) ? void 0 : L();
            }
            function ve(e, t) {
              return "quasi" != e ? T() : "${" != t.slice(t.length - 2) ? L(ve) : L(he, ye);
            }
            function ye(e) {
              if ("}" == e) return S.marked = "string-2", S.state.tokenize = y, L(ve);
            }
            function be(e, t) {
              return "variable" == e && S.stream.match(/^\s*[?:]/, !1) || "?" == t ? L(be) : ":" == e ? L(he) : "spread" == e ? L(be) : T(he);
            }
            function xe(e, t) {
              return "<" == t ? L(H(">"), ae(he, ">"), F, xe) : "|" == t || "." == e || "&" == t ? L(he) : "[" == e ? L(he, z("]"), xe) : "extends" == t || "implements" == t ? (S.marked = "keyword", L(he)) : "?" == t ? L(he, z(":"), he) : void 0;
            }
            function we(e, t) {
              if ("<" == t) return L(H(">"), ae(he, ">"), F, xe);
            }
            function ke() {
              return T(he, Ce);
            }
            function Ce(e, t) {
              if ("=" == t) return L(he);
            }
            function Se(e, t) {
              return "enum" == t ? (S.marked = "keyword", L(Je)) : T(Te, ce, Ee, Me);
            }
            function Te(e, t) {
              return u && A(t) ? (S.marked = "keyword", L(Te)) : "variable" == e ? (E(t), L()) : "spread" == e ? L(Te) : "[" == e ? le(Ne, "]") : "{" == e ? le(Le, "}") : void 0;
            }
            function Le(e, t) {
              return "variable" != e || S.stream.match(/^\s*:/, !1) ? ("variable" == e && (S.marked = "property"), "spread" == e ? L(Te) : "}" == e ? T() : "[" == e ? L(j, z("]"), z(":"), Le) : L(z(":"), Te, Ee)) : (E(t), L(Ee));
            }
            function Ne() {
              return T(Te, Ee);
            }
            function Ee(e, t) {
              if ("=" == t) return L(U);
            }
            function Me(e) {
              if ("," == e) return L(Se);
            }
            function Ae(e, t) {
              if ("keyword b" == e && "else" == t) return L(H("form", "else"), _, F);
            }
            function Oe(e, t) {
              return "await" == t ? L(Oe) : "(" == e ? L(H(")"), De, F) : void 0;
            }
            function De(e) {
              return "var" == e ? L(Se, Re) : "variable" == e ? L(Re) : T(Re);
            }
            function Re(e, t) {
              return ")" == e ? L() : ";" == e ? L(Re) : "in" == t || "of" == t ? (S.marked = "keyword", L(j, Re)) : T(j, Re);
            }
            function We(e, t) {
              return "*" == t ? (S.marked = "keyword", L(We)) : "variable" == e ? (E(t), L(We)) : "(" == e ? L(W, H(")"), ae(He, ")"), F, de, _, P) : u && "<" == t ? L(H(">"), ae(ke, ">"), F, We) : void 0;
            }
            function Ie(e, t) {
              return "*" == t ? (S.marked = "keyword", L(Ie)) : "variable" == e ? (E(t), L(Ie)) : "(" == e ? L(W, H(")"), ae(He, ")"), F, de, P) : u && "<" == t ? L(H(">"), ae(ke, ">"), F, Ie) : void 0;
            }
            function Pe(e, t) {
              return "keyword" == e || "variable" == e ? (S.marked = "type", L(Pe)) : "<" == t ? L(H(">"), ae(ke, ">"), F) : void 0;
            }
            function He(e, t) {
              return "@" == t && L(j, He), "spread" == e ? L(He) : u && A(t) ? (S.marked = "keyword", L(He)) : u && "this" == e ? L(ce, Ee) : T(Te, ce, Ee);
            }
            function Fe(e, t) {
              return "variable" == e ? ze(e, t) : _e(e, t);
            }
            function ze(e, t) {
              if ("variable" == e) return E(t), L(_e);
            }
            function _e(e, t) {
              return "<" == t ? L(H(">"), ae(ke, ">"), F, _e) : "extends" == t || "implements" == t || u && "," == e ? ("implements" == t && (S.marked = "keyword"), L(u ? he : j, _e)) : "{" == e ? L(H("}"), Be, F) : void 0;
            }
            function Be(e, t) {
              return "async" == e || "variable" == e && ("static" == t || "get" == t || "set" == t || u && A(t)) && S.stream.match(/^\s+[\w$\xa1-\uffff]/, !1) ? (S.marked = "keyword", L(Be)) : "variable" == e || "keyword" == S.style ? (S.marked = "property", L(je, Be)) : "number" == e || "string" == e ? L(je, Be) : "[" == e ? L(j, ce, z("]"), je, Be) : "*" == t ? (S.marked = "keyword", L(Be)) : u && "(" == e ? T(Ie, Be) : ";" == e || "," == e ? L(Be) : "}" == e ? L() : "@" == t ? L(j, Be) : void 0;
            }
            function je(e, t) {
              if ("!" == t) return L(je);
              if ("?" == t) return L(je);
              if (":" == e) return L(he, Ee);
              if ("=" == t) return L(U);
              var r = S.state.lexical.prev;
              return T(r && "interface" == r.info ? Ie : We);
            }
            function Ue(e, t) {
              return "*" == t ? (S.marked = "keyword", L(qe, z(";"))) : "default" == t ? (S.marked = "keyword", L(j, z(";"))) : "{" == e ? L(ae(Ge, "}"), qe, z(";")) : T(_);
            }
            function Ge(e, t) {
              return "as" == t ? (S.marked = "keyword", L(z("variable"))) : "variable" == e ? T(U, Ge) : void 0;
            }
            function Ve(e) {
              return "string" == e ? L() : "(" == e ? T(j) : "." == e ? T(Y) : T(Ke, Ye, qe);
            }
            function Ke(e, t) {
              return "{" == e ? le(Ke, "}") : ("variable" == e && E(t), "*" == t && (S.marked = "keyword"), L(Xe));
            }
            function Ye(e) {
              if ("," == e) return L(Ke, Ye);
            }
            function Xe(e, t) {
              if ("as" == t) return S.marked = "keyword", L(Ke);
            }
            function qe(e, t) {
              if ("from" == t) return S.marked = "keyword", L(j);
            }
            function $e(e) {
              return "]" == e ? L() : T(ae(U, "]"));
            }
            function Je() {
              return T(H("form"), Te, z("{"), H("}"), ae(Ze, "}"), F, F);
            }
            function Ze() {
              return T(Te, Ee);
            }
            function Qe(e, t, r) {
              return t.tokenize == g && /^(?:operator|sof|keyword [bcd]|case|new|export|default|spread|[\[{}\(,;:]|=>)$/.test(t.lastType) || "quasi" == t.lastType && /\{\s*$/.test(e.string.slice(0, e.pos - (r || 0)));
            }
            return P.lex = !0, F.lex = !0, {
              startState: function (e) {
                var t = {
                  tokenize: g,
                  lastType: "sof",
                  cc: [],
                  lexical: new w((e || 0) - o, 0, "block", !1),
                  localVars: r.localVars,
                  context: r.localVars && new O(null, null, !1),
                  indented: e || 0
                };
                return r.globalVars && "object" == typeof r.globalVars && (t.globalVars = r.globalVars), t;
              },
              token: function (e, t) {
                if (e.sol() && (t.lexical.hasOwnProperty("align") || (t.lexical.align = !1), t.indented = e.indentation(), b(e, t)), t.tokenize != v && e.eatSpace()) return null;
                var r = t.tokenize(e, t);
                return "comment" == n ? r : (t.lastType = "operator" != n || "++" != i && "--" != i ? n : "incdec", C(t, r, n, i, e));
              },
              indent: function (t, n) {
                if (t.tokenize == v || t.tokenize == y) return e.Pass;
                if (t.tokenize != g) return 0;
                var i,
                  l = n && n.charAt(0),
                  s = t.lexical;
                if (!/^\s*else\b/.test(n)) for (var c = t.cc.length - 1; c >= 0; --c) {
                  var u = t.cc[c];
                  if (u == F) s = s.prev;else if (u != Ae && u != P) break;
                }
                for (; ("stat" == s.type || "form" == s.type) && ("}" == l || (i = t.cc[t.cc.length - 1]) && (i == Y || i == X) && !/^[,\.=+\-*:?[\(]/.test(n));) s = s.prev;
                a && ")" == s.type && "stat" == s.prev.type && (s = s.prev);
                var d = s.type,
                  f = l == d;
                return "vardef" == d ? s.indented + ("operator" == t.lastType || "," == t.lastType ? s.info.length + 1 : 0) : "form" == d && "{" == l ? s.indented : "form" == d ? s.indented + o : "stat" == d ? s.indented + (function (e, t) {
                  return "operator" == e.lastType || "," == e.lastType || h.test(t.charAt(0)) || /[,.]/.test(t.charAt(0));
                }(t, n) ? a || o : 0) : "switch" != s.info || f || 0 == r.doubleIndentSwitch ? s.align ? s.column + (f ? 0 : 1) : s.indented + (f ? 0 : o) : s.indented + (/^(?:case|default)\b/.test(n) ? o : 2 * o);
              },
              electricInput: /^\s*(?:case .*?:|default:|\{|\})$/,
              blockCommentStart: s ? null : "/*",
              blockCommentEnd: s ? null : "*/",
              blockCommentContinue: s ? null : " * ",
              lineComment: s ? null : "//",
              fold: "brace",
              closeBrackets: "()[]{}''\"\"``",
              helperType: s ? "json" : "javascript",
              jsonldMode: l,
              jsonMode: s,
              expressionAllowed: Qe,
              skipExpression: function (t) {
                C(t, "atom", "atom", "true", new e.StringStream("", 2, null));
              }
            };
          }), e.registerHelper("wordChars", "javascript", /[\w$]/), e.defineMIME("text/javascript", "javascript"), e.defineMIME("text/ecmascript", "javascript"), e.defineMIME("application/javascript", "javascript"), e.defineMIME("application/x-javascript", "javascript"), e.defineMIME("application/ecmascript", "javascript"), e.defineMIME("application/json", {
            name: "javascript",
            json: !0
          }), e.defineMIME("application/x-json", {
            name: "javascript",
            json: !0
          }), e.defineMIME("application/manifest+json", {
            name: "javascript",
            json: !0
          }), e.defineMIME("application/ld+json", {
            name: "javascript",
            jsonld: !0
          }), e.defineMIME("text/typescript", {
            name: "javascript",
            typescript: !0
          }), e.defineMIME("application/typescript", {
            name: "javascript",
            typescript: !0
          });
        }(r(631));
      },
      856: function (e) {
        e.exports = function () {
          "use strict";

          const {
            entries: e,
            setPrototypeOf: t,
            isFrozen: r,
            getPrototypeOf: n,
            getOwnPropertyDescriptor: i
          } = Object;
          let {
              freeze: o,
              seal: a,
              create: l
            } = Object,
            {
              apply: s,
              construct: c
            } = "undefined" != typeof Reflect && Reflect;
          s || (s = function (e, t, r) {
            return e.apply(t, r);
          }), o || (o = function (e) {
            return e;
          }), a || (a = function (e) {
            return e;
          }), c || (c = function (e, t) {
            return new e(...t);
          });
          const u = k(Array.prototype.forEach),
            d = k(Array.prototype.pop),
            f = k(Array.prototype.push),
            h = k(String.prototype.toLowerCase),
            p = k(String.prototype.toString),
            m = k(String.prototype.match),
            g = k(String.prototype.replace),
            v = k(String.prototype.indexOf),
            y = k(String.prototype.trim),
            b = k(RegExp.prototype.test),
            x = (w = TypeError, function () {
              for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++) t[r] = arguments[r];
              return c(w, t);
            });
          var w;
          function k(e) {
            return function (t) {
              for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++) n[i - 1] = arguments[i];
              return s(e, t, n);
            };
          }
          function C(e, n, i) {
            var o;
            i = null !== (o = i) && void 0 !== o ? o : h, t && t(e, null);
            let a = n.length;
            for (; a--;) {
              let t = n[a];
              if ("string" == typeof t) {
                const e = i(t);
                e !== t && (r(n) || (n[a] = e), t = e);
              }
              e[t] = !0;
            }
            return e;
          }
          function S(t) {
            const r = l(null);
            for (const [n, i] of e(t)) r[n] = i;
            return r;
          }
          function T(e, t) {
            for (; null !== e;) {
              const r = i(e, t);
              if (r) {
                if (r.get) return k(r.get);
                if ("function" == typeof r.value) return k(r.value);
              }
              e = n(e);
            }
            return function (e) {
              return console.warn("fallback value for", e), null;
            };
          }
          const L = o(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]),
            N = o(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]),
            E = o(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]),
            M = o(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]),
            A = o(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]),
            O = o(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]),
            D = o(["#text"]),
            R = o(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "xmlns", "slot"]),
            W = o(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]),
            I = o(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]),
            P = o(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]),
            H = a(/\{\{[\w\W]*|[\w\W]*\}\}/gm),
            F = a(/<%[\w\W]*|[\w\W]*%>/gm),
            z = a(/\${[\w\W]*}/gm),
            _ = a(/^data-[\-\w.\u00B7-\uFFFF]/),
            B = a(/^aria-[\-\w]+$/),
            j = a(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i),
            U = a(/^(?:\w+script|data):/i),
            G = a(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g),
            V = a(/^html$/i);
          var K = Object.freeze({
            __proto__: null,
            MUSTACHE_EXPR: H,
            ERB_EXPR: F,
            TMPLIT_EXPR: z,
            DATA_ATTR: _,
            ARIA_ATTR: B,
            IS_ALLOWED_URI: j,
            IS_SCRIPT_OR_DATA: U,
            ATTR_WHITESPACE: G,
            DOCTYPE_NAME: V
          });
          const Y = () => "undefined" == typeof window ? null : window,
            X = function (e, t) {
              if ("object" != typeof e || "function" != typeof e.createPolicy) return null;
              let r = null;
              const n = "data-tt-policy-suffix";
              t && t.hasAttribute(n) && (r = t.getAttribute(n));
              const i = "dompurify" + (r ? "#" + r : "");
              try {
                return e.createPolicy(i, {
                  createHTML: e => e,
                  createScriptURL: e => e
                });
              } catch (e) {
                return console.warn("TrustedTypes policy " + i + " could not be created."), null;
              }
            };
          return function t() {
            let r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : Y();
            const n = e => t(e);
            if (n.version = "3.0.5", n.removed = [], !r || !r.document || 9 !== r.document.nodeType) return n.isSupported = !1, n;
            const i = r.document,
              a = i.currentScript;
            let {
              document: l
            } = r;
            const {
                DocumentFragment: s,
                HTMLTemplateElement: c,
                Node: w,
                Element: k,
                NodeFilter: H,
                NamedNodeMap: F = r.NamedNodeMap || r.MozNamedAttrMap,
                HTMLFormElement: z,
                DOMParser: _,
                trustedTypes: B
              } = r,
              U = k.prototype,
              G = T(U, "cloneNode"),
              q = T(U, "nextSibling"),
              $ = T(U, "childNodes"),
              J = T(U, "parentNode");
            if ("function" == typeof c) {
              const e = l.createElement("template");
              e.content && e.content.ownerDocument && (l = e.content.ownerDocument);
            }
            let Z,
              Q = "";
            const {
                implementation: ee,
                createNodeIterator: te,
                createDocumentFragment: re,
                getElementsByTagName: ne
              } = l,
              {
                importNode: ie
              } = i;
            let oe = {};
            n.isSupported = "function" == typeof e && "function" == typeof J && ee && void 0 !== ee.createHTMLDocument;
            const {
              MUSTACHE_EXPR: ae,
              ERB_EXPR: le,
              TMPLIT_EXPR: se,
              DATA_ATTR: ce,
              ARIA_ATTR: ue,
              IS_SCRIPT_OR_DATA: de,
              ATTR_WHITESPACE: fe
            } = K;
            let {
                IS_ALLOWED_URI: he
              } = K,
              pe = null;
            const me = C({}, [...L, ...N, ...E, ...A, ...D]);
            let ge = null;
            const ve = C({}, [...R, ...W, ...I, ...P]);
            let ye = Object.seal(Object.create(null, {
                tagNameCheck: {
                  writable: !0,
                  configurable: !1,
                  enumerable: !0,
                  value: null
                },
                attributeNameCheck: {
                  writable: !0,
                  configurable: !1,
                  enumerable: !0,
                  value: null
                },
                allowCustomizedBuiltInElements: {
                  writable: !0,
                  configurable: !1,
                  enumerable: !0,
                  value: !1
                }
              })),
              be = null,
              xe = null,
              we = !0,
              ke = !0,
              Ce = !1,
              Se = !0,
              Te = !1,
              Le = !1,
              Ne = !1,
              Ee = !1,
              Me = !1,
              Ae = !1,
              Oe = !1,
              De = !0,
              Re = !1;
            const We = "user-content-";
            let Ie = !0,
              Pe = !1,
              He = {},
              Fe = null;
            const ze = C({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
            let _e = null;
            const Be = C({}, ["audio", "video", "img", "source", "image", "track"]);
            let je = null;
            const Ue = C({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]),
              Ge = "http://www.w3.org/1998/Math/MathML",
              Ve = "http://www.w3.org/2000/svg",
              Ke = "http://www.w3.org/1999/xhtml";
            let Ye = Ke,
              Xe = !1,
              qe = null;
            const $e = C({}, [Ge, Ve, Ke], p);
            let Je;
            const Ze = ["application/xhtml+xml", "text/html"],
              Qe = "text/html";
            let et,
              tt = null;
            const rt = l.createElement("form"),
              nt = function (e) {
                return e instanceof RegExp || e instanceof Function;
              },
              it = function (e) {
                if (!tt || tt !== e) {
                  if (e && "object" == typeof e || (e = {}), e = S(e), Je = Je = -1 === Ze.indexOf(e.PARSER_MEDIA_TYPE) ? Qe : e.PARSER_MEDIA_TYPE, et = "application/xhtml+xml" === Je ? p : h, pe = "ALLOWED_TAGS" in e ? C({}, e.ALLOWED_TAGS, et) : me, ge = "ALLOWED_ATTR" in e ? C({}, e.ALLOWED_ATTR, et) : ve, qe = "ALLOWED_NAMESPACES" in e ? C({}, e.ALLOWED_NAMESPACES, p) : $e, je = "ADD_URI_SAFE_ATTR" in e ? C(S(Ue), e.ADD_URI_SAFE_ATTR, et) : Ue, _e = "ADD_DATA_URI_TAGS" in e ? C(S(Be), e.ADD_DATA_URI_TAGS, et) : Be, Fe = "FORBID_CONTENTS" in e ? C({}, e.FORBID_CONTENTS, et) : ze, be = "FORBID_TAGS" in e ? C({}, e.FORBID_TAGS, et) : {}, xe = "FORBID_ATTR" in e ? C({}, e.FORBID_ATTR, et) : {}, He = "USE_PROFILES" in e && e.USE_PROFILES, we = !1 !== e.ALLOW_ARIA_ATTR, ke = !1 !== e.ALLOW_DATA_ATTR, Ce = e.ALLOW_UNKNOWN_PROTOCOLS || !1, Se = !1 !== e.ALLOW_SELF_CLOSE_IN_ATTR, Te = e.SAFE_FOR_TEMPLATES || !1, Le = e.WHOLE_DOCUMENT || !1, Me = e.RETURN_DOM || !1, Ae = e.RETURN_DOM_FRAGMENT || !1, Oe = e.RETURN_TRUSTED_TYPE || !1, Ee = e.FORCE_BODY || !1, De = !1 !== e.SANITIZE_DOM, Re = e.SANITIZE_NAMED_PROPS || !1, Ie = !1 !== e.KEEP_CONTENT, Pe = e.IN_PLACE || !1, he = e.ALLOWED_URI_REGEXP || j, Ye = e.NAMESPACE || Ke, ye = e.CUSTOM_ELEMENT_HANDLING || {}, e.CUSTOM_ELEMENT_HANDLING && nt(e.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (ye.tagNameCheck = e.CUSTOM_ELEMENT_HANDLING.tagNameCheck), e.CUSTOM_ELEMENT_HANDLING && nt(e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (ye.attributeNameCheck = e.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), e.CUSTOM_ELEMENT_HANDLING && "boolean" == typeof e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (ye.allowCustomizedBuiltInElements = e.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), Te && (ke = !1), Ae && (Me = !0), He && (pe = C({}, [...D]), ge = [], !0 === He.html && (C(pe, L), C(ge, R)), !0 === He.svg && (C(pe, N), C(ge, W), C(ge, P)), !0 === He.svgFilters && (C(pe, E), C(ge, W), C(ge, P)), !0 === He.mathMl && (C(pe, A), C(ge, I), C(ge, P))), e.ADD_TAGS && (pe === me && (pe = S(pe)), C(pe, e.ADD_TAGS, et)), e.ADD_ATTR && (ge === ve && (ge = S(ge)), C(ge, e.ADD_ATTR, et)), e.ADD_URI_SAFE_ATTR && C(je, e.ADD_URI_SAFE_ATTR, et), e.FORBID_CONTENTS && (Fe === ze && (Fe = S(Fe)), C(Fe, e.FORBID_CONTENTS, et)), Ie && (pe["#text"] = !0), Le && C(pe, ["html", "head", "body"]), pe.table && (C(pe, ["tbody"]), delete be.tbody), e.TRUSTED_TYPES_POLICY) {
                    if ("function" != typeof e.TRUSTED_TYPES_POLICY.createHTML) throw x('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
                    if ("function" != typeof e.TRUSTED_TYPES_POLICY.createScriptURL) throw x('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
                    Z = e.TRUSTED_TYPES_POLICY, Q = Z.createHTML("");
                  } else void 0 === Z && (Z = X(B, a)), null !== Z && "string" == typeof Q && (Q = Z.createHTML(""));
                  o && o(e), tt = e;
                }
              },
              ot = C({}, ["mi", "mo", "mn", "ms", "mtext"]),
              at = C({}, ["foreignobject", "desc", "title", "annotation-xml"]),
              lt = C({}, ["title", "style", "font", "a", "script"]),
              st = C({}, N);
            C(st, E), C(st, M);
            const ct = C({}, A);
            C(ct, O);
            const ut = function (e) {
                let t = J(e);
                t && t.tagName || (t = {
                  namespaceURI: Ye,
                  tagName: "template"
                });
                const r = h(e.tagName),
                  n = h(t.tagName);
                return !!qe[e.namespaceURI] && (e.namespaceURI === Ve ? t.namespaceURI === Ke ? "svg" === r : t.namespaceURI === Ge ? "svg" === r && ("annotation-xml" === n || ot[n]) : Boolean(st[r]) : e.namespaceURI === Ge ? t.namespaceURI === Ke ? "math" === r : t.namespaceURI === Ve ? "math" === r && at[n] : Boolean(ct[r]) : e.namespaceURI === Ke ? !(t.namespaceURI === Ve && !at[n]) && !(t.namespaceURI === Ge && !ot[n]) && !ct[r] && (lt[r] || !st[r]) : !("application/xhtml+xml" !== Je || !qe[e.namespaceURI]));
              },
              dt = function (e) {
                f(n.removed, {
                  element: e
                });
                try {
                  e.parentNode.removeChild(e);
                } catch (t) {
                  e.remove();
                }
              },
              ft = function (e, t) {
                try {
                  f(n.removed, {
                    attribute: t.getAttributeNode(e),
                    from: t
                  });
                } catch (e) {
                  f(n.removed, {
                    attribute: null,
                    from: t
                  });
                }
                if (t.removeAttribute(e), "is" === e && !ge[e]) if (Me || Ae) try {
                  dt(t);
                } catch (e) {} else try {
                  t.setAttribute(e, "");
                } catch (e) {}
              },
              ht = function (e) {
                let t, r;
                if (Ee) e = "<remove></remove>" + e;else {
                  const t = m(e, /^[\r\n\t ]+/);
                  r = t && t[0];
                }
                "application/xhtml+xml" === Je && Ye === Ke && (e = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + e + "</body></html>");
                const n = Z ? Z.createHTML(e) : e;
                if (Ye === Ke) try {
                  t = new _().parseFromString(n, Je);
                } catch (e) {}
                if (!t || !t.documentElement) {
                  t = ee.createDocument(Ye, "template", null);
                  try {
                    t.documentElement.innerHTML = Xe ? Q : n;
                  } catch (e) {}
                }
                const i = t.body || t.documentElement;
                return e && r && i.insertBefore(l.createTextNode(r), i.childNodes[0] || null), Ye === Ke ? ne.call(t, Le ? "html" : "body")[0] : Le ? t.documentElement : i;
              },
              pt = function (e) {
                return te.call(e.ownerDocument || e, e, H.SHOW_ELEMENT | H.SHOW_COMMENT | H.SHOW_TEXT, null, !1);
              },
              mt = function (e) {
                return e instanceof z && ("string" != typeof e.nodeName || "string" != typeof e.textContent || "function" != typeof e.removeChild || !(e.attributes instanceof F) || "function" != typeof e.removeAttribute || "function" != typeof e.setAttribute || "string" != typeof e.namespaceURI || "function" != typeof e.insertBefore || "function" != typeof e.hasChildNodes);
              },
              gt = function (e) {
                return "object" == typeof w ? e instanceof w : e && "object" == typeof e && "number" == typeof e.nodeType && "string" == typeof e.nodeName;
              },
              vt = function (e, t, r) {
                oe[e] && u(oe[e], e => {
                  e.call(n, t, r, tt);
                });
              },
              yt = function (e) {
                let t;
                if (vt("beforeSanitizeElements", e, null), mt(e)) return dt(e), !0;
                const r = et(e.nodeName);
                if (vt("uponSanitizeElement", e, {
                  tagName: r,
                  allowedTags: pe
                }), e.hasChildNodes() && !gt(e.firstElementChild) && (!gt(e.content) || !gt(e.content.firstElementChild)) && b(/<[/\w]/g, e.innerHTML) && b(/<[/\w]/g, e.textContent)) return dt(e), !0;
                if (!pe[r] || be[r]) {
                  if (!be[r] && xt(r)) {
                    if (ye.tagNameCheck instanceof RegExp && b(ye.tagNameCheck, r)) return !1;
                    if (ye.tagNameCheck instanceof Function && ye.tagNameCheck(r)) return !1;
                  }
                  if (Ie && !Fe[r]) {
                    const t = J(e) || e.parentNode,
                      r = $(e) || e.childNodes;
                    if (r && t) for (let n = r.length - 1; n >= 0; --n) t.insertBefore(G(r[n], !0), q(e));
                  }
                  return dt(e), !0;
                }
                return e instanceof k && !ut(e) ? (dt(e), !0) : "noscript" !== r && "noembed" !== r && "noframes" !== r || !b(/<\/no(script|embed|frames)/i, e.innerHTML) ? (Te && 3 === e.nodeType && (t = e.textContent, t = g(t, ae, " "), t = g(t, le, " "), t = g(t, se, " "), e.textContent !== t && (f(n.removed, {
                  element: e.cloneNode()
                }), e.textContent = t)), vt("afterSanitizeElements", e, null), !1) : (dt(e), !0);
              },
              bt = function (e, t, r) {
                if (De && ("id" === t || "name" === t) && (r in l || r in rt)) return !1;
                if (ke && !xe[t] && b(ce, t)) ;else if (we && b(ue, t)) ;else if (!ge[t] || xe[t]) {
                  if (!(xt(e) && (ye.tagNameCheck instanceof RegExp && b(ye.tagNameCheck, e) || ye.tagNameCheck instanceof Function && ye.tagNameCheck(e)) && (ye.attributeNameCheck instanceof RegExp && b(ye.attributeNameCheck, t) || ye.attributeNameCheck instanceof Function && ye.attributeNameCheck(t)) || "is" === t && ye.allowCustomizedBuiltInElements && (ye.tagNameCheck instanceof RegExp && b(ye.tagNameCheck, r) || ye.tagNameCheck instanceof Function && ye.tagNameCheck(r)))) return !1;
                } else if (je[t]) ;else if (b(he, g(r, fe, ""))) ;else if ("src" !== t && "xlink:href" !== t && "href" !== t || "script" === e || 0 !== v(r, "data:") || !_e[e]) if (Ce && !b(de, g(r, fe, ""))) ;else if (r) return !1;
                return !0;
              },
              xt = function (e) {
                return e.indexOf("-") > 0;
              },
              wt = function (e) {
                let t, r, i, o;
                vt("beforeSanitizeAttributes", e, null);
                const {
                  attributes: a
                } = e;
                if (!a) return;
                const l = {
                  attrName: "",
                  attrValue: "",
                  keepAttr: !0,
                  allowedAttributes: ge
                };
                for (o = a.length; o--;) {
                  t = a[o];
                  const {
                    name: s,
                    namespaceURI: c
                  } = t;
                  if (r = "value" === s ? t.value : y(t.value), i = et(s), l.attrName = i, l.attrValue = r, l.keepAttr = !0, l.forceKeepAttr = void 0, vt("uponSanitizeAttribute", e, l), r = l.attrValue, l.forceKeepAttr) continue;
                  if (ft(s, e), !l.keepAttr) continue;
                  if (!Se && b(/\/>/i, r)) {
                    ft(s, e);
                    continue;
                  }
                  Te && (r = g(r, ae, " "), r = g(r, le, " "), r = g(r, se, " "));
                  const u = et(e.nodeName);
                  if (bt(u, i, r)) {
                    if (!Re || "id" !== i && "name" !== i || (ft(s, e), r = We + r), Z && "object" == typeof B && "function" == typeof B.getAttributeType) if (c) ;else switch (B.getAttributeType(u, i)) {
                      case "TrustedHTML":
                        r = Z.createHTML(r);
                        break;
                      case "TrustedScriptURL":
                        r = Z.createScriptURL(r);
                    }
                    try {
                      c ? e.setAttributeNS(c, s, r) : e.setAttribute(s, r), d(n.removed);
                    } catch (e) {}
                  }
                }
                vt("afterSanitizeAttributes", e, null);
              },
              kt = function e(t) {
                let r;
                const n = pt(t);
                for (vt("beforeSanitizeShadowDOM", t, null); r = n.nextNode();) vt("uponSanitizeShadowNode", r, null), yt(r) || (r.content instanceof s && e(r.content), wt(r));
                vt("afterSanitizeShadowDOM", t, null);
              };
            return n.sanitize = function (e) {
              let t,
                r,
                o,
                a,
                l = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              if (Xe = !e, Xe && (e = "\x3c!--\x3e"), "string" != typeof e && !gt(e)) {
                if ("function" != typeof e.toString) throw x("toString is not a function");
                if ("string" != typeof (e = e.toString())) throw x("dirty is not a string, aborting");
              }
              if (!n.isSupported) return e;
              if (Ne || it(l), n.removed = [], "string" == typeof e && (Pe = !1), Pe) {
                if (e.nodeName) {
                  const t = et(e.nodeName);
                  if (!pe[t] || be[t]) throw x("root node is forbidden and cannot be sanitized in-place");
                }
              } else if (e instanceof w) t = ht("\x3c!----\x3e"), r = t.ownerDocument.importNode(e, !0), 1 === r.nodeType && "BODY" === r.nodeName || "HTML" === r.nodeName ? t = r : t.appendChild(r);else {
                if (!Me && !Te && !Le && -1 === e.indexOf("<")) return Z && Oe ? Z.createHTML(e) : e;
                if (t = ht(e), !t) return Me ? null : Oe ? Q : "";
              }
              t && Ee && dt(t.firstChild);
              const c = pt(Pe ? e : t);
              for (; o = c.nextNode();) yt(o) || (o.content instanceof s && kt(o.content), wt(o));
              if (Pe) return e;
              if (Me) {
                if (Ae) for (a = re.call(t.ownerDocument); t.firstChild;) a.appendChild(t.firstChild);else a = t;
                return (ge.shadowroot || ge.shadowrootmode) && (a = ie.call(i, a, !0)), a;
              }
              let u = Le ? t.outerHTML : t.innerHTML;
              return Le && pe["!doctype"] && t.ownerDocument && t.ownerDocument.doctype && t.ownerDocument.doctype.name && b(V, t.ownerDocument.doctype.name) && (u = "<!DOCTYPE " + t.ownerDocument.doctype.name + ">\n" + u), Te && (u = g(u, ae, " "), u = g(u, le, " "), u = g(u, se, " ")), Z && Oe ? Z.createHTML(u) : u;
            }, n.setConfig = function (e) {
              it(e), Ne = !0;
            }, n.clearConfig = function () {
              tt = null, Ne = !1;
            }, n.isValidAttribute = function (e, t, r) {
              tt || it({});
              const n = et(e),
                i = et(t);
              return bt(n, i, r);
            }, n.addHook = function (e, t) {
              "function" == typeof t && (oe[e] = oe[e] || [], f(oe[e], t));
            }, n.removeHook = function (e) {
              if (oe[e]) return d(oe[e]);
            }, n.removeHooks = function (e) {
              oe[e] && (oe[e] = []);
            }, n.removeAllHooks = function () {
              oe = {};
            }, n;
          }();
        }();
      },
      656: (e, t, r) => {
        "use strict";

        function n() {
          return n = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
            }
            return e;
          }, n.apply(this, arguments);
        }
        function i(e) {
          return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
            return typeof e;
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
          }, i(e);
        }
        var o,
          a = (o = function (e, t) {
            return o = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (e, t) {
              e.__proto__ = t;
            } || function (e, t) {
              for (var r in t) t.hasOwnProperty(r) && (e[r] = t[r]);
            }, o(e, t);
          }, function (e, t) {
            function r() {
              this.constructor = e;
            }
            o(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
          });
        t.fk = void 0;
        var l,
          s = r(156),
          c = "undefined" == typeof navigator || !0 === r.g.PREVENT_CODEMIRROR_RENDER;
        c || (l = r(631));
        var u = function () {
            function e() {}
            return e.equals = function (e, t) {
              var r = this,
                n = Object.keys,
                o = i(e),
                a = i(t);
              return e && t && "object" === o && o === a ? n(e).length === n(t).length && n(e).every(function (n) {
                return r.equals(e[n], t[n]);
              }) : e === t;
            }, e;
          }(),
          d = function () {
            function e(e, t) {
              this.editor = e, this.props = t;
            }
            return e.prototype.delegateCursor = function (e, t, r) {
              var n = this.editor.getDoc();
              r && this.editor.focus(), t ? n.setCursor(e) : n.setCursor(e, null, {
                scroll: !1
              });
            }, e.prototype.delegateScroll = function (e) {
              this.editor.scrollTo(e.x, e.y);
            }, e.prototype.delegateSelection = function (e, t) {
              this.editor.getDoc().setSelections(e), t && this.editor.focus();
            }, e.prototype.apply = function (e) {
              e && e.selection && e.selection.ranges && this.delegateSelection(e.selection.ranges, e.selection.focus || !1), e && e.cursor && this.delegateCursor(e.cursor, e.autoScroll || !1, this.editor.getOption("autofocus") || !1), e && e.scroll && this.delegateScroll(e.scroll);
            }, e.prototype.applyNext = function (e, t, r) {
              e && e.selection && e.selection.ranges && t && t.selection && t.selection.ranges && !u.equals(e.selection.ranges, t.selection.ranges) && this.delegateSelection(t.selection.ranges, t.selection.focus || !1), e && e.cursor && t && t.cursor && !u.equals(e.cursor, t.cursor) && this.delegateCursor(r.cursor || t.cursor, t.autoScroll || !1, t.autoCursor || !1), e && e.scroll && t && t.scroll && !u.equals(e.scroll, t.scroll) && this.delegateScroll(t.scroll);
            }, e.prototype.applyUserDefined = function (e, t) {
              t && t.cursor && this.delegateCursor(t.cursor, e.autoScroll || !1, this.editor.getOption("autofocus") || !1);
            }, e.prototype.wire = function (e) {
              var t = this;
              Object.keys(e || {}).filter(function (e) {
                return /^on/.test(e);
              }).forEach(function (e) {
                switch (e) {
                  case "onBlur":
                    t.editor.on("blur", function (e, r) {
                      t.props.onBlur(t.editor, r);
                    });
                    break;
                  case "onContextMenu":
                    t.editor.on("contextmenu", function (e, r) {
                      t.props.onContextMenu(t.editor, r);
                    });
                    break;
                  case "onCopy":
                    t.editor.on("copy", function (e, r) {
                      t.props.onCopy(t.editor, r);
                    });
                    break;
                  case "onCursor":
                    t.editor.on("cursorActivity", function (e) {
                      t.props.onCursor(t.editor, t.editor.getDoc().getCursor());
                    });
                    break;
                  case "onCursorActivity":
                    t.editor.on("cursorActivity", function (e) {
                      t.props.onCursorActivity(t.editor);
                    });
                    break;
                  case "onCut":
                    t.editor.on("cut", function (e, r) {
                      t.props.onCut(t.editor, r);
                    });
                    break;
                  case "onDblClick":
                    t.editor.on("dblclick", function (e, r) {
                      t.props.onDblClick(t.editor, r);
                    });
                    break;
                  case "onDragEnter":
                    t.editor.on("dragenter", function (e, r) {
                      t.props.onDragEnter(t.editor, r);
                    });
                    break;
                  case "onDragLeave":
                    t.editor.on("dragleave", function (e, r) {
                      t.props.onDragLeave(t.editor, r);
                    });
                    break;
                  case "onDragOver":
                    t.editor.on("dragover", function (e, r) {
                      t.props.onDragOver(t.editor, r);
                    });
                    break;
                  case "onDragStart":
                    t.editor.on("dragstart", function (e, r) {
                      t.props.onDragStart(t.editor, r);
                    });
                    break;
                  case "onDrop":
                    t.editor.on("drop", function (e, r) {
                      t.props.onDrop(t.editor, r);
                    });
                    break;
                  case "onFocus":
                    t.editor.on("focus", function (e, r) {
                      t.props.onFocus(t.editor, r);
                    });
                    break;
                  case "onGutterClick":
                    t.editor.on("gutterClick", function (e, r, n, i) {
                      t.props.onGutterClick(t.editor, r, n, i);
                    });
                    break;
                  case "onInputRead":
                    t.editor.on("inputRead", function (e, r) {
                      t.props.onInputRead(t.editor, r);
                    });
                    break;
                  case "onKeyDown":
                    t.editor.on("keydown", function (e, r) {
                      t.props.onKeyDown(t.editor, r);
                    });
                    break;
                  case "onKeyHandled":
                    t.editor.on("keyHandled", function (e, r, n) {
                      t.props.onKeyHandled(t.editor, r, n);
                    });
                    break;
                  case "onKeyPress":
                    t.editor.on("keypress", function (e, r) {
                      t.props.onKeyPress(t.editor, r);
                    });
                    break;
                  case "onKeyUp":
                    t.editor.on("keyup", function (e, r) {
                      t.props.onKeyUp(t.editor, r);
                    });
                    break;
                  case "onMouseDown":
                    t.editor.on("mousedown", function (e, r) {
                      t.props.onMouseDown(t.editor, r);
                    });
                    break;
                  case "onPaste":
                    t.editor.on("paste", function (e, r) {
                      t.props.onPaste(t.editor, r);
                    });
                    break;
                  case "onRenderLine":
                    t.editor.on("renderLine", function (e, r, n) {
                      t.props.onRenderLine(t.editor, r, n);
                    });
                    break;
                  case "onScroll":
                    t.editor.on("scroll", function (e) {
                      t.props.onScroll(t.editor, t.editor.getScrollInfo());
                    });
                    break;
                  case "onSelection":
                    t.editor.on("beforeSelectionChange", function (e, r) {
                      t.props.onSelection(t.editor, r);
                    });
                    break;
                  case "onTouchStart":
                    t.editor.on("touchstart", function (e, r) {
                      t.props.onTouchStart(t.editor, r);
                    });
                    break;
                  case "onUpdate":
                    t.editor.on("update", function (e) {
                      t.props.onUpdate(t.editor);
                    });
                    break;
                  case "onViewportChange":
                    t.editor.on("viewportChange", function (e, r, n) {
                      t.props.onViewportChange(t.editor, r, n);
                    });
                }
              });
            }, e;
          }(),
          f = function (e) {
            function t(t) {
              var r = e.call(this, t) || this;
              return c || (r.applied = !1, r.appliedNext = !1, r.appliedUserDefined = !1, r.deferred = null, r.emulating = !1, r.hydrated = !1, r.initCb = function () {
                r.props.editorDidConfigure && r.props.editorDidConfigure(r.editor);
              }, r.mounted = !1), r;
            }
            return a(t, e), t.prototype.hydrate = function (e) {
              var t = this,
                r = e && e.options ? e.options : {},
                i = n({}, l.defaults, this.editor.options, r);
              Object.keys(i).some(function (e) {
                return t.editor.getOption(e) !== i[e];
              }) && Object.keys(i).forEach(function (e) {
                r.hasOwnProperty(e) && t.editor.getOption(e) !== i[e] && (t.editor.setOption(e, i[e]), t.mirror.setOption(e, i[e]));
              }), this.hydrated || (this.deferred ? this.resolveChange(e.value) : this.initChange(e.value || "")), this.hydrated = !0;
            }, t.prototype.initChange = function (e) {
              this.emulating = !0;
              var t = this.editor.getDoc(),
                r = t.lastLine(),
                n = t.getLine(t.lastLine()).length;
              t.replaceRange(e || "", {
                line: 0,
                ch: 0
              }, {
                line: r,
                ch: n
              }), this.mirror.setValue(e), t.clearHistory(), this.mirror.clearHistory(), this.emulating = !1;
            }, t.prototype.resolveChange = function (e) {
              this.emulating = !0;
              var t = this.editor.getDoc();
              if ("undo" === this.deferred.origin ? t.undo() : "redo" === this.deferred.origin ? t.redo() : t.replaceRange(this.deferred.text, this.deferred.from, this.deferred.to, this.deferred.origin), e && e !== t.getValue()) {
                var r = t.getCursor();
                t.setValue(e), t.setCursor(r);
              }
              this.emulating = !1, this.deferred = null;
            }, t.prototype.mirrorChange = function (e) {
              var t = this.editor.getDoc();
              return "undo" === e.origin ? (t.setHistory(this.mirror.getHistory()), this.mirror.undo()) : "redo" === e.origin ? (t.setHistory(this.mirror.getHistory()), this.mirror.redo()) : this.mirror.replaceRange(e.text, e.from, e.to, e.origin), this.mirror.getValue();
            }, t.prototype.componentDidMount = function () {
              var e = this;
              c || (this.props.defineMode && this.props.defineMode.name && this.props.defineMode.fn && l.defineMode(this.props.defineMode.name, this.props.defineMode.fn), this.editor = l(this.ref, this.props.options), this.shared = new d(this.editor, this.props), this.mirror = l(function () {}, this.props.options), this.editor.on("electricInput", function () {
                e.mirror.setHistory(e.editor.getDoc().getHistory());
              }), this.editor.on("cursorActivity", function () {
                e.mirror.setCursor(e.editor.getDoc().getCursor());
              }), this.editor.on("beforeChange", function (t, r) {
                if (!e.emulating) {
                  r.cancel(), e.deferred = r;
                  var n = e.mirrorChange(e.deferred);
                  e.props.onBeforeChange && e.props.onBeforeChange(e.editor, e.deferred, n);
                }
              }), this.editor.on("change", function (t, r) {
                e.mounted && e.props.onChange && e.props.onChange(e.editor, r, e.editor.getValue());
              }), this.hydrate(this.props), this.shared.apply(this.props), this.applied = !0, this.mounted = !0, this.shared.wire(this.props), this.editor.getOption("autofocus") && this.editor.focus(), this.props.editorDidMount && this.props.editorDidMount(this.editor, this.editor.getValue(), this.initCb));
            }, t.prototype.componentDidUpdate = function (e) {
              if (!c) {
                var t = {
                  cursor: null
                };
                this.props.value !== e.value && (this.hydrated = !1), this.props.autoCursor || void 0 === this.props.autoCursor || (t.cursor = this.editor.getDoc().getCursor()), this.hydrate(this.props), this.appliedNext || (this.shared.applyNext(e, this.props, t), this.appliedNext = !0), this.shared.applyUserDefined(e, t), this.appliedUserDefined = !0;
              }
            }, t.prototype.componentWillUnmount = function () {
              c || this.props.editorWillUnmount && this.props.editorWillUnmount(l);
            }, t.prototype.shouldComponentUpdate = function (e, t) {
              return !c;
            }, t.prototype.render = function () {
              var e = this;
              if (c) return null;
              var t = this.props.className ? "react-codemirror2 " + this.props.className : "react-codemirror2";
              return s.createElement("div", {
                className: t,
                ref: function (t) {
                  return e.ref = t;
                }
              });
            }, t;
          }(s.Component);
        t.fk = f, function (e) {
          function t(t) {
            var r = e.call(this, t) || this;
            return c || (r.applied = !1, r.appliedUserDefined = !1, r.continueChange = !1, r.detached = !1, r.hydrated = !1, r.initCb = function () {
              r.props.editorDidConfigure && r.props.editorDidConfigure(r.editor);
            }, r.mounted = !1, r.onBeforeChangeCb = function () {
              r.continueChange = !0;
            }), r;
          }
          a(t, e), t.prototype.hydrate = function (e) {
            var t = this,
              r = e && e.options ? e.options : {},
              i = n({}, l.defaults, this.editor.options, r);
            if (Object.keys(i).some(function (e) {
              return t.editor.getOption(e) !== i[e];
            }) && Object.keys(i).forEach(function (e) {
              r.hasOwnProperty(e) && t.editor.getOption(e) !== i[e] && t.editor.setOption(e, i[e]);
            }), !this.hydrated) {
              var o = this.editor.getDoc(),
                a = o.lastLine(),
                s = o.getLine(o.lastLine()).length;
              o.replaceRange(e.value || "", {
                line: 0,
                ch: 0
              }, {
                line: a,
                ch: s
              });
            }
            this.hydrated = !0;
          }, t.prototype.componentDidMount = function () {
            var e = this;
            c || (this.detached = !0 === this.props.detach, this.props.defineMode && this.props.defineMode.name && this.props.defineMode.fn && l.defineMode(this.props.defineMode.name, this.props.defineMode.fn), this.editor = l(this.ref, this.props.options), this.shared = new d(this.editor, this.props), this.editor.on("beforeChange", function (t, r) {
              e.props.onBeforeChange && e.props.onBeforeChange(e.editor, r, e.editor.getValue(), e.onBeforeChangeCb);
            }), this.editor.on("change", function (t, r) {
              e.mounted && e.props.onChange && (e.props.onBeforeChange ? e.continueChange && e.props.onChange(e.editor, r, e.editor.getValue()) : e.props.onChange(e.editor, r, e.editor.getValue()));
            }), this.hydrate(this.props), this.shared.apply(this.props), this.applied = !0, this.mounted = !0, this.shared.wire(this.props), this.editor.getDoc().clearHistory(), this.props.editorDidMount && this.props.editorDidMount(this.editor, this.editor.getValue(), this.initCb));
          }, t.prototype.componentDidUpdate = function (e) {
            if (this.detached && !1 === this.props.detach && (this.detached = !1, e.editorDidAttach && e.editorDidAttach(this.editor)), this.detached || !0 !== this.props.detach || (this.detached = !0, e.editorDidDetach && e.editorDidDetach(this.editor)), !c && !this.detached) {
              var t = {
                cursor: null
              };
              this.props.value !== e.value && (this.hydrated = !1, this.applied = !1, this.appliedUserDefined = !1), e.autoCursor || void 0 === e.autoCursor || (t.cursor = this.editor.getDoc().getCursor()), this.hydrate(this.props), this.applied || (this.shared.apply(e), this.applied = !0), this.appliedUserDefined || (this.shared.applyUserDefined(e, t), this.appliedUserDefined = !0);
            }
          }, t.prototype.componentWillUnmount = function () {
            c || this.props.editorWillUnmount && this.props.editorWillUnmount(l);
          }, t.prototype.shouldComponentUpdate = function (e, t) {
            var r = !0;
            return c && (r = !1), this.detached && e.detach && (r = !1), r;
          }, t.prototype.render = function () {
            var e = this;
            if (c) return null;
            var t = this.props.className ? "react-codemirror2 " + this.props.className : "react-codemirror2";
            return s.createElement("div", {
              className: t,
              ref: function (t) {
                return e.ref = t;
              }
            });
          };
        }(s.Component);
      },
      156: t => {
        "use strict";

        t.exports = e;
      }
    },
    r = {};
  function n(e) {
    var i = r[e];
    if (void 0 !== i) return i.exports;
    var o = r[e] = {
      exports: {}
    };
    return t[e].call(o.exports, o, o.exports, n), o.exports;
  }
  n.n = e => {
    var t = e && e.__esModule ? () => e.default : () => e;
    return n.d(t, {
      a: t
    }), t;
  }, n.d = (e, t) => {
    for (var r in t) n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, {
      enumerable: !0,
      get: t[r]
    });
  }, n.g = function () {
    if ("object" == typeof globalThis) return globalThis;
    try {
      return this || new Function("return this")();
    } catch (e) {
      if ("object" == typeof window) return window;
    }
  }(), n.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), n.r = e => {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  };
  var i = {};
  return (() => {
    "use strict";

    n.r(i), n.d(i, {
      ActivityPubExplorer: () => x,
      ActivityPubVisualization: () => u,
      ActivityWorkshop: () => C,
      WebFingerForge: () => L
    });
    var e = n(156),
      t = n.n(e),
      r = n(856),
      o = n.n(r);
    function a(e) {
      var r = e.json,
        n = e.clickableLinks,
        i = e.onLinkClick;
      if (null == r) return null;
      var o = "dark:text-blue-300 text-blue-700",
        a = "dark:text-blue-100 text-blue-900 pr-1",
        l = "dark:text-green-300 text-green-700";
      return t().createElement("div", {
        className: "overflow-auto font-mono dark:bg-mastodon-gray-900 bg-mastodon-gray-100"
      }, t().createElement(function e(r) {
        var s = r.value;
        if ("string" == typeof s) return t().createElement(t().Fragment, null, t().createElement("span", {
          className: l
        }, '"'), s.startsWith("https://") && n ? t().createElement("a", {
          className: "dark:text-green-300 text-green-700 hover:underline dark:hover:text-blue-300 hover:text-blue-700 cursor-pointer",
          onClick: function () {
            return i(s);
          }
        }, s) : t().createElement("span", {
          className: "dark:text-green-300 text-green-700"
        }, s), t().createElement("span", {
          className: l
        }, '"'));
        if ("number" == typeof s) return t().createElement("span", {
          className: "dark:text-green-300 text-green-700"
        }, s);
        if ("boolean" == typeof s) return t().createElement("span", {
          className: "dark:text-green-300 text-green-700"
        }, s.toString());
        if (null === s) return t().createElement("span", {
          className: "dark:text-green-300 text-green-700"
        }, "null");
        if (Array.isArray(s)) return t().createElement(t().Fragment, null, t().createElement("span", {
          className: a
        }, "["), t().createElement("div", {
          className: "pl-4"
        }, s.map(function (r, n) {
          return t().createElement("div", {
            key: n
          }, t().createElement(e, {
            value: r
          }), n < s.length - 1 && t().createElement("span", {
            className: a
          }, ","));
        })), t().createElement("span", {
          className: a
        }, "]"));
        if ("object" == typeof s) {
          var c = Object.entries(s);
          return t().createElement(t().Fragment, null, t().createElement("span", {
            className: a
          }, "{"), t().createElement("div", {
            className: "pl-4"
          }, c.map(function (r, n) {
            var i = r[0],
              l = r[1];
            return t().createElement("div", {
              key: i
            }, t().createElement("span", {
              className: o
            }, '"'), t().createElement("span", {
              className: "dark:text-blue-300 text-blue-700"
            }, i), t().createElement("span", {
              className: o
            }, '"'), t().createElement("span", {
              className: a
            }, ":"), t().createElement(e, {
              value: l
            }), n < c.length - 1 && t().createElement("span", {
              className: a
            }, ","));
          })), t().createElement("span", {
            className: a
          }, "}"));
        }
        return null;
      }, {
        value: r
      }));
    }
    function l(e) {
      var r = e.activity;
      return t().createElement("div", null, t().createElement("div", {
        className: "font-bold"
      }, r.type), function () {
        switch (r.type) {
          case "Follow":
          case "Like":
          case "Dislike":
          case "Block":
          case "Announce":
          case "Lock":
            return "string" == typeof r.object && t().createElement("div", {
              className: "object overflow-auto"
            }, r.object);
          case "Note":
          case "Question":
          case "Page":
            return t().createElement("div", {
              className: "object font-mono overflow-auto [&>p:first-child]:mt-0 [&>p:last-child]:mb-0 [&>p]:my-4 [&_a]:dark:text-mastodon-violet [&_a]:text-mastodon-blue [&_a]:no-underline",
              dangerouslySetInnerHTML: {
                __html: o().sanitize(r.name || r.content, {
                  ALLOWED_TAGS: ["p", "a", "br"]
                })
              }
            });
          case "Person":
            return t().createElement("div", {
              className: "object overflow-auto"
            }, r.id);
          case "Move":
            return t().createElement("div", {
              className: "object overflow-auto"
            }, t().createElement("div", null, r.object), t().createElement("div", {
              className: "italic"
            }, "to"), t().createElement("div", null, r.target));
          default:
            return null;
        }
      }());
    }
    function s(e) {
      var r = e.activity,
        n = e.nested,
        i = void 0 !== n && n;
      return r.type ? t().createElement("div", {
        className: "overflow-hidden ".concat(i ? "my-0 p-0.5 bg-mastodon-gray-200 dark:bg-mastodon-gray-800 border-0 border-l-4 border-l-mastodon-primary border-solid" : "my-2 p-1 border border-solid border-mastodon-gray-400 dark:border-mastodon-gray-800")
      }, t().createElement(l, {
        activity: r
      }), null != r.object && "string" != typeof r.object && t().createElement(s, {
        activity: r.object,
        nested: !0
      })) : null;
    }
    function c(r) {
      var n = r.event,
        i = r.clickableLinks,
        o = void 0 !== i && i,
        l = r.onLinkClick,
        c = r.showExplorerLink,
        u = void 0 !== c && c,
        d = r.onExplorerLinkClick,
        f = r.showWorkshopLink,
        h = void 0 !== f && f,
        p = r.onWorkshopLinkClick,
        m = (0, e.useState)(!1),
        g = m[0],
        v = m[1];
      return t().createElement("div", {
        className: "w-4/5 ".concat("inbound" == n.type ? "" : "self-end")
      }, t().createElement("div", {
        className: "bg-white text-black dark:bg-mastodon-gray-900 dark:text-white flex flex-col p-1 m-1 rounded rounded-tl-none  ".concat(n.failure && "border-red-600 dark:border-red-500 border-solid border")
      }, n.data.actor && t().createElement("div", null, t().createElement("span", {
        className: "italic dark:text-gray-400 text-gray-600"
      }, "From"), t().createElement("span", {
        className: "dark:text-gray-200 text-gray-800"
      }, " ", n.sender)), t().createElement("div", null, t().createElement("span", {
        className: "italic dark:text-gray-400 text-gray-600"
      }, "Sent to"), t().createElement("span", {
        className: "dark:text-gray-200 text-gray-800"
      }, " ", n.path)), t().createElement(s, {
        activity: n.data
      }), t().createElement("div", {
        className: "flex flex-row items-start justify-between"
      }, t().createElement("div", {
        className: "text-gray-600 dark:text-gray-400"
      }, new Date(n.timestamp).toLocaleTimeString()), t().createElement("div", {
        className: "flex flex-col items-end"
      }, t().createElement("button", {
        className: "border-0 p-0 bg-inherit underline hover:no-underline text-mastodon-gray-600 cursor-pointer",
        onClick: function () {
          return v(!g);
        }
      }, g ? "hide" : "show", " source"), g && u && t().createElement("a", {
        className: "border-0 p-0 bg-inherit underline hover:no-underline text-mastodon-gray-600 cursor-pointer",
        onClick: function () {
          return d(n.data);
        }
      }, "open in explorer"), g && h && t().createElement("a", {
        className: "border-0 p-0 bg-inherit underline hover:no-underline text-mastodon-gray-600 cursor-pointer",
        onClick: function () {
          return p(n);
        }
      }, "open in workshop"))), g && t().createElement(a, {
        json: n.data,
        clickableLinks: o,
        onLinkClick: l
      })), n.failure && t().createElement("div", {
        className: "pl-1"
      }, t().createElement("span", {
        className: "dark:text-red-500 text-red-600"
      }, "Sending failed"), t().createElement("span", {
        className: "dark:text-gray-400 text-gray-600"
      }, " (", n.failure, ")")));
    }
    function u(e) {
      var r = e.logs,
        n = e.clickableLinks,
        i = void 0 !== n && n,
        o = e.onLinkClick,
        a = e.showExplorerLink,
        l = void 0 !== a && a,
        s = e.onExplorerLinkClick,
        u = e.showWorkshopLink,
        d = void 0 !== u && u,
        f = e.onWorkshopLinkClick;
      return t().createElement("div", {
        className: "flex flex-col"
      }, r.filter(function (e) {
        return "keep-alive" !== e.type;
      }).map(function (e, r) {
        return t().createElement(c, {
          key: r + e.data.id,
          event: e,
          clickableLinks: i,
          onLinkClick: o,
          showExplorerLink: l,
          onExplorerLinkClick: s,
          showWorkshopLink: d,
          onWorkshopLinkClick: f
        });
      }));
    }
    function d(e) {
      var r = e.small,
        n = void 0 !== r && r,
        i = e.colorDefinition,
        o = i ? "bg-".concat(i) : "bg-slate-600 dark:bg-slate-400";
      return t().createElement("div", {
        className: "activitypub-loading-indicator-container"
      }, t().createElement("div", {
        className: "activitypub-loading-indicator ".concat(n && "small")
      }, t().createElement("div", {
        className: o
      }), t().createElement("div", {
        className: o
      }), t().createElement("div", {
        className: o
      }), t().createElement("div", {
        className: o
      })));
    }
    var f = ["styles"];
    function h() {
      return h = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];
          for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
        return e;
      }, h.apply(this, arguments);
    }
    const p = function (e) {
      e.styles;
      var r = function (e, t) {
        if (null == e) return {};
        var r,
          n,
          i = function (e, t) {
            if (null == e) return {};
            var r,
              n,
              i = {},
              o = Object.keys(e);
            for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
            return i;
          }(e, t);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
        }
        return i;
      }(e, f);
      return t().createElement("svg", h({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }, r), t().createElement("path", {
        d: "M20 11v2H8l5.5 5.5-1.42 1.42L4.16 12l7.92-7.92L13.5 5.5 8 11h12z"
      }));
    };
    var m = ["styles"];
    function g() {
      return g = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];
          for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
        return e;
      }, g.apply(this, arguments);
    }
    const v = function (e) {
      e.styles;
      var r = function (e, t) {
        if (null == e) return {};
        var r,
          n,
          i = function (e, t) {
            if (null == e) return {};
            var r,
              n,
              i = {},
              o = Object.keys(e);
            for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
            return i;
          }(e, t);
        if (Object.getOwnPropertySymbols) {
          var o = Object.getOwnPropertySymbols(e);
          for (n = 0; n < o.length; n++) r = o[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
        }
        return i;
      }(e, m);
      return t().createElement("svg", g({
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
      }, r), t().createElement("path", {
        d: "M17.65 6.35A7.958 7.958 0 0012 4a8 8 0 00-8 8 8 8 0 008 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0112 18a6 6 0 01-6-6 6 6 0 016-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
      }));
    };
    var y = function (e, t, r) {
        if (r || 2 === arguments.length) for (var n, i = 0, o = t.length; i < o; i++) !n && i in t || (n || (n = Array.prototype.slice.call(t, 0, i)), n[i] = t[i]);
        return e.concat(n || Array.prototype.slice.call(t));
      },
      b = /^[!@](?<username>[^@]+)@(?<domain>[^@]+)$/;
    function x(r) {
      var n = this,
        i = r.fetchMethod,
        o = r.initialActivityJson,
        l = void 0 === o ? null : o,
        s = r.initialUrl,
        c = void 0 === s ? "" : s,
        u = (0, e.useState)(!1),
        f = u[0],
        h = u[1],
        m = (0, e.useState)(""),
        g = m[0],
        x = m[1],
        w = (0, e.useState)(null != l ? [{
          url: "",
          status: null,
          statusText: null,
          activityJson: l,
          validJson: !0
        }] : []),
        k = w[0],
        C = w[1],
        S = (0, e.useState)(!1),
        T = S[0],
        L = S[1];
      (0, e.useEffect)(function () {
        "" != c && N(c);
      }, []);
      var N = function (e, t) {
          return void 0 === t && (t = k), r = n, o = void 0, l = function () {
            var r, n, o, a, l, s;
            return function (e, t) {
              var r,
                n,
                i,
                o,
                a = {
                  label: 0,
                  sent: function () {
                    if (1 & i[0]) throw i[1];
                    return i[1];
                  },
                  trys: [],
                  ops: []
                };
              return o = {
                next: l(0),
                throw: l(1),
                return: l(2)
              }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
                return this;
              }), o;
              function l(o) {
                return function (l) {
                  return function (o) {
                    if (r) throw new TypeError("Generator is already executing.");
                    for (; a;) try {
                      if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;
                      switch (n = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                        case 0:
                        case 1:
                          i = o;
                          break;
                        case 4:
                          return a.label++, {
                            value: o[1],
                            done: !1
                          };
                        case 5:
                          a.label++, n = o[1], o = [0];
                          continue;
                        case 7:
                          o = a.ops.pop(), a.trys.pop();
                          continue;
                        default:
                          if (!((i = (i = a.trys).length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                            a = 0;
                            continue;
                          }
                          if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                            a.label = o[1];
                            break;
                          }
                          if (6 === o[0] && a.label < i[1]) {
                            a.label = i[1], i = o;
                            break;
                          }
                          if (i && a.label < i[2]) {
                            a.label = i[2], a.ops.push(o);
                            break;
                          }
                          i[2] && a.ops.pop(), a.trys.pop();
                          continue;
                      }
                      o = t.call(e, a);
                    } catch (e) {
                      o = [6, e], n = 0;
                    } finally {
                      r = i = 0;
                    }
                    if (5 & o[0]) throw o[1];
                    return {
                      value: o[0] ? o[1] : void 0,
                      done: !0
                    };
                  }([o, l]);
                };
              }
            }(this, function (c) {
              switch (c.label) {
                case 0:
                  return r = e.match(b), n = null != r ? "https://".concat(r.groups.domain, "/.well-known/webfinger?resource=acct:").concat(r.groups.username, "%40").concat(r.groups.domain) : e, C(y(y([], t, !0), [{
                    url: n,
                    status: null,
                    statusText: null,
                    activityJson: null,
                    validJson: !1
                  }], !1)), x(n), L(!0), [4, i(n)];
                case 1:
                  o = c.sent(), L(!1), c.label = 2;
                case 2:
                  return c.trys.push([2, 4,, 5]), a = C, l = [y([], t, !0)], s = {
                    url: n,
                    status: o.status,
                    statusText: o.statusText
                  }, [4, o.json()];
                case 3:
                  return a.apply(void 0, [y.apply(void 0, l.concat([[(s.activityJson = c.sent(), s.validJson = !0, s)], !1]))]), [3, 5];
                case 4:
                  return c.sent(), C(y(y([], t, !0), [{
                    url: n,
                    status: o.status,
                    statusText: o.statusText,
                    activityJson: null,
                    validJson: !1
                  }], !1)), [3, 5];
                case 5:
                  return [2];
              }
            });
          }, new ((a = void 0) || (a = Promise))(function (e, t) {
            function n(e) {
              try {
                s(l.next(e));
              } catch (e) {
                t(e);
              }
            }
            function i(e) {
              try {
                s(l.throw(e));
              } catch (e) {
                t(e);
              }
            }
            function s(t) {
              var r;
              t.done ? e(t.value) : (r = t.value, r instanceof a ? r : new a(function (e) {
                e(r);
              })).then(n, i);
            }
            s((l = l.apply(r, o || [])).next());
          });
          var r, o, a, l;
        },
        E = k[k.length - 1] || {},
        M = E.url,
        A = void 0 === M ? "" : M,
        O = E.status,
        D = E.statusText,
        R = E.activityJson,
        W = E.validJson;
      return t().createElement("div", {
        className: "dark:text-mastodon-gray-500 dark:bg-mastodon-gray-1000 bg-mastodon-gray-200"
      }, t().createElement("div", {
        className: "p-4 flex items-center"
      }, t().createElement("button", {
        className: "w-6 h-6 p-0 m-2 ml-0 bg-transparent border-0 ".concat(k.length > 1 ? "fill-mastodon-gray-600 cursor-pointer" : "dark:fill-mastodon-gray-800 fill-mastodon-gray-400"),
        onClick: function () {
          k.length > 1 && (x(k[k.length - 2].url || ""), C(k.slice(0, k.length - 1)));
        }
      }, t().createElement(p, null)), t().createElement("button", {
        className: "w-6 h-6 p-0 m-2 bg-transparent border-0 ".concat("" !== A ? "fill-mastodon-gray-600 cursor-pointer" : "dark:fill-mastodon-gray-800 fill-mastodon-gray-400"),
        onClick: function () {
          "" !== A && N(A, k.slice(0, k.length - 1));
        }
      }, t().createElement(v, null)), t().createElement("div", {
        className: "flex flex-col items-center w-full"
      }, t().createElement("input", {
        className: ["w-full", "box-border", "p-2.5", "rounded", "outline-none", "border-solid", "text-base", "leading-[18px]", "dark:border-mastodon-gray-800", "border-mastodon-gray-500", "dark:bg-mastodon-gray-900", "bg-mastodon-gray-300", "dark:text-mastodon-gray-500", "text-mastodon-gray-900"].join(" "),
        type: "text",
        value: g,
        spellCheck: !1,
        onChange: function (e) {
          return x(e.target.value);
        },
        onKeyPress: function (e) {
          "Enter" === e.key && N(g);
        },
        onFocus: function () {
          return h(!0);
        },
        onBlur: function () {
          return h(!1);
        },
        placeholder: "Enter an ActivityPub URL"
      }), "" === g && f && t().createElement(function () {
        return t().createElement("div", {
          className: "relative"
        }, t().createElement("div", {
          className: "absolute shadow-xl rounded p-2 text-mastodon-gray-700 left-[-200px] w-[400px] top-[10px] bg-white"
        }, t().createElement("div", {
          className: "uppercase font-medium"
        }, "Examples"), t().createElement("div", {
          className: "my-2"
        }, "Enter", " ", t().createElement("span", {
          className: "font-medium text-black"
        }, "https://mastodon.social/users/Gargron"), " to see the actor definition of @Gargron@mastodon.social."), t().createElement("div", {
          className: "my-2"
        }, "Enter", " ", t().createElement("span", {
          className: "font-medium text-black"
        }, "https://mastodon.social/users/crepels/followers"), " ", "to see the followers collection of @crepels@mastodon.social."), t().createElement("div", {
          className: "mt-2"
        }, "Enter a full mention like", " ", t().createElement("span", {
          className: "font-medium text-black"
        }, "@crepels@mastodon.social"), "; it will be translated to the corresponding webfinger URL."), t().createElement("div", {
          className: "mt-2"
        }, "Enter a full Lemmy community name like", " ", t().createElement("span", {
          className: "font-medium text-black"
        }, "!fediverse@lemmy.world"), "; it will be translated to the corresponding webfinger URL.")));
      }, null))), k.length > 0 && t().createElement("div", {
        className: "border-0 border-t border-solid dark:border-t-mastodon-gray-800 border-t-mastodon-gray-500"
      }, T ? t().createElement(d, null) : W ? t().createElement(a, {
        json: R,
        clickableLinks: !0,
        onLinkClick: function (e) {
          return N(e);
        }
      }) : t().createElement("div", null, "The response did not return valid JSON (Response status ", O, " ", D, ")")));
    }
    var w = n(656),
      k = (n(876), n(386), function (e, t, r, n) {
        return new (r || (r = Promise))(function (i, o) {
          function a(e) {
            try {
              s(n.next(e));
            } catch (e) {
              o(e);
            }
          }
          function l(e) {
            try {
              s(n.throw(e));
            } catch (e) {
              o(e);
            }
          }
          function s(e) {
            var t;
            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
              e(t);
            })).then(a, l);
          }
          s((n = n.apply(e, t || [])).next());
        });
      });
    function C(r) {
      var n = this,
        i = r.activity,
        o = r.inboxUrl,
        a = r.onSubmit,
        l = r.onActivityChange,
        s = r.onInboxUrlChange,
        c = (0, e.useState)(null),
        u = c[0],
        f = c[1],
        h = (0, e.useState)(null),
        p = h[0],
        m = h[1],
        g = (0, e.useState)(null),
        v = g[0],
        y = g[1],
        b = (0, e.useState)(null),
        x = b[0],
        C = b[1],
        S = (0, e.useState)(!1),
        T = S[0],
        L = S[1];
      return t().createElement("div", {
        className: "h-full m-2 dark:text-white flex flex-col"
      }, t().createElement("div", null, t().createElement("div", {
        className: "my-1 ".concat(null != v ? "dark:text-red-400 text-red-700" : "")
      }, t().createElement("span", {
        className: "font-medium"
      }, "Inbox url"), v && t().createElement("span", {
        className: "pl-2"
      }, v)), t().createElement("input", {
        className: ["w-full", "box-border", "p-2.5", "rounded", "outline-none", "border-solid", "text-base", "leading-[18px]", null != v ? "dark:border-red-400 border-red-700" : "border-mastodon-gray-500 dark:border-mastodon-gray-800", "dark:bg-mastodon-gray-900", "bg-mastodon-gray-300", "dark:text-mastodon-gray-500", "text-mastodon-gray-900", "placeholder:text-mastodon-gray-600", "dark:placeholder:text-mastodon-gray-600", "placeholder:italic"].join(" "),
        type: "text",
        spellCheck: "false",
        autoComplete: "off",
        placeholder: "For example https://activitypub.academy/users/alice/inbox",
        value: o,
        onChange: function (e) {
          y(null), f(null), s(e.target.value);
        }
      })), t().createElement("div", {
        className: "my-2 flex flex-col h-full"
      }, t().createElement("div", {
        className: "my-1 ".concat(null != p ? "dark:text-red-400 text-red-700" : "")
      }, t().createElement("span", {
        className: "font-medium"
      }, "Activity"), p && t().createElement("span", {
        className: "pl-2"
      }, p)), t().createElement(w.fk, {
        className: ["box-border", "min-h-[24rem]", "h-full", "w-full", "overflow-auto", "rounded", "border", "border-solid", null != p ? "dark:border-red-400 border-red-700" : "border-mastodon-gray-500 dark:border-mastodon-gray-800"].join(" "),
        value: i,
        onBeforeChange: function (e, t, r) {
          m(null), f(null), C(null), l(r);
        },
        options: {
          mode: {
            name: "javascript",
            json: !0
          },
          extraKeys: {
            "Ctrl-Space": "autocomplete"
          },
          hintOptions: {
            completeSingle: !1
          },
          lineNumbers: !1,
          readOnly: !1,
          inputStyle: "textarea",
          autocorrect: !1,
          placeholder: 'Insert your activity JSON here. For example\n{\n  "@context":"https://www.w3.org/ns/activitystreams",\n  "id":"https://activitypub.academy/some-id",\n  "type":"Follow",\n  "actor":"https://activitypub.academy/users/bob",\n  "object":"https://activitypub.academy/users/alice"\n}\n'
        }
      })), t().createElement("div", {
        className: "my-4 flex flex-row items-center"
      }, t().createElement("button", {
        className: "font-[Roboto] text-base px-4 py-2 rounded bg-mastodon-primary text-white font-medium cursor-pointer disabled:bg-mastodon-gray-500 dark:disabled:bg-mastodon-gray-800 disabled:cursor-default border-0",
        onClick: function () {
          return k(n, void 0, void 0, function () {
            var e;
            return function (e, t) {
              var r,
                n,
                i,
                o,
                a = {
                  label: 0,
                  sent: function () {
                    if (1 & i[0]) throw i[1];
                    return i[1];
                  },
                  trys: [],
                  ops: []
                };
              return o = {
                next: l(0),
                throw: l(1),
                return: l(2)
              }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
                return this;
              }), o;
              function l(o) {
                return function (l) {
                  return function (o) {
                    if (r) throw new TypeError("Generator is already executing.");
                    for (; a;) try {
                      if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;
                      switch (n = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                        case 0:
                        case 1:
                          i = o;
                          break;
                        case 4:
                          return a.label++, {
                            value: o[1],
                            done: !1
                          };
                        case 5:
                          a.label++, n = o[1], o = [0];
                          continue;
                        case 7:
                          o = a.ops.pop(), a.trys.pop();
                          continue;
                        default:
                          if (!((i = (i = a.trys).length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                            a = 0;
                            continue;
                          }
                          if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                            a.label = o[1];
                            break;
                          }
                          if (6 === o[0] && a.label < i[1]) {
                            a.label = i[1], i = o;
                            break;
                          }
                          if (i && a.label < i[2]) {
                            a.label = i[2], a.ops.push(o);
                            break;
                          }
                          i[2] && a.ops.pop(), a.trys.pop();
                          continue;
                      }
                      o = t.call(e, a);
                    } catch (e) {
                      o = [6, e], n = 0;
                    } finally {
                      r = i = 0;
                    }
                    if (5 & o[0]) throw o[1];
                    return {
                      value: o[0] ? o[1] : void 0,
                      done: !0
                    };
                  }([o, l]);
                };
              }
            }(this, function (t) {
              switch (t.label) {
                case 0:
                  f(null), C(null);
                  try {
                    if ("https:" != (e = new URL(o)).protocol) throw new Error("protocol must be https, was ".concat(e.protocol));
                    if ("" == e.host) throw new Error("host must be specified, was ".concat(e.host));
                  } catch (e) {
                    return y("Must be a valid https URL"), [2];
                  }
                  try {
                    JSON.parse(i);
                  } catch (e) {
                    return m("Must be a valid JSON object"), [2];
                  }
                  t.label = 1;
                case 1:
                  return t.trys.push([1, 3,, 4]), L(!0), [4, a()];
                case 2:
                  return t.sent(), C("Activity added to outbound queue"), [3, 4];
                case 3:
                  return t.sent(), f("Failed to send. Please try again."), [3, 4];
                case 4:
                  return L(!1), [2];
              }
            });
          });
        },
        disabled: T
      }, t().createElement("div", {
        className: "h-[24px] w-[60px] flex flex-row items-center justify-center"
      }, T ? t().createElement(d, {
        small: !0,
        colorDefinition: "white"
      }) : "Publish!")), u && t().createElement("div", {
        className: "mx-4 dark:text-red-400 text-red-700"
      }, u), x && t().createElement("div", {
        className: "mx-4 dark:text-white"
      }, x)));
    }
    var S = function (e, t, r, n) {
        return new (r || (r = Promise))(function (i, o) {
          function a(e) {
            try {
              s(n.next(e));
            } catch (e) {
              o(e);
            }
          }
          function l(e) {
            try {
              s(n.throw(e));
            } catch (e) {
              o(e);
            }
          }
          function s(e) {
            var t;
            e.done ? i(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
              e(t);
            })).then(a, l);
          }
          s((n = n.apply(e, t || [])).next());
        });
      },
      T = function (e, t) {
        var r,
          n,
          i,
          o,
          a = {
            label: 0,
            sent: function () {
              if (1 & i[0]) throw i[1];
              return i[1];
            },
            trys: [],
            ops: []
          };
        return o = {
          next: l(0),
          throw: l(1),
          return: l(2)
        }, "function" == typeof Symbol && (o[Symbol.iterator] = function () {
          return this;
        }), o;
        function l(o) {
          return function (l) {
            return function (o) {
              if (r) throw new TypeError("Generator is already executing.");
              for (; a;) try {
                if (r = 1, n && (i = 2 & o[0] ? n.return : o[0] ? n.throw || ((i = n.return) && i.call(n), 0) : n.next) && !(i = i.call(n, o[1])).done) return i;
                switch (n = 0, i && (o = [2 & o[0], i.value]), o[0]) {
                  case 0:
                  case 1:
                    i = o;
                    break;
                  case 4:
                    return a.label++, {
                      value: o[1],
                      done: !1
                    };
                  case 5:
                    a.label++, n = o[1], o = [0];
                    continue;
                  case 7:
                    o = a.ops.pop(), a.trys.pop();
                    continue;
                  default:
                    if (!((i = (i = a.trys).length > 0 && i[i.length - 1]) || 6 !== o[0] && 2 !== o[0])) {
                      a = 0;
                      continue;
                    }
                    if (3 === o[0] && (!i || o[1] > i[0] && o[1] < i[3])) {
                      a.label = o[1];
                      break;
                    }
                    if (6 === o[0] && a.label < i[1]) {
                      a.label = i[1], i = o;
                      break;
                    }
                    if (i && a.label < i[2]) {
                      a.label = i[2], a.ops.push(o);
                      break;
                    }
                    i[2] && a.ops.pop(), a.trys.pop();
                    continue;
                }
                o = t.call(e, a);
              } catch (e) {
                o = [6, e], n = 0;
              } finally {
                r = i = 0;
              }
              if (5 & o[0]) throw o[1];
              return {
                value: o[0] ? o[1] : void 0,
                done: !0
              };
            }([o, l]);
          };
        }
      };
    function L(r) {
      var n = this,
        i = r.onSubmit,
        o = r.loadData,
        a = (0, e.useState)(null),
        l = a[0],
        s = a[1],
        c = (0, e.useState)(null),
        u = c[0],
        f = c[1],
        h = (0, e.useState)(null),
        p = h[0],
        m = h[1],
        g = (0, e.useState)(!1),
        v = g[0],
        y = g[1],
        b = (0, e.useState)(!1),
        x = b[0],
        k = b[1],
        C = (0, e.useState)(""),
        L = C[0],
        N = C[1];
      return (0, e.useEffect)(function () {
        S(n, void 0, void 0, function () {
          var e;
          return T(this, function (t) {
            switch (t.label) {
              case 0:
                y(!0), t.label = 1;
              case 1:
                return t.trys.push([1, 3, 4, 5]), e = N, [4, o()];
              case 2:
                return e.apply(void 0, [t.sent()]), [3, 5];
              case 3:
                return t.sent(), m("Failed to load. Please reload the page."), [3, 5];
              case 4:
                return y(!1), [7];
              case 5:
                return [2];
            }
          });
        });
      }, []), t().createElement(t().Fragment, null, v ? t().createElement(d, null) : null != p ? t().createElement("div", {
        className: "h-full m-2 dark:text-red-400 text-red-700 flex flex-col"
      }, p) : t().createElement("div", {
        className: "h-full m-2 dark:text-white flex flex-col"
      }, t().createElement("div", {
        className: "my-2 flex flex-col h-full"
      }, t().createElement("div", {
        className: "my-1"
      }, t().createElement("span", {
        className: "font-medium"
      }, "WebFinger response")), t().createElement(w.fk, {
        className: ["box-border", "min-h-[24rem]", "h-full", "w-full", "overflow-auto", "rounded", "border", "border-solid", "border-mastodon-gray-500 dark:border-mastodon-gray-800"].join(" "),
        value: L,
        onBeforeChange: function (e, t, r) {
          N(r), s(null), f(null);
        },
        options: {
          mode: {
            name: "javascript",
            json: !0
          },
          extraKeys: {
            "Ctrl-Space": "autocomplete"
          },
          hintOptions: {
            completeSingle: !1
          },
          lineNumbers: !1,
          readOnly: !1,
          inputStyle: "textarea",
          autocorrect: !1,
          placeholder: "Insert the WebFinger response here."
        }
      })), t().createElement("div", {
        className: "my-4 flex flex-row items-center"
      }, t().createElement("button", {
        className: "font-[Roboto] text-base px-4 py-2 rounded bg-mastodon-primary text-white font-medium cursor-pointer disabled:bg-mastodon-gray-500 dark:disabled:bg-mastodon-gray-800 disabled:cursor-default border-0",
        onClick: function () {
          return S(n, void 0, void 0, function () {
            return T(this, function (e) {
              switch (e.label) {
                case 0:
                  s(null), f(null);
                  try {
                    JSON.parse(L);
                  } catch (e) {
                    return s("Value must be a valid JSON object"), [2];
                  }
                  e.label = 1;
                case 1:
                  return e.trys.push([1, 3,, 4]), k(!0), [4, i(L)];
                case 2:
                  return e.sent(), f("Saved successfully"), [3, 4];
                case 3:
                  return e.sent(), s("Failed to save. Please try again."), [3, 4];
                case 4:
                  return k(!1), [2];
              }
            });
          });
        },
        disabled: x
      }, t().createElement("div", {
        className: "h-[24px] w-[60px] flex flex-row items-center justify-center"
      }, x ? t().createElement(d, {
        small: !0,
        colorDefinition: "white"
      }) : "Save")), l && t().createElement("div", {
        className: "mx-4 dark:text-red-400 text-red-700"
      }, l), u && t().createElement("div", {
        className: "mx-4 dark:text-white"
      }, u))));
    }
  })(), i;
})());